webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_user__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_common__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_devedor__ = __webpack_require__(372);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__store_user__["a" /* default */],
    common: __WEBPACK_IMPORTED_MODULE_3__store_common__["a" /* default */],
    devedor: __WEBPACK_IMPORTED_MODULE_4__store_devedor__["a" /* default */]
  },

  state: {
    world: 'world'
  },

  actions: {},

  mutations: {},

  getters: {}
}));

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(4);





var config = {
  baseURL: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.server
};
var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create(config);

/* harmony default export */ __webpack_exports__["a"] = ({
  getUsuarios: function getUsuarios() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/users/getall", headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getUsuariosId: function getUsuariosId(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.get("/users/getallid/" + id, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  getFuncionarios: function getFuncionarios() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.get("/users/getFuncionarios", headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  getLogs: function getLogs() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return instance.get('/logs/get');

            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 7]]);
    }))();
  },
  getUsuario: function getUsuario(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context5.next = 4;
              return instance.get("/users/id/" + id, headers);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);

              console.log(_context5.t0.response);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context5.t0.response.data.message);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 8]]);
    }))();
  },
  saveUsuario: function saveUsuario(user) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context6.next = 4;
              return instance.post("/users/register", {
                name: user.name,
                email: user.username,
                password: user.senha,
                acesso: user.acesso,
                cliente: user.cliente,
                devedor: user.devedor
              }, headers);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);

              console.log(_context6.t0.response);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context6.t0.response.data.message);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 8]]);
    }))();
  },
  saveUsuarioDevedor: function saveUsuarioDevedor(user) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return instance.post("/users/registerDevedor", {
                name: user.name,
                email: user.username,
                password: user.senha,
                acesso: user.acesso,
                cliente: user.cliente,
                devedor: user.devedor
              });

            case 3:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](0);

              console.log(_context7.t0);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context7.t0.response.data.message);

            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 7]]);
    }))();
  },
  saveUsuarioSenha: function saveUsuarioSenha(user) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context8.next = 4;
              return instance.post("/users/pass", {
                id: user._id,
                name: user.name,
                email: user.username,
                password: user.senha,
                acesso: user.acesso,
                cliente: user.cliente,
                devedor: user.devedor
              }, headers);

            case 4:
              response = _context8.sent;
              return _context8.abrupt("return", response.data);

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](0);

              console.log(_context8.t0.response);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context8.t0.response.data.message);

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 8]]);
    }))();
  },
  alterarUsuario: function alterarUsuario(id, user) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context9.next = 4;
              return instance.put("/users/alterar/" + id, user, headers);

            case 4:
              response = _context9.sent;
              return _context9.abrupt("return", response.data);

            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](0);

              console.log(_context9.t0.response);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context9.t0.response.data.message);

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[0, 8]]);
    }))();
  },
  deleteUser: function deleteUser(id) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context10.next = 4;
              return instance.delete("/users/remove/" + id, headers);

            case 4:
              response = _context10.sent;
              return _context10.abrupt("return", response.data);

            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10["catch"](0);

              console.log(_context10.t0.response);
              __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setError', _context10.t0.response.data.message);

            case 12:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getDevedoreId: function getDevedoreId(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/devedores/get/" + id, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getDevedoreIdDev: function getDevedoreIdDev(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.get("/devedores/getDev/" + id, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  getSearch: function getSearch(search) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.get("/devedores/getSearch/" + search, headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  getSearchCPF: function getSearchCPF(search) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return instance.get("/devedores/getSearchCPF/" + search);

            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0);
              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 7]]);
    }))();
  },
  getDevedores: function getDevedores() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context5.next = 4;
              return instance.get("/devedores/get", headers);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);

              console.log(_context5.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context5.t0.response.data.message);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 8]]);
    }))();
  },
  getPagination: function getPagination(params) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context6.next = 4;
              return instance.post("/devedores/getPagination", params, headers);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);

              console.log(_context6.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context6.t0.response.data.message);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 8]]);
    }))();
  },
  save: function save(model) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context7.next = 4;
              return instance.post("/devedores/save", model, headers);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);

              console.log(_context7.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context7.t0.response.data.message);

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context8.next = 4;
              return instance.delete("/devedores/" + item._id, headers);

            case 4:
              response = _context8.sent;
              return _context8.abrupt("return", response.data);

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](0);

              console.log(_context8.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context8.t0.response.data.message);

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/acordo/get", headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getFinanc: function getFinanc(model) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.post("/acordo/getFinanc", model, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  getGraph: function getGraph(model) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.post("/acordo/getGraph", model, headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  getParcelas: function getParcelas(model) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context4.next = 4;
              return instance.post("/acordo/getParcelas", model, headers);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  },
  getId: function getId(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context5.next = 4;
              return instance.get("/acordo/get/" + id, headers);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);

              console.log(_context5.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context5.t0.response.data.message);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 8]]);
    }))();
  },
  getDevedor: function getDevedor(user) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context6.next = 4;
              return instance.get("/acordo/getDevedor/" + user, headers);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);

              console.log(_context6.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context6.t0.response.data.message);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 8]]);
    }))();
  },
  save: function save(model) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context7.next = 4;
              return instance.post("/acordo/save", model, headers);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);

              console.log(_context7.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context7.t0.response.data.message);

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context8.next = 4;
              return instance.delete("/acordo/" + item._id + "/" + item.devedor, headers);

            case 4:
              response = _context8.sent;
              return _context8.abrupt("return", response.data);

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](0);

              console.log(_context8.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context8.t0.response.data.message);

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getClienteId: function getClienteId(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/clientes/get/" + id, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(err.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', err.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getClientes: function getClientes() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.get("/clientes/get", headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  getClientesValores: function getClientesValores(model) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.post("/clientes/getValores", model, headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  save: function save(model) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context4.next = 4;
              return instance.post("/clientes/save", model, headers);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  },
  bloquear: function bloquear(model) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context5.next = 4;
              return instance.post("/clientes/bloquear", model, headers);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);

              console.log(_context5.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context5.t0.response.data.message);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context6.next = 4;
              return instance.delete("/clientes/" + item._id, headers);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);

              console.log(_context6.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context6.t0.response.data.message);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(4);





var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getCep: function getCep(cep) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return instance.get("/correio/get/" + cep);

            case 3:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  getPreco: function getPreco(cep) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return instance.get("/correio/getpreco/" + cep);

            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 7]]);
    }))();
  },
  getTrack: function getTrack(cep) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return instance.get("/correio/gettrack/" + cep);

            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  }
});

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);





var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/juno/" + id, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  createCharge: function createCharge(model) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.post("/juno/createCharge", model, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  createFaturaIugu: function createFaturaIugu(model) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.post("/iugu/createFatura", model, headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  gerarBoletoBB: function gerarBoletoBB(model) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context4.next = 4;
              return instance.post("/iugu/gerarBoletoBB", model, headers);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  },
  buscarBoletosBB: function buscarBoletosBB(model) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context5.next = 4;
              return instance.post("/iugu/buscarBoletosBB", model, headers);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);

              console.log(_context5.t0);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context5.t0.response.data);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 8]]);
    }))();
  },
  imprimirBoletosBB: function imprimirBoletosBB(model) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context6.next = 4;
              return instance.post("/iugu/imprimirBoletosBB", model, headers);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);

              console.log(_context6.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context6.t0.response.data);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 8]]);
    }))();
  },
  pagarParcela: function pagarParcela(model) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context7.next = 4;
              return instance.post("/juno/pagarParcela", model, headers);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);

              console.log(_context7.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context7.t0.response.data.message);

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getId: function getId(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return instance.get("/empresas/get/" + id);

            case 3:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  getAll: function getAll() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return instance.get("/empresas/getAll");

            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 7]]);
    }))();
  },
  save: function save(model) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return instance.post("/empresas/save", model);

            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },
  saveImage: function saveImage(model) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var config, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              config = { headers: { 'Content-Type': 'multipart/form-data' } };
              _context4.next = 4;
              return instance.post("/empresas/saveImage", model, config);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return instance.delete("/empresas/" + item._id);

            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);

              console.log(_context5.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context5.t0.response.data.message);

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 7]]);
    }))();
  },
  removeImage: function removeImage(item, empresa) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return instance.delete("/empresas/removeImage/" + item._id + '/' + empresa);

            case 3:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);

              console.log(_context6.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context6.t0.response.data.message);

            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 7]]);
    }))();
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getId: function getId(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/agendas/get/" + id, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getNotifUser: function getNotifUser(user) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.get("/agendas/getNotifUser/" + user, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  getUser: function getUser(user, data) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.get("/agendas/getUser/" + user + "/" + data, headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  getAgendasUser: function getAgendasUser(model) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context4.next = 4;
              return instance.post("/agendas/getUser", model, headers);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  },
  save: function save(model) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context5.next = 4;
              return instance.post("/agendas/save", model, headers);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);

              console.log(_context5.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context5.t0.response.data.message);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 8]]);
    }))();
  },
  saveNotific: function saveNotific(model) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context6.next = 4;
              return instance.post("/agendas/saveNotific", model, headers);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);

              console.log(_context6.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context6.t0.response.data.message);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context7.next = 4;
              return instance.delete("/agendas/" + item._id, headers);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);

              console.log(_context7.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context7.t0.response.data.message);

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getDividaId: function getDividaId(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/dividas/get/" + id, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getDividaDevedor: function getDividaDevedor(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.get("/dividas/getdevedor/" + id, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  getDividasAll: function getDividasAll() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.get("/dividas/getAll", headers);

            case 4:
              response = _context3.sent;


              response.data.forEach(function (element) {
                element.ValorDivida = element.ValorDivida ? element.ValorDivida.toFixed(2) : 0.00;
                element.ValorEmpresa = element.ValorEmpresa ? element.ValorEmpresa.toFixed(2) : 0.00;
              });
              return _context3.abrupt("return", response.data);

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 9]]);
    }))();
  },
  getDividas: function getDividas(model) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context4.next = 4;
              return instance.post("/dividas/get", model, headers);

            case 4:
              response = _context4.sent;


              response.data.forEach(function (element) {
                element.ValorDivida = element.ValorDivida ? element.ValorDivida.toFixed(2) : 0.00;
                element.ValorEmpresa = element.ValorEmpresa ? element.ValorEmpresa.toFixed(2) : 0.00;
              });
              return _context4.abrupt("return", response.data);

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 9]]);
    }))();
  },
  getDividas2: function getDividas2(model) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context5.next = 4;
              return instance.post("/dividas/gett", model, headers);

            case 4:
              response = _context5.sent;


              response.data.forEach(function (element) {
                element.ValorDivida = element.ValorDivida ? element.ValorDivida.toFixed(2) : 0.00;
                element.ValorEmpresa = element.ValorEmpresa ? element.ValorEmpresa.toFixed(2) : 0.00;
              });
              return _context5.abrupt("return", response.data);

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);

              console.log(_context5.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context5.t0.response.data.message);

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 9]]);
    }))();
  },
  save: function save(model) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context6.next = 4;
              return instance.post("/dividas/save", model, headers);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);

              console.log(_context6.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context6.t0.response.data.message);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 8]]);
    }))();
  },
  saveStatus: function saveStatus(model) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context7.next = 4;
              return instance.post("/dividas/saveStatus", model, headers);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);

              console.log(_context7.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context7.t0.response.data.message);

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 8]]);
    }))();
  },
  saveDividaImage: function saveDividaImage(model) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              headers = { headers: { 'Content-Type': 'multipart/form-data', "x-access-token": localStorage.getItem("cobranca-token") } };
              _context8.next = 4;
              return instance.post("/dividas/saveImage", model, headers);

            case 4:
              response = _context8.sent;
              return _context8.abrupt("return", response.data);

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](0);

              console.log(_context8.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context8.t0.response.data.message);

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context9.next = 4;
              return instance.delete("/dividas/" + item._id, headers);

            case 4:
              response = _context9.sent;
              return _context9.abrupt("return", response.data);

            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](0);

              console.log(_context9.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context9.t0.response.data.message);

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[0, 8]]);
    }))();
  },
  removeDividaImage: function removeDividaImage(item, divida) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context10.next = 4;
              return instance.delete("/dividas/removeImage/" + item._id + '/' + divida, headers);

            case 4:
              response = _context10.sent;
              return _context10.abrupt("return", response.data);

            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10["catch"](0);

              console.log(_context10.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context10.t0.response.data.message);

            case 12:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getId: function getId(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/enderecodeve/get/" + id, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getDevedor: function getDevedor(user) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.get("/enderecodeve/getDevedor/" + user, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  save: function save(model) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.post("/enderecodeve/save", model, headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context4.next = 4;
              return instance.delete("/enderecodeve/" + item._id + "/" + item.devedor, headers);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getId: function getId(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/telefonedeve/get/" + id, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getDevedor: function getDevedor(user) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.get("/telefonedeve/getDevedor/" + user, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  save: function save(model) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.post("/telefonedeve/save", model, headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context4.next = 4;
              return instance.delete("/telefonedeve/" + item._id + "/" + item.devedor, headers);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___ = __webpack_require__(206);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_AppAlert__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_usuario__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppAlert: __WEBPACK_IMPORTED_MODULE_4__components_shared_AppAlert__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */]
  },
  data: function data() {
    return {
      title: 'Vuetify.js',
      scrolled: false,
      dialogError: false,
      menu: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    errorTest: function errorTest() {
      this.dialogError = false;
      this.$store.dispatch('clearError');
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    },
    handleScroll: function handleScroll() {
      if (this.$store.getters.user) {
        this.scrolled = true;
      } else {
        this.scrolled = window.scrollY > 0;
      }
    },
    getLetter: function getLetter(name) {
      return name.substring(0, 1) + name.substring(name.lastIndexOf("+") + 1, name.lastIndexOf("+") + 2);
    },
    logout: function logout() {
      this.menu = false;
      this.$router.push('/logout');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setDrawerRight: "setDrawerRight",
    setDrawer: "setDrawer"
  })),
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
    localStorage.setItem('themeCache', true);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  computed: {
    error: function error() {
      if (this.$store.getters.error) {
        this.dialogError = true;
      } else {
        this.dialogError = false;
      }
      return this.$store.getters.error;
    },
    isLoggin: function isLoggin() {
      if (this.$store.getters.user) {
        return true;
      } else {
        return false;
      }
    },
    user: function user() {
      return this.$store.getters.user;
    },
    isDesconto: function isDesconto() {
      return this.$store.getters.desconto;
    },
    isUser: function isUser() {
      if (!this.$store.getters.user) {
        return false;
      } else {
        __WEBPACK_IMPORTED_MODULE_7__services_usuario__["a" /* default */].getUsuario(this.$store.getters.user._id).then(function (res) {
          if (res != null && res.grand == "Cliente") {
            return false;
          } else {
            return true;
          }
        });
      }
    },
    drawerRight: function drawerRight() {
      return this.$store.getters.drawerRight;
    },
    drawer: function drawer() {
      return this.$store.getters.drawer;
    }
  },
  asyncComputed: {
    user: function user() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user._id);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 6:
                return _context.abrupt('return', {});

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_script_lang_js___ = __webpack_require__(222);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_empresa__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_agendas__ = __webpack_require__(63);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Header",
  data: function data() {
    return {
      name: "Header",
      title: 'Vuetify.js',
      scrolled: false,
      dialogError: false,
      menu: false,
      user: {},
      search: "",
      empresa: {},
      dialogNotif: false,
      agendaNotif: {}
    };
  },

  // sockets : {
  //   connect: function(){
  //     console.log('socket connected');
  //   },
  //   notific: function(val){
  //     if (val.user1 == this.user._id || val.user2 == this.user._id) {
  //       this.$store.dispatch("SET_USUARIOS", this.user);
  //       var audio = new Audio('/static/img/guess-what.mp3');
  //       audio.play();
  //     }
  //   }
  // },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.menu = false;

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var theme;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              theme = localStorage.getItem("themeCache");

              if (theme) {
                if (theme == "true") {
                  _this2.$vuetify.theme.dark = true;
                } else _this2.$vuetify.theme.dark = false;
              }
              if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user) {
                _this2.$store.dispatch("SET_USUARIOS", _this2.user);
              }

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },


  watch: {
    '$route': function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var agendaNotif;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user._id);

              case 3:
                this.user = _context3.sent;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__services_empresa__["a" /* default */].getId(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user.empresa);

              case 6:
                this.empresa = _context3.sent;
                _context3.next = 9;
                return __WEBPACK_IMPORTED_MODULE_6__services_agendas__["a" /* default */].getNotifUser(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user._id);

              case 9:
                agendaNotif = _context3.sent;

                if (agendaNotif && agendaNotif.length > 0) {
                  this.dialogNotif = true;
                  this.agendaNotif = agendaNotif[0];
                }

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function $route() {
        return _ref.apply(this, arguments);
      }

      return $route;
    }()
  },
  computed: {
    // Set your username thanks to your getter
    isLoggin: function isLoggin() {
      return this.$store.getters.user ? true : false;
    },
    username: function username() {
      return this.$store.getters["username"];
    },
    isDesconto: function isDesconto() {
      return this.$store.getters.desconto;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    drawer: function drawer() {
      return this.$store.getters.drawer;
    },
    usuarios: function usuarios() {
      return this.$store.getters.usuarios;
    },
    drawerRight: function drawerRight() {
      return this.$store.getters.drawerRight;
    }
  },
  asyncComputed: {
    isUser: function isUser() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this3.$store.getters.user) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", false);

              case 4:
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4__services_usuario__["a" /* default */].getUsuario(_this3.$store.getters.user._id);

              case 6:
                res = _context4.sent;

                if (!(res != null && res.grand == "Funcionario")) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", false);

              case 11:
                return _context4.abrupt("return", true);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    items: function items() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var items, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                items = [];

                if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user._id);

              case 4:
                res = _context5.sent;

                if (res != null && res.acesso == "Devedor") {
                  items = [{ icon: "money", text: "Minhas Dividas", link: "minhas-dividas" }];
                } else if (res != null && res.acesso == "Funcionario") {
                  items = [{ icon: "money", text: "Cobrança", link: "/funcionario/cobranca" }, { icon: "schedule", text: "Agenda", link: "/funcionario/agenda" }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Recebimento",
                    children: [{ icon: "highlight", text: "Vigente", link: "/recebimentos/4" }, { icon: "money", text: "Recebido", link: "/recebimentos/2" }, { icon: "money_off", text: "Atraso", link: "/recebimentos/3" }, { icon: "delete", text: "Cancelado", link: "/recebimentos/9" }]
                  }];
                } else if (res != null && res.acesso == "Financeiro") {
                  items = [{
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Configurações",
                    children: [{ icon: "business", text: "Clientes", link: "/clientes" }, { icon: "money", text: "Cobrança", link: "/funcionario/cobranca" }, { icon: "money_off", text: "Dividas", link: "/dividas" }, { icon: "schedule", text: "Agenda", link: "/funcionario/agenda" }]
                  }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Movimentações",
                    children: [{ icon: "monetization_on", text: "Financeiro", link: "/financeiro" }, { icon: "monetization_on", text: "Boleto BB", link: "/boletosbb" }]
                  }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Recebimento",
                    children: [{ icon: "highlight", text: "Vigente", link: "/recebimentos/4" }, { icon: "money", text: "Recebido", link: "/recebimentos/2" }, { icon: "money_off", text: "Atraso", link: "/recebimentos/3" }, { icon: "delete", text: "Cancelado", link: "/recebimentos/9" }]
                  }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Relatório",
                    children: [{ icon: "bar_chart", text: "Dividas", link: "/rel-dividas" }]
                  }];
                } else if (res != null && res.acesso == "Advogado") {
                  items = [{ icon: "money", text: "Cobrança", link: "/funcionario/cobranca" }, { icon: "money_off", text: "Dividas", link: "/dividas" }];
                } else if (res != null && res.acesso == "Cadastradores") {
                  items = [{ icon: "business", text: "Clientes", link: "/clientes" }, { icon: "people", text: "Devedores", link: "/devedores" }, { icon: "money", text: "Cobrança", link: "/funcionario/cobranca" }, { icon: "money_off", text: "Dividas", link: "/dividas" }];
                } else if (res != null && res.acesso == "AdminClientes") {
                  items = [{ icon: "dashboard", text: "Painel", link: "/painel" }, { icon: "money_off", text: "Dividas", link: "/dividas" }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Recebimento",
                    children: [{ icon: "highlight", text: "Vigente", link: "/recebimentos/4" }, { icon: "money", text: "Recebido", link: "/recebimentos/2" }, { icon: "money_off", text: "Atraso", link: "/recebimentos/3" }, { icon: "delete", text: "Cancelado", link: "/recebimentos/9" }]
                    //{ icon: "dashboard", text: "Fechamento", link: "/fechamento" },
                  }];
                } else if (res != null && res.acesso == "Cliente") {
                  items = [{ icon: "dashboard", text: "Painel", link: "/painel" }, { icon: "money_off", text: "Dividas", link: "/dividas" }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Recebimento",
                    children: [{ icon: "highlight", text: "Vigente", link: "/recebimentos/4" }, { icon: "money", text: "Recebido", link: "/recebimentos/2" }, { icon: "money_off", text: "Atraso", link: "/recebimentos/3" }, { icon: "delete", text: "Cancelado", link: "/recebimentos/9" }]
                    //{ icon: "dashboard", text: "Fechamento", link: "/fechamento" },
                  }];
                } else if (res != null && res.grand == "Geral") {
                  items = [{ icon: "dashboard", text: "Painel", link: "/painel" }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Configurações",
                    children: [{ icon: "perm_contact_calendar", text: "Usuários", link: "/usuarios" }, { icon: "business", text: "Empresas", link: "/empresas" }, { icon: "business", text: "Clientes", link: "/clientes" }, { icon: "people", text: "Devedores", link: "/devedores" }, { icon: "money_off", text: "Dividas", link: "/dividas" }]
                  }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Movimentação",
                    children: [{ icon: "money", text: "Cobrança", link: "/funcionario/cobranca" }, { icon: "schedule", text: "Agenda", link: "/funcionario/agenda" }, { icon: "monetization_on", text: "Financeiro", link: "/financeiro" }, { icon: "monetization_on", text: "Boleto BB", link: "/boletosbb" }]
                  }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Recebimento",
                    children: [{ icon: "highlight", text: "Vigente", link: "/recebimentos/4" }, { icon: "money", text: "Recebido", link: "/recebimentos/2" }, { icon: "money_off", text: "Atraso", link: "/recebimentos/3" }, { icon: "delete", text: "Cancelado", link: "/recebimentos/9" }]
                  }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Relatório",
                    children: [{ icon: "bar_chart", text: "Dividas", link: "/rel-dividas" }]
                  }, { icon: "dashboard", text: "Fechamento", link: "/fechamento" }];
                } else {
                  items = [{ icon: "dashboard", text: "Painel", link: "/painel" }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Configurações",
                    children: [{ icon: "perm_contact_calendar", text: "Usuários", link: "/usuarios" }, { icon: "business", text: "Clientes", link: "/clientes" }, { icon: "people", text: "Devedores", link: "/devedores" }, { icon: "money_off", text: "Dividas", link: "/dividas" }]
                  }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Movimentações",
                    children: [{ icon: "money", text: "Cobrança", link: "/funcionario/cobranca" }, { icon: "schedule", text: "Agenda", link: "/funcionario/agenda" }, { icon: "monetization_on", text: "Financeiro", link: "/financeiro" }, { icon: "monetization_on", text: "Boleto BB", link: "/boletosbb" }]
                  }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Recebimento",
                    children: [{ icon: "highlight", text: "Vigente", link: "/recebimentos/4" }, { icon: "money", text: "Recebido", link: "/recebimentos/2" }, { icon: "money_off", text: "Atraso", link: "/recebimentos/3" }, { icon: "delete", text: "Cancelado", link: "/recebimentos/9" }]
                  }, {
                    icon: "keyboard_arrow_up",
                    "icon-alt": "keyboard_arrow_down",
                    text: "Relatório",
                    children: [{ icon: "bar_chart", text: "Dividas", link: "/rel-dividas" }]
                  }, { icon: "dashboard", text: "Fechamento", link: "/fechamento" }];
                }

              case 6:
                return _context5.abrupt("return", items);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    menus: function menus() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var menus;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                menus = [{
                  icon: 'home',
                  title: 'Registrar',
                  to: '/signup'
                }, {
                  icon: 'label',
                  title: 'Entrar',
                  to: '/signin'
                }];

                if (_this5.$store.getters.user) {
                  menus = [{
                    icon: 'label',
                    title: 'Logout',
                    to: '/logout'
                  }];
                }
                return _context6.abrupt("return", menus);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    }
  },
  methods: {
    scrollFix: function scrollFix(hashbang) {
      if (hashbang) {
        location.href = hashbang;
      } else {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    filterItems: function filterItems(presets) {
      var app = this;
      if (app.search && app.search.length > 0) {
        return presets.filter(function (preset) {
          var regex = new RegExp('(' + app.search + ')', 'i');
          if (preset.text.match(regex)) {
            return preset.text.match(regex);
          } else {
            var retorno = [];
            if (preset.children && preset.children.length > 0) {

              preset.children.forEach(function (element) {
                if (element.text.match(regex)) {
                  retorno.push(element);
                }
              });
              return retorno;
            }
          }
        });
      } else {
        return presets;
      }
    },
    getPath: function getPath(usuario) {
      if (this.user) {
        var uid1 = this.user._id;
        var uid2 = usuario._id;
        var path = uid1 < uid2 ? uid1 + '/' + uid2 : uid2 + '/' + uid1;
        return '/chat/' + path;
      }
    },
    home: function home() {
      this.$router.push('/');
    },
    cobrarNotif: function cobrarNotif(item) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this6.dialogNotif = false;
                item.verificou = true;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_agendas__["a" /* default */].saveNotific(item);

              case 4:
                _this6.$router.push('/funcionario/cobranca/' + item.agenda.iddevedor._id);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    }
  }
});

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppAlert_vue_vue_type_script_lang_js___ = __webpack_require__(229);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AppAlert_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_lang_js___ = __webpack_require__(231);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_usuario__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      msg: 'Home',
      email: '',
      password: '',
      cards: {
        card1: "",
        card2: "",
        card3: ""
      }
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();
                _context.next = 3;
                return _this.$store.dispatch('signUserIn', { username: _this.email, password: _this.password });

              case 3:
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user._id);

              case 5:
                res = _context.sent;


                _this.$store.dispatch("SET_USUARIOS", res);

                if (!(res.acesso == "Cliente")) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return _this.$router.push('/recebimentos');

              case 10:
                _context.next = 24;
                break;

              case 12:
                if (!(res.acesso == "Admin")) {
                  _context.next = 17;
                  break;
                }

                _context.next = 15;
                return _this.$router.push('/painel');

              case 15:
                _context.next = 24;
                break;

              case 17:
                if (!(res.acesso == "AdminClientes")) {
                  _context.next = 22;
                  break;
                }

                _context.next = 20;
                return _this.$router.push('/painel');

              case 20:
                _context.next = 24;
                break;

              case 22:
                _context.next = 24;
                return _this.$router.push('/usuarios');

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  watch: {
    user: function user(value) {
      /*if (value !== null && value !== undefined) {
        this.$router.push('/')
      }*/
    }
  },
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Deve ser um e-mail válido');
      !this.$v.email.required && errors.push('Usuário deve ser informado');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Senha deve ser informada');
      return errors;
    }
  }
});

/***/ }),
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Devedor_vue_vue_type_script_lang_js___ = __webpack_require__(234);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Devedor_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_devedores__ = __webpack_require__(13);



//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      msg: 'Home',
      email: '',
      password: '',
      tipo: 'cpf',
      cpf: '',
      cnpj: '',
      telefone: '',
      mensagem: '',
      maskCPF: '###.###.###-##',
      maskCNPJ: '##.###.###/####-##',
      maskTelefone: '(##) #####-####',
      cards: {
        card1: "",
        card2: "",
        card3: ""
      },
      devedor: {}
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    entrar: function entrar() {
      this.$router.push('/');
    },
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!_this.$refs.form.validate()) {
                  _context.next = 34;
                  break;
                }

                _this.$v.$touch();

                if (!(_this.tipo == 'cpf' && !_this.cpf)) {
                  _context.next = 6;
                  break;
                }

                _this.setError('CPF deve ser informado!');
                return _context.abrupt('return');

              case 6:
                if (!(_this.tipo == 'cnpj' && !_this.cnpj)) {
                  _context.next = 9;
                  break;
                }

                _this.setError('CNPJ deve ser informado!');
                return _context.abrupt('return');

              case 9:
                if (!(!_this.devedor && !_this.devedor._id)) {
                  _context.next = 12;
                  break;
                }

                _this.setError('Você não tem dividas cadastradas!');
                return _context.abrupt('return');

              case 12:
                if (_this.email) {
                  _context.next = 15;
                  break;
                }

                _this.setError('Email não informado!');
                return _context.abrupt('return');

              case 15:
                if (_this.password) {
                  _context.next = 18;
                  break;
                }

                _this.setError('Senha não informada!');
                return _context.abrupt('return');

              case 18:

                _this.model = {
                  name: _this.devedor.Nome,
                  username: _this.email,
                  senha: _this.password,
                  devedor: _this.devedor._id,
                  acesso: "Devedor",
                  grand: "Devedor"
                };

                _context.next = 21;
                return __WEBPACK_IMPORTED_MODULE_7__services_usuario__["a" /* default */].saveUsuarioDevedor(_this.model);

              case 21:
                res = _context.sent;
                _context.next = 24;
                return _this.$store.dispatch('signUserIn', { username: _this.email, password: _this.password });

              case 24:
                _context.next = 26;
                return __WEBPACK_IMPORTED_MODULE_7__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user._id);

              case 26:
                res = _context.sent;

                if (!(res.grand == "Devedor")) {
                  _context.next = 32;
                  break;
                }

                _context.next = 30;
                return _this.$router.push('/minhas-dividas');

              case 30:
                _context.next = 34;
                break;

              case 32:
                _context.next = 34;
                return _this.$router.push('/minhas-dividas');

              case 34:
                _context.next = 39;
                break;

              case 36:
                _context.prev = 36;
                _context.t0 = _context['catch'](0);

                _this.setError(_context.t0);

              case 39:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 36]]);
      }))();
    },
    getSearch: function getSearch(search) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var devedores;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!search) {
                  _context2.next = 14;
                  break;
                }

                _this2.setLoading(true);
                _this2.devedor = {};
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__services_devedores__["a" /* default */].getSearchCPF(search);

              case 5:
                devedores = _context2.sent;

                if (!(devedores.length == 1)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 9;
                return __WEBPACK_IMPORTED_MODULE_8__services_devedores__["a" /* default */].getDevedoreIdDev(devedores[0]._id);

              case 9:
                _this2.devedor = _context2.sent;
                _context2.next = 13;
                break;

              case 12:
                _this2.mensagem = "Ops! " + _this2.tipo.toUpperCase() + " não localizado! Não localizamos o seu CPF/CNPJ em nossa base, entre em contato através dos nossos canais de atendimento para mais informações.";

              case 13:
                _this2.setLoading(false);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setError: "setError"
  })),
  watch: {
    user: function user(value) {
      /*if (value !== null && value !== undefined) {
        this.$router.push('/')
      }*/
    }
  },
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Deve ser um e-mail válido');
      !this.$v.email.required && errors.push('Usuário deve ser informado');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Senha deve ser informada');
      return errors;
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HelloWorld_vue_vue_type_script_lang_js___ = __webpack_require__(236);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_HelloWorld_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Hello ' + this.$store.state.world,
      model: {}
    };
  },

  methods: {
    saveProduct: function saveProduct() {
      productsRef.push(this.model);
      this.clear();
    },
    clear: function clear() {
      this.model = {};
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Cobranca_vue_vue_type_script_lang_js___ = __webpack_require__(238);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Cobranca_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_dividas__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_ocorrencias__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_enderecodeve__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_cobranca_Endereco__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_cobranca_Telefone__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_cobranca_Email__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_cobranca_Negociacao__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_cobranca_Acordos__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_string_mask__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_string_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_string_mask__);





var asyncForEach = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(array, callback) {
    var index;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            index = 0;

          case 1:
            if (!(index < array.length)) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return callback(array[index], index, array);

          case 4:
            index++;
            _context.next = 1;
            break;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function asyncForEach(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Endereco: __WEBPACK_IMPORTED_MODULE_11__pages_cobranca_Endereco__["a" /* default */],
    Telefone: __WEBPACK_IMPORTED_MODULE_12__pages_cobranca_Telefone__["a" /* default */],
    Email: __WEBPACK_IMPORTED_MODULE_13__pages_cobranca_Email__["a" /* default */],
    Negociacao: __WEBPACK_IMPORTED_MODULE_14__pages_cobranca_Negociacao__["a" /* default */],
    Acordos: __WEBPACK_IMPORTED_MODULE_15__pages_cobranca_Acordos__["a" /* default */]
  },
  name: 'Cobranca',
  data: function data() {
    return {
      model: {},
      message: "",
      search: "",
      tipoConsulta: 1,
      dialogDevedores: false,
      dialogOcorrencia: false,

      date2: new Date().toISOString().substr(0, 10),
      dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu2: false,
      modal2: false,

      user: {},
      devedores: [],
      active: 0,
      items: ['Negociando', 'Promessa de Acordo', 'Recado Formal', 'Recado com terceiro', 'Sem condições', 'Deslocalizado', 'Recusa', 'Falecido', 'Tentativa de Contato', 'Black List'],

      mask: '(##) #####-####',
      maskCPF: '###.###.###-##',
      maskCNPJ: '##.###.###/####-##',
      maskHora: '##:##',
      valid: true,
      headersOcorrencias: [{
        text: 'Data',
        align: 'left',
        sortable: true,
        value: 'createdAt'
      }, {
        text: 'Telefone',
        align: 'left',
        sortable: true,
        value: 'telefone'
      }, {
        text: 'Ação',
        align: 'left',
        sortable: true,
        value: 'status'
      }, {
        text: 'Sub Ação',
        align: 'left',
        sortable: true,
        value: 'subacao',
        width: '40%'
      }, {
        text: 'Retorno',
        align: 'left',
        sortable: true,
        value: 'data'
      }, {
        text: 'Hora',
        align: 'left',
        sortable: true,
        value: 'hora'
      }, {
        text: 'Operador',
        align: 'left',
        sortable: true,
        value: 'user.name'
      }],
      headersDividas: [{
        text: 'Contrato',
        align: 'left',
        sortable: true,
        value: 'Identificador'
      }, {
        text: 'Empresa',
        align: 'left',
        sortable: true,
        value: 'idcliente.Nome',
        width: '40%'
      }, {
        text: 'Valor Divida',
        align: 'left',
        sortable: true,
        value: 'ValorEmpresa'
      }, {
        text: 'Status',
        align: 'left',
        sortable: true,
        value: 'StatusDivida'
      }, {
        text: 'Ações',
        value: 'action'
      }],

      headersPdfs: [{
        text: 'Nome  Anexo',
        align: 'left',
        sortable: true,
        value: 'descricao'
      }],
      headers: [{
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'Nome'
      }, {
        text: 'CPF ou CNPJ',
        align: 'left',
        sortable: true,
        value: 'CnpjCpf'
      }, {
        text: 'Endereco',
        align: 'left',
        sortable: true,
        value: 'Endereco'
      }],

      subRules: [function (v) {
        return !!v || 'Sub Ação deve ser informado.';
      }, function (v) {
        return v && v.length >= 10 || 'Nome deve ser maior que 10 caracteres.';
      }],
      telefoneRules: [function (v) {
        return !!v || 'Telefone deve ser informado!';
      }, function (v) {
        return v && /^\([1-9]{2}\) [0-9]{5}\-[0-9]{4}$/.test(v) || 'Telefone inválido.';
      }]
    };
  },

  computed: {
    computedDateFormatted2: function computedDateFormatted2() {
      return this.formatDate(this.date2);
    },
    devedor: function devedor() {
      return this.$store.getters["devedor"];
    },
    acordo: function acordo() {
      return this.$store.getters["acordo"];
    },
    loading: function loading() {
      return this.$store.getters["loading"];
    }
  },

  watch: {
    date2: function date2(val) {
      this.dateFormatted2 = this.formatDate(this.date2);
      this.model.data = this.date2;
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var deve, cpf, formatterCPF, result, retorno, formatterCNPJ, _result, _retorno;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setLoading(true);
              _this.tipoConsulta = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_10__services_usuario__["a" /* default */].getUsuario(_this.$store.getters.user._id);

            case 4:
              _this.user = _context2.sent;

              _this.setDevedor({});

              if (!(_this.$route.params.id || _this.$route.query.cpf)) {
                _context2.next = 38;
                break;
              }

              _context2.next = 9;
              return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this.$route.params.id);

            case 9:
              deve = _context2.sent;

              if (deve) {
                _context2.next = 36;
                break;
              }

              cpf = "";

              if (_this.$route.query && _this.$route.query.cpf) {
                cpf = _this.$route.query.cpf.replace('.', '').replace('.', '').replace('.', '').replace('-', '').replace('/', '');
              } else {
                cpf = _this.$route.params.id;
              }
              if (cpf.length < 11) {
                cpf = cpf.padStart(11, '0');
              } else if (cpf.length > 11 && cpf.length < 14) {
                cpf = cpf.padStart(14, '0');
              }

              if (!(cpf.length == 11)) {
                _context2.next = 26;
                break;
              }

              formatterCPF = new __WEBPACK_IMPORTED_MODULE_17_string_mask___default.a(_this.maskCPF);
              result = formatterCPF.apply(cpf);
              _context2.next = 19;
              return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getSearch(result);

            case 19:
              retorno = _context2.sent;

              if (!(retorno.length > 0)) {
                _context2.next = 24;
                break;
              }

              _context2.next = 23;
              return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(retorno[0]._id);

            case 23:
              deve = _context2.sent;

            case 24:
              _context2.next = 36;
              break;

            case 26:
              if (!(cpf.length == 14)) {
                _context2.next = 36;
                break;
              }

              formatterCNPJ = new __WEBPACK_IMPORTED_MODULE_17_string_mask___default.a(_this.maskCNPJ);
              _result = formatterCNPJ.apply(cpf);
              _context2.next = 31;
              return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getSearch(_result);

            case 31:
              _retorno = _context2.sent;

              if (!(_retorno.length > 0)) {
                _context2.next = 36;
                break;
              }

              _context2.next = 35;
              return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_retorno[0]._id);

            case 35:
              deve = _context2.sent;

            case 36:

              _this.setDevedor(deve);
              if (_this.devedor.dividas && _this.devedor.dividas.length > 0) {
                _this.setAcordo(_this.devedor.dividas[0].acordo);
              } else {
                _this.setAcordo({});
              }

            case 38:
              _this.active = 0;
              _this.$forceUpdate();
              _this.setLoading(false);

            case 41:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
    },
    proximo: function proximo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.setLoading(true);
                _this2.setDevedor({});
                _this2.active = 0;
                _context3.t0 = _this2;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(-1);

              case 6:
                _context3.t1 = _context3.sent;

                _context3.t0.setDevedor.call(_context3.t0, _context3.t1);

                if (_this2.devedor.dividas && _this2.devedor.dividas.length > 0) {
                  _this2.setAcordo(_this2.devedor.dividas[0].acordo);
                } else {
                  _this2.setAcordo({});
                }
                _this2.setLoading(false);
                _this2.dialogDevedores = false;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    getSearch: function getSearch(search) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!search) {
                  _context4.next = 23;
                  break;
                }

                _this3.setLoading(true);
                search = encodeURIComponent(search);
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getSearch(search);

              case 5:
                _this3.devedores = _context4.sent;

                if (!(_this3.devedores && _this3.devedores.length > 1)) {
                  _context4.next = 10;
                  break;
                }

                _this3.dialogDevedores = true;
                _context4.next = 22;
                break;

              case 10:
                if (!(_this3.devedores.length == 0)) {
                  _context4.next = 14;
                  break;
                }

                _this3.setDevedor({});
                _context4.next = 22;
                break;

              case 14:

                _this3.setDevedor({});
                _this3.active = 0;
                _context4.t0 = _this3;
                _context4.next = 19;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this3.devedores[0]._id);

              case 19:
                _context4.t1 = _context4.sent;

                _context4.t0.setDevedor.call(_context4.t0, _context4.t1);

                if (_this3.devedor.dividas && _this3.devedor.dividas.length > 0) {
                  _this3.setAcordo(_this3.devedor.dividas[0].acordo);
                } else {
                  _this3.setAcordo({});
                }

                //this.setDevedor(this.devedores[0]);

              case 22:
                _this3.setLoading(false);

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    getStatusAcordo: function getStatusAcordo(divida) {
      if (divida && divida.ValorRepasse === 0) {
        return 'Quitado';
      }
      if (divida.StatusDivida == 1) {
        return 'Processo Cobrança';
      } else if (divida.StatusDivida == 2) {
        return 'Aguardando Aprovação';
      } else if (divida.StatusDivida == 3) {
        return 'Acordo Vigente';
      } else if (divida.StatusDivida == 4) {
        return 'Acordo em Atraso';
      } else if (divida.StatusDivida == 5) {
        return 'Divida Bloqueada';
      } else if (divida.StatusDivida == 6) {
        return 'Deslocalizado';
      } else if (divida.StatusDivida == 8) {
        return 'Bloqueado';
      }
    },
    getColor: function getColor(status) {
      if (status == "Falecido" || status == 'Black List') {
        return 'black white--text';
      } else if (status == "Pagamento de Parcela") {
        return 'pink lighten-4 black--text';
      } else {
        return 'green lighten-2 black--text';
      }
    },
    getColorDivida: function getColorDivida(divida) {
      if (divida && divida.ValorRepasse === 0) {
        return 'pink lighten-4 black--text';
      }
    },
    novaOcorrencia: function novaOcorrencia(devedor) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.model = { devedor: devedor._id };
                _this4.model.data = _this4.date2;
                _this4.dialogOcorrencia = true;

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    bloquearDevedor: function bloquearDevedor(devedor) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var dev;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this5.user.acesso == 'Admin' || _this5.user.acesso == 'Advogado')) {
                  _context6.next = 14;
                  break;
                }

                _this5.setLoading(true);
                devedor.IsAtivo = !devedor.IsAtivo;
                _context6.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].save(devedor);

              case 5:
                dev = _context6.sent;
                _context6.t0 = _this5;
                _context6.next = 9;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(devedor._id);

              case 9:
                _context6.t1 = _context6.sent;

                _context6.t0.setDevedor.call(_context6.t0, _context6.t1);

                if (_this5.devedor.dividas && _this5.devedor.dividas.length > 0) {
                  _this5.setAcordo(_this5.devedor.dividas[0].acordo);
                } else {
                  _this5.setAcordo({});
                }
                _this5.active = 0;
                _this5.setLoading(false);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    bloquearDivida: function bloquearDivida(divida) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var dev;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this6.user.acesso == 'Admin' || _this6.user.acesso == 'Advogado')) {
                  _context7.next = 14;
                  break;
                }

                _this6.setLoading(true);
                divida.IsBloqueado = !divida.IsBloqueado;
                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7__services_dividas__["a" /* default */].saveStatus(divida);

              case 5:
                dev = _context7.sent;
                _context7.t0 = _this6;
                _context7.next = 9;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this6.devedor._id);

              case 9:
                _context7.t1 = _context7.sent;

                _context7.t0.setDevedor.call(_context7.t0, _context7.t1);

                if (_this6.devedor.dividas && _this6.devedor.dividas.length > 0) {
                  _this6.setAcordo(_this6.devedor.dividas[0].acordo);
                } else {
                  _this6.setAcordo({});
                }
                _this6.active = 0;
                _this6.setLoading(false);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    salvar: function salvar() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!_this7.$refs.form.validate()) {
                  _context8.next = 22;
                  break;
                }

                _this7.setLoading(true);

                if (!(_this7.model.agendamento && !_this7.model.data)) {
                  _context8.next = 6;
                  break;
                }

                _this7.setError("Data deve ser informada");
                _this7.setLoading(false);
                return _context8.abrupt("return");

              case 6:
                if (!(_this7.model.agendamento && !_this7.model.hora)) {
                  _context8.next = 10;
                  break;
                }

                _this7.setError("Hora deve ser informada");
                _this7.setLoading(false);
                return _context8.abrupt("return");

              case 10:
                _this7.model.user = _this7.user._id;
                _context8.next = 13;
                return __WEBPACK_IMPORTED_MODULE_8__services_ocorrencias__["a" /* default */].save(_this7.model);

              case 13:
                _this7.dialogOcorrencia = false;
                _context8.t0 = _this7;
                _context8.next = 17;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this7.model.devedor);

              case 17:
                _context8.t1 = _context8.sent;

                _context8.t0.setDevedor.call(_context8.t0, _context8.t1);

                if (_this7.devedor.dividas && _this7.devedor.dividas.length > 0) {
                  _this7.setAcordo(_this7.devedor.dividas[0].acordo);
                } else {
                  _this7.setAcordo({});
                }
                _this7.setLoading(false);
                _this7.$forceUpdate();

              case 22:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    },
    selectedDevedor: function selectedDevedor(item) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this8.setLoading(true);
                _this8.setDevedor({});
                _this8.active = 0;
                _context9.t0 = _this8;
                _context9.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(item._id);

              case 6:
                _context9.t1 = _context9.sent;

                _context9.t0.setDevedor.call(_context9.t0, _context9.t1);

                if (_this8.devedor.dividas && _this8.devedor.dividas.length > 0) {
                  _this8.setAcordo(_this8.devedor.dividas[0].acordo);
                } else {
                  _this8.setAcordo({});
                }
                _this8.setLoading(false);
                _this8.dialogDevedores = false;

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this8);
      }))();
    },
    setAcordoInterno: function setAcordoInterno(item) {
      this.setAcordo(item.acordo);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapMutations */])({
    setError: "setError",
    setLoading: "setLoading",
    setDevedor: "setDevedor",
    setAcordo: "setAcordo"
  }))
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getOcorrenciaId: function getOcorrenciaId(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/ocorrencias/get/" + id, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getDevedor: function getDevedor(search) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.get("/ocorrencias/getDevedor/" + search, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  getOcorrencias: function getOcorrencias() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.get("/ocorrencias/get", headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  getOcorrenciasUser: function getOcorrenciasUser(model) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context4.next = 4;
              return instance.post("/ocorrencias/getUser", model, headers);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  },
  save: function save(model) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context5.next = 4;
              return instance.post("/ocorrencias/save", model, headers);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);

              console.log(_context5.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context5.t0.response.data.message);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context6.next = 4;
              return instance.delete("/ocorrencias/" + item._id, headers);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);

              console.log(_context6.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context6.t0.response.data.message);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Endereco_vue_vue_type_script_lang_js___ = __webpack_require__(241);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Endereco_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_buscacep__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_enderecodeve__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Endereco',
  data: function data() {
    return {

      valid: true,
      modelEndereco: {},
      dialogConfirmation: false,
      dialogEndereco: false,
      editando: false,
      excluindo: {},
      cep: {},
      user: {},
      mask: '#####-###',
      headersEndereco: [{
        text: 'Endereco',
        align: 'left',
        sortable: true,
        value: 'logradouro'
      }, {
        text: 'Número',
        align: 'left',
        sortable: true,
        value: 'numero'
      }, {
        text: 'Bairro',
        align: 'left',
        sortable: true,
        value: 'bairro'
      }, {
        text: 'Cidade',
        align: 'left',
        sortable: true,
        value: 'localidade'
      }, {
        text: 'UF',
        align: 'left',
        sortable: true,
        value: 'uf'
      }, { text: 'Ações', value: 'action', sortable: false }],
      estados: ["Acre", "Amapá", "Amazonas", "Pará", "Rondônia", "Roraima", "Tocantins", "Alagoas", "Bahia", "Ceará", "Maranhão", "Paraíba", "Pernambuco", "Piauí", "Rio Grande do Norte", "Sergipe", "Goiás", "Mato Grosso", "Mato Grosso do Sul", "Distrito Federal", "Espiríto Santo", "Rio de Janeiro", "São Paulo", "Minas Gerais", "Paraná", "Rio Grande do Sul", "Santa Catarina"]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__services_usuario__["a" /* default */].getUsuario(_this.$store.getters.user._id);

            case 2:
              _this.user = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    devedor: function devedor() {
      return this.$store.getters["devedor"];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    novoEndereco: function novoEndereco(devedor) {
      this.modelEndereco = { devedor: devedor._id };
      this.dialogEndereco = true;
    },
    salvarEndereco: function salvarEndereco() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.$refs.form.validate()) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_enderecodeve__["a" /* default */].save(_this2.modelEndereco);

              case 3:
                _this2.dialogEndereco = false;
                _context2.t0 = _this2;
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__services_devedores__["a" /* default */].getDevedoreId(_this2.modelEndereco.devedor);

              case 7:
                _context2.t1 = _context2.sent;

                _context2.t0.setDevedor.call(_context2.t0, _context2.t1);

                _this2.$forceUpdate();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    freteCep: function freteCep(postcode) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_buscacep__["a" /* default */].getCep(postcode.replace('-', ''));

              case 2:
                _this3.cep = _context3.sent;


                _this3.modelEndereco.logradouro = _this3.cep.logradouro;
                _this3.modelEndereco.bairro = _this3.cep.bairro;
                _this3.modelEndereco.localidade = _this3.cep.localidade;
                _this3.modelEndereco.uf = _this3.cep.uf;
                _this3.$forceUpdate();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getColorEndereco: function getColorEndereco(endereco) {
      if (endereco && endereco.hot) return 'red white--text';
    },

    deleteItem: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(even) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.dialogConfirmation) {
                  _context4.next = 5;
                  break;
                }

                this.dialogConfirmation = true;
                this.excluindo = even;
                _context4.next = 14;
                break;

              case 5:
                _context4.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__services_enderecodeve__["a" /* default */].remove(even);

              case 7:
                this.dialogConfirmation = false;
                this.excluindo = null;
                _context4.t0 = this;
                _context4.next = 12;
                return __WEBPACK_IMPORTED_MODULE_5__services_devedores__["a" /* default */].getDevedoreId(even.devedor);

              case 12:
                _context4.t1 = _context4.sent;

                _context4.t0.setDevedor.call(_context4.t0, _context4.t1);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteItem(_x) {
        return _ref.apply(this, arguments);
      }

      return deleteItem;
    }(),
    editItem: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(even) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                this.dialogEndereco = true;
                this.editando = true;
                this.modelEndereco = even;

                this.modelEndereco.internal = undefined;
                this.modelEndereco.flags = undefined;

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function editItem(_x2) {
        return _ref2.apply(this, arguments);
      }

      return editItem;
    }()
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapMutations */])({
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Telefone_vue_vue_type_script_lang_js___ = __webpack_require__(243);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Telefone_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_buscacep__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_telefonedeve__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Telefone',
  data: function data() {
    return {

      valid: true,
      model: {},
      dialogConfirmation: false,
      dialog: false,
      editando: false,
      excluindo: {},
      cep: {},
      user: {},
      mask: '(##) #####-####',
      items: ["Celular", "Comercial", "Residencial"],
      itemsQuem: ["Devedor", "Pai", "Mae ", "Irmão (a)", "Filho(a)", "Cônjuge ", "Primo(a)", "Tio(a)", "Vo(a)", "Amigo(a)", "Colega de trabalho ", "Não conhece", "Trabalho", "Não ligar", "Não é do devedor"],
      headersTelefone: [{
        text: 'Telefone',
        align: 'left',
        sortable: true,
        value: 'telefone'
      }, {
        text: 'Referência',
        align: 'left',
        sortable: true,
        value: 'quem'
      }, {
        text: 'Tipo',
        align: 'left',
        sortable: true,
        value: 'tipo'
      }, {
        text: 'Whatsapp',
        align: 'left',
        sortable: true,
        value: 'whatsapp'
      }, { text: 'Ações', value: 'action', sortable: false }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__services_usuario__["a" /* default */].getUsuario(_this.$store.getters.user._id);

            case 2:
              _this.user = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    devedor: function devedor() {
      return this.$store.getters["devedor"];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    novo: function novo(devedor) {
      this.model = { devedor: devedor._id };
      this.dialog = true;
    },
    salvar: function salvar() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.$refs.form.validate()) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_telefonedeve__["a" /* default */].save(_this2.model);

              case 3:
                _this2.dialog = false;
                _context2.t0 = _this2;
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__services_devedores__["a" /* default */].getDevedoreId(_this2.model.devedor);

              case 7:
                _context2.t1 = _context2.sent;

                _context2.t0.setDevedor.call(_context2.t0, _context2.t1);

                _this2.$forceUpdate();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getColor: function getColor(telefone) {
      if (telefone && telefone.hot) return 'red white--text';
    },

    deleteItem: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(even) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.dialogConfirmation) {
                  _context3.next = 5;
                  break;
                }

                this.dialogConfirmation = true;
                this.excluindo = even;
                _context3.next = 14;
                break;

              case 5:
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__services_telefonedeve__["a" /* default */].remove(even);

              case 7:
                this.dialogConfirmation = false;
                this.excluindo = null;
                _context3.t0 = this;
                _context3.next = 12;
                return __WEBPACK_IMPORTED_MODULE_5__services_devedores__["a" /* default */].getDevedoreId(even.devedor);

              case 12:
                _context3.t1 = _context3.sent;

                _context3.t0.setDevedor.call(_context3.t0, _context3.t1);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteItem(_x) {
        return _ref.apply(this, arguments);
      }

      return deleteItem;
    }(),
    editItem: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(even) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:

                this.dialog = true;
                this.editando = true;
                this.model = even;

                this.model.internal = undefined;
                this.model.flags = undefined;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function editItem(_x2) {
        return _ref2.apply(this, arguments);
      }

      return editItem;
    }()
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapMutations */])({
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Email_vue_vue_type_script_lang_js___ = __webpack_require__(245);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Email_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_buscacep__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_emaildeve__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_usuario__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Email',
  data: function data() {
    return {

      valid: true,
      model: {},
      emailRules: [function (v) {
        return !!v || 'E-mail deve ser informado';
      }, function (v) {
        return (/.+@.+\..+/.test(v) || 'E-mail não é válido.'
        );
      }],
      dialogConfirmation: false,
      dialog: false,
      editando: false,
      excluindo: {},
      cep: {},
      user: {},
      mask: '#####-###',
      items: ["Pessoal", "Comercial"],
      headersEmail: [{
        text: 'Email',
        align: 'left',
        sortable: true,
        value: 'email'
      }, {
        text: 'Tipo',
        align: 'left',
        sortable: true,
        value: 'tipo'
      }, { text: 'Ações', value: 'action', sortable: false }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7__services_usuario__["a" /* default */].getUsuario(_this.$store.getters.user._id);

            case 2:
              _this.user = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    devedor: function devedor() {
      return this.$store.getters["devedor"];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    novo: function novo(devedor) {
      this.model = { devedor: devedor._id };
      this.dialog = true;
    },
    salvar: function salvar() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.$refs.form.validate()) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_emaildeve__["a" /* default */].save(_this2.model);

              case 3:
                _this2.dialog = false;
                _context2.t0 = _this2;
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this2.model.devedor);

              case 7:
                _context2.t1 = _context2.sent;

                _context2.t0.setDevedor.call(_context2.t0, _context2.t1);

                _this2.$forceUpdate();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getColor: function getColor(email) {
      if (email && email.hot) return 'red white--text';
    },
    deleteItem: function deleteItem(even) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.dialogConfirmation) {
                  _context3.next = 5;
                  break;
                }

                _this3.dialogConfirmation = true;
                _this3.excluindo = even;
                _context3.next = 14;
                break;

              case 5:
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__services_emaildeve__["a" /* default */].remove(even);

              case 7:
                _this3.dialogConfirmation = false;
                _this3.excluindo = null;
                _context3.t0 = _this3;
                _context3.next = 12;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(even.devedor);

              case 12:
                _context3.t1 = _context3.sent;

                _context3.t0.setDevedor.call(_context3.t0, _context3.t1);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    editItem: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(even) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:

                this.dialog = true;
                this.editando = true;
                this.model = even;

                this.model.internal = undefined;
                this.model.flags = undefined;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function editItem(_x) {
        return _ref.apply(this, arguments);
      }

      return editItem;
    }()
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getId: function getId(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.get("/emaildeve/get/" + id, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  getDevedor: function getDevedor(user) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.get("/emaildeve/getDevedor/" + user, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  save: function save(model) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context3.next = 4;
              return instance.post("/emaildeve/save", model, headers);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              console.log(_context3.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context3.t0.response.data.message);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  remove: function remove(item) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context4.next = 4;
              return instance.delete("/emaildeve/" + item._id + "/" + item.devedor, headers);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context4.t0.response.data.message);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Negociacao_vue_vue_type_script_lang_js___ = __webpack_require__(248);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Negociacao_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_acordo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_telefonedeve__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_money__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);





//
//









function getPosition(string, subString, index) {
  return string.split(subString, index).join(subString).length;
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Negociacao',
  data: function data() {
    return {
      valid: true,
      dialogConfirmation: false,
      menu2: false,
      date2: new Date().toISOString().substr(0, 10),
      dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu3: false,
      date3: new Date().toISOString().substr(0, 10),
      dateFormatted3: this.formatDate(new Date().toISOString().substr(0, 10)),
      mask: '(##) #####-####',
      modal2: false,
      user: {},
      message: "",
      dialogError: false,
      money: {
        decimal: ',',
        thousands: '.',
        suffix: '',
        precision: 2
      },
      dialogParcela: false,
      parcelas: [],
      headersParcelas: [{
        text: 'Numero',
        value: 'numero'
      }, {
        text: 'Vencimento',
        value: 'vencimento'
      }, {
        text: 'Valor',
        value: 'valor'
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7__services_usuario__["a" /* default */].getUsuario(_this.$store.getters.user._id);

            case 2:
              _this.user = _context.sent;

              _this.$forceUpdate();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    computedDateFormatted2: function computedDateFormatted2() {
      return this.formatDate(this.date2);
    },
    computedDateFormatted3: function computedDateFormatted3() {
      return this.formatDate(this.date3);
    },
    devedor: function devedor() {
      return this.$store.getters["devedor"];
    },
    acordo: function acordo() {
      return this.$store.getters["acordo"];
    },
    loading: function loading() {
      return this.$store.getters["loading"];
    }
  },
  watch: {
    date2: function date2(val) {
      this.dateFormatted2 = this.formatDate(this.date2);
      this.acordo.dtVencimento = this.date2;
    },
    date3: function date3(val) {
      this.dateFormatted3 = this.formatDate(this.date3);
      this.acordo.dtVencimentoParcela = this.date3;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
    },
    allowedDatesParcela: function allowedDatesParcela(date) {
      var val = __WEBPACK_IMPORTED_MODULE_11_moment___default()().add(45, 'days');
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date) <= val;
    },
    allowedDates: function allowedDates(date) {
      var val = __WEBPACK_IMPORTED_MODULE_11_moment___default()().add(15, 'days');
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date) <= val;
    },
    salvar: function salvar(parcela) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var valorAcordo, vencimento, parcelas, entrada, vencimentoParcela, index, valor, telefone, ValorAcordo;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.$refs.form.validate()) {
                  _context2.next = 42;
                  break;
                }

                if (parcela) {
                  _context2.next = 14;
                  break;
                }

                // let valorAcordo = this.acordo.ValorAcordo.replace('.', '').replace('.', '').replace('.', '');
                // valorAcordo = valorAcordo.replace(',', '.');
                valorAcordo = Number(_this2.acordo.ValorAcordo);
                vencimento = _this2.acordo.dtVencimento;
                parcelas = [];
                entrada = 0;

                if (_this2.acordo.ValorEntrada) {

                  // entrada = this.acordo.ValorEntrada.replace('.', '').replace('.', '').replace('.', '');
                  // entrada = entrada.replace(',', '.');
                  entrada = Number(_this2.acordo.ValorEntrada);

                  if (entrada) {
                    parcelas.push({ "numero": 1, "valor": entrada, "vencimento": vencimento });
                  }
                }

                vencimentoParcela = _this2.acordo.dtVencimentoParcela;

                for (index = 0; index < _this2.acordo.nrParcela; index++) {
                  valor = 0;

                  if (index + 1 != _this2.acordo.nrParcela) {
                    valor = (valorAcordo - entrada) / _this2.acordo.nrParcela;
                  } else {
                    valor = Number(valorAcordo) - Number(parcelas.map(function (item) {
                      return item.valor;
                    }).reduce(function (prev, next) {
                      return prev + next;
                    }));
                  }
                  vencimentoParcela = new Date(Date.parse(vencimentoParcela));
                  if (index == 0) {
                    parcelas.push({ "numero": parcelas.length + 1, "valor": valor, "vencimento": new Date(vencimentoParcela).toISOString().substr(0, 10) });
                  } else {
                    parcelas.push({ "numero": parcelas.length + 1, "valor": valor, "vencimento": new Date(vencimentoParcela.setMonth(vencimentoParcela.getMonth() + 1)).toISOString().substr(0, 10) });
                  }
                }

                _this2.acordo.parcelas = parcelas;
                _this2.dialogParcela = true;
                return _context2.abrupt("return");

              case 14:
                _this2.setLoading(true);

                if (_this2.acordo.telefone) {
                  _context2.next = 19;
                  break;
                }

                _this2.setError('Telefone de Fechamento do Acordo deve ser informado!');
                _this2.setLoading(false);
                return _context2.abrupt("return");

              case 19:
                telefone = {
                  devedor: _this2.devedor._id,
                  telefone: _this2.acordo.telefone,
                  hot: true
                };
                _context2.next = 22;
                return __WEBPACK_IMPORTED_MODULE_8__services_telefonedeve__["a" /* default */].save(telefone);

              case 22:
                ValorAcordo = _this2.acordo.ValorAcordo; //.replace('.', '').replace('.', '').replace('.', '');
                //ValorAcordo = ValorAcordo.replace(',', '.');

                if (!(Number(ValorAcordo) != Number(_this2.acordo.parcelas.map(function (item) {
                  return Number(item.valor);
                }).reduce(function (prev, next) {
                  return prev + next;
                })))) {
                  _context2.next = 27;
                  break;
                }

                _this2.message = "O Valor das parcelas (" + _this2.acordo.parcelas.map(function (item) {
                  return Number(item.valor);
                }).reduce(function (prev, next) {
                  return prev + next;
                }) + ") não é igual ao valor do Acordo (" + _this2.acordo.ValorAcordo + ")";
                _this2.dialogError = true;
                return _context2.abrupt("return");

              case 27:
                _this2.acordo.devedor = _this2.devedor._id;
                _this2.acordo.cliente = _this2.acordo.idcliente._id;
                _this2.acordo.user = _this2.user._id;
                _this2.acordo.StatusAcordo = '2';
                _context2.next = 33;
                return __WEBPACK_IMPORTED_MODULE_5__services_acordo__["a" /* default */].save(_this2.acordo);

              case 33:
                _context2.t0 = _this2;
                _context2.next = 36;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this2.acordo.devedor);

              case 36:
                _context2.t1 = _context2.sent;

                _context2.t0.setDevedor.call(_context2.t0, _context2.t1);

                if (_this2.devedor.dividas) {
                  _this2.setAcordo(_this2.devedor.dividas[0].acordo);
                }
                _this2.dialogParcela = false;
                _this2.setLoading(false);
                _this2.$forceUpdate();

              case 42:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    calculaParcelas: function calculaParcelas(parcelas) {
      if (parcelas && parcelas.length > 0) {
        return Number(parcelas.map(function (item) {
          return Number(item.valor ? item.valor : 0);
        }).reduce(function (prev, next) {
          return prev + next;
        }).toFixed(2));
      } else {
        return 0;
      }
    },
    getTipoProduto: function getTipoProduto(tipo) {
      if (!tipo) return '';
      if (tipo == 1) return 'Boleto';else if (tipo == 2) return 'Cheque';else if (tipo == 3) return 'Nota';else if (tipo == 4) return 'Nota Fiscal';else if (tipo == 5) return 'Promissoria';
    },
    getDiasAtraso: function getDiasAtraso(data) {
      if (data) {
        var mes = data.substring(getPosition(data, '/', 1) + 1, getPosition(data, '/', 2) + 1);
        data = data.replace(mes, '');
        data = mes + data;
        var toDate = new Date(data);
        var result = new Date().getTime() - toDate.getTime();
        result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(result / 1000 / 60 / 60 / 24);
        return result;
      }
      return null;
    },
    getMesesAtraso: function getMesesAtraso(data) {
      if (data) {
        var mes = data.substring(getPosition(data, '/', 1) + 1, getPosition(data, '/', 2) + 1);
        data = data.replace(mes, '');
        data = mes + data;
        var toDate = new Date(data);
        var result = new Date().getTime() - toDate.getTime();
        result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(result / 1000 / 60 / 60 / 24 / 30);
        return result;
      }
      return null;
    },
    getAnosAtraso: function getAnosAtraso(data) {
      if (data) {
        var mes = data.substring(getPosition(data, '/', 1) + 1, getPosition(data, '/', 2) + 1);
        data = data.replace(mes, '');
        data = mes + data;
        var toDate = new Date(data);
        var result = new Date().getTime() - toDate.getTime();
        result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(result / 1000 / 60 / 60 / 24 / 30 / 12);
        return result;
      }
      return null;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapMutations */])({
    setDevedor: "setDevedor",
    setAcordo: "setAcordo",
    setLoading: "setLoading",
    setError: "setError"
  })),
  directives: { money: __WEBPACK_IMPORTED_MODULE_10_v_money__["VMoney"] }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_script_lang_js___ = __webpack_require__(250);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_acordo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_juno__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Endereco',
  data: function data() {
    return {

      valid: true,
      acordo: {},
      dialogConfirmation: false,
      dialogError: false,
      dialogParcela: false,
      editando: false,
      message: "",
      excluindo: {},
      cep: {},
      headersAcordo: [{
        text: 'Nome Operador',
        align: 'left',
        sortable: true,
        value: 'user.name'
      }, {
        text: 'Nome Empresa',
        align: 'left',
        sortable: true,
        value: 'cliente.Nome'
      }, {
        text: 'Valor Acordo',
        align: 'left',
        sortable: true,
        value: 'ValorAcordo'
      }, {
        text: 'Tipo Acordo',
        align: 'left',
        sortable: true,
        value: 'proposta'
      }, {
        text: 'Tipo Pagamento',
        align: 'left',
        sortable: true,
        value: 'tipoPagamento'
      }, {
        text: 'Saldo Inicial',
        align: 'left',
        sortable: true,
        value: 'ValorDivida'
      }, {
        text: 'Comentarios',
        align: 'left',
        sortable: true,
        value: 'detalhes'
      }, {
        text: 'Status Acordo',
        align: 'left',
        sortable: true,
        value: 'StatusAcordo'
      }, {
        text: 'Data Acordo',
        align: 'left',
        sortable: true,
        value: 'createdAt'
      }],
      headersParcelas: [{
        text: 'Numero',
        value: 'numero'
      }, {
        text: 'Vencimento',
        value: 'vencimento'
      }, {
        text: 'Valor',
        value: 'valor'
      }, {
        text: 'Boleto',
        value: 'boleto'
      },
      // {
      //   text: 'Modo de Envio',
      //   value: 'email'
      // },
      {
        text: 'Status',
        value: 'stPago'
      }, {
        text: 'Numero Boleto',
        value: 'numeroBoleto'
      }, {
        text: 'Pagamento',
        value: 'dtPagamento'
      }]
    };
  },

  computed: {
    devedor: function devedor() {
      return this.$store.getters["devedor"];
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    abrirAcordo: function abrirAcordo(acordo) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.acordo = acordo;
                _this.dialogParcela = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getColorEndereco: function getColorEndereco(endereco) {
      if (endereco && endereco.hot) return 'red white--text';
    },
    desabilitarPagamento: function desabilitarPagamento(acordo, item) {
      if (acordo.StatusAcordo == '1' || acordo.StatusAcordo == '2' || acordo.StatusAcordo == '9' || item.stPago == 'S') {
        return true;
      } else {
        var retorno = false;
        acordo.parcelas.forEach(function (parcela) {
          if (parcela.numero == item.numero - 1 && parcela.stPago == "N") {
            retorno = true;
          }
        });
        return retorno;
      }
    },
    enviarEmail: function enviarEmail(item) {
      console.log(item);
    },
    gerarBoleto: function gerarBoleto(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!item.secure_url) {
                  _context3.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(item.secure_url).then(function (response) {
                  window.open(item.secure_url, '_blank');
                }).catch(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(error) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_5__services_juno__["a" /* default */].imprimirBoletosBB(item);

                          case 2:
                            response = _context2.sent;

                            window.open(response.secure_url, '_blank');

                          case 4:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _context3.next = 19;
                break;

              case 4:
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__services_juno__["a" /* default */].gerarBoletoBB(item);

              case 6:
                response = _context3.sent;

                if (!response) {
                  _context3.next = 19;
                  break;
                }

                if (!(response && response.data && response.data.erros)) {
                  _context3.next = 11;
                  break;
                }

                _this2.setError(response.data.erros);
                return _context3.abrupt("return");

              case 11:

                _this2.dialogParcela = false;
                _this2.$forceUpdate();
                _context3.t0 = _this2;
                _context3.next = 16;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this2.acordo.devedor);

              case 16:
                _context3.t1 = _context3.sent;

                _context3.t0.setDevedor.call(_context3.t0, _context3.t1);

                _this2.setError('Boleto gerado com sucesso!');

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    getStatusAcordo: function getStatusAcordo(status) {
      if (status == 1) {
        return 'Processo Cobrança';
      } else if (status == 2) {
        return 'Aguardando Aprovação';
      } else if (status == 3) {
        return 'Acordo Vigente';
      } else if (status == 4) {
        return 'Acordo em Atraso';
      } else if (status == 9) {
        return 'Acordo Cancelado';
      } else if (status == 6) {
        return 'Acordo Liquidado';
      }
    },
    getProposta: function getProposta(proposta) {
      if (proposta == 1) {
        return 'Fixa';
      } else if (proposta == 2) {
        return 'Exceção';
      } else if (proposta == 3) {
        return 'Gerado Devedor';
      }
    },
    getStPago: function getStPago(item) {
      if (item.juno && item.juno.payments && item.juno.payments.length > 0 || item.stPago == 'S') {
        return 'Pago';
      }
      if (item.secure_url) {
        return 'Boleto BB';
      }
      if (!item.juno) {
        return 'Boleto não Gerado';
      }

      if (moment(item.juno.dueDate) < moment()) {
        return 'Atraso';
      }
      if (item.stPago == 'N') {
        return 'Não Pago';
      }
    },
    getPagamento: function getPagamento(pagamento) {
      if (pagamento == 1) {
        return 'Boleto';
      } else if (pagamento == 2) {
        return 'Deposito';
      } else if (pagamento == 3) {
        return 'Escritório';
      } else if (pagamento == 4) {
        return 'Na Loja';
      } else if (pagamento == 5) {
        return 'Pix';
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setError: "setError",
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Agenda_vue_vue_type_script_lang_js___ = __webpack_require__(252);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Agenda_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_agendas__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);



//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {

      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      modal2: false,
      active: 0,
      singleSelect: true,
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
      editando: false,
      user: null,
      devedores: [],
      agendas: [],
      maskHora: '##:##',
      model: { data: new Date().toISOString().substr(0, 10) },
      headers: [{
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'iddevedor.Nome'
      }, {
        text: 'CPF',
        align: 'left',
        sortable: true,
        value: 'iddevedor.CnpjCpf'
      }, {
        text: 'Data',
        align: 'left',
        sortable: true,
        value: 'data'
      }, {
        text: 'Hora',
        align: 'left',
        sortable: true,
        value: 'hora'
      }, { text: 'Ações', value: 'action', sortable: false }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__services_devedores__["a" /* default */].getDevedores();

            case 2:
              _this.devedores = _context.sent;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_5__services_agendas__["a" /* default */].getUser(_this.$store.getters.user._id, _this.parseDate(_this.formatDate(_this.date)));

            case 5:
              _this.agendas = _context.sent;

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedDateFormatted2: function computedDateFormatted2() {
      return this.formatDate(this.date2);
    }
  },

  watch: {
    date: function date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    date2: function date2(val) {
      this.dateFormatted2 = this.formatDate(this.date2);
      this.model.data = this.date2;
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
    },

    cobrar: function cobrar(item) {
      this.$router.push('/funcionario/cobranca/' + item.iddevedor._id);
    },
    novo: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.dialog = true;
                this.editando = false;
                this.model = { data: new Date().toISOString().substr(0, 10) };

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function novo() {
        return _ref.apply(this, arguments);
      }

      return novo;
    }(),
    dateChange: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(date) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_agendas__["a" /* default */].getUser(this.$store.getters.user._id, this.parseDate(this.formatDate(this.date)));

              case 2:
                this.agendas = _context3.sent;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function dateChange(_x) {
        return _ref2.apply(this, arguments);
      }

      return dateChange;
    }(),
    deleteItem: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(even) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.dialogConfirmation) {
                  _context4.next = 5;
                  break;
                }

                this.dialogConfirmation = true;
                this.excluindo = even;
                _context4.next = 12;
                break;

              case 5:
                _context4.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__services_agendas__["a" /* default */].remove(even);

              case 7:
                this.dialogConfirmation = false;
                this.excluindo = null;
                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_5__services_agendas__["a" /* default */].getUser(this.$store.getters.user._id, this.parseDate(this.formatDate(this.date)));

              case 11:
                this.agendas = _context4.sent;

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteItem(_x2) {
        return _ref3.apply(this, arguments);
      }

      return deleteItem;
    }(),
    editItem: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(even) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_devedores__["a" /* default */].getDevedores();

              case 2:
                this.devedores = _context5.sent;

                this.dialog = true;
                this.editando = true;
                this.model = even;

                this.model.internal = undefined;
                this.model.flags = undefined;
                if (!this.model.iddevedor) {
                  this.model.iddevedor = {};
                }
                if (this.model.data) {
                  this.model.data = new Date(this.model.data).toISOString().substr(0, 10);
                }

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function editItem(_x3) {
        return _ref4.apply(this, arguments);
      }

      return editItem;
    }(),
    save: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var errors, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.$validator.validate();

              case 2:
                errors = _context6.sent;

                this.model.iduser = this.$store.getters.user._id;

                if (!errors) {
                  _context6.next = 18;
                  break;
                }

                _context6.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__services_agendas__["a" /* default */].save(this.model);

              case 7:
                res = _context6.sent;

                if (!(res.data && res.data.error)) {
                  _context6.next = 13;
                  break;
                }

                this.message = res.data.error.data;
                this.dialogError = true;
                _context6.next = 18;
                break;

              case 13:
                this.model = {};
                this.dialog = false;
                _context6.next = 17;
                return __WEBPACK_IMPORTED_MODULE_5__services_agendas__["a" /* default */].getUser(this.$store.getters.user._id, this.parseDate(this.formatDate(this.date)));

              case 17:
                this.agendas = _context6.sent;

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function save() {
        return _ref5.apply(this, arguments);
      }

      return save;
    }(),

    clear: function clear() {
      this.model = { data: new Date().toISOString().substr(0, 10) };
      this.editando = false;
      this.dialog = false;
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signin_vue_vue_type_script_lang_js___ = __webpack_require__(254);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signin_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signin',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      title: 'Signin',
      email: '',
      password: ''
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();
                _context.next = 3;
                return _this.$store.dispatch('signUserIn', { email: _this.email, password: _this.password });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clear: function clear() {
      this.$v.$reset();
      this.email = '';
      this.password = '';
      this.$router.push('/signup');
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/hello');
      }
    }
  },
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signup_vue_vue_type_script_lang_js___ = __webpack_require__(256);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signup_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signin',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      title: 'Signin',
      email: '',
      password: ''
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();
                _context.next = 3;
                return _this.$store.dispatch('signUserUp', { email: _this.email, password: _this.password });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clear: function clear() {
      this.$v.$reset();
      this.email = '';
      this.password = '';
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/hello');
      }
    }
  },
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuarios_vue_vue_type_script_lang_js___ = __webpack_require__(258);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuarios_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_cliente__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_empresa__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_money__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      search: '',
      snackbar: false,
      message: '',
      loading: true,
      dialog: false,
      dialogSenha: false,
      dialogError: false,
      dialogConfirmation: false,
      editando: false,
      excluindo: {},
      idZabbix: '',
      user: {},
      usuarios: [],
      clientes: [],
      devedores: [],
      empresas: [],
      money: {
        decimal: ',',
        thousands: '.',
        suffix: '',
        precision: 2
      },
      options: ['Cliente', 'Admin', 'Funcionario', 'Financeiro', 'Cadastradores', 'Advogado', 'AdminClientes'],
      model: {
        name: "",
        username: "",
        senha: ""
      },
      headers: [{
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name'
      }, {
        text: 'Email',
        align: 'left',
        sortable: true,
        value: 'username'
      }, {
        text: 'Acesso',
        align: 'left',
        sortable: true,
        value: 'acesso'
      }, { text: 'Ações', value: 'action', sortable: false }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuarios();

            case 2:
              _this.usuarios = _context.sent;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_6__services_cliente__["a" /* default */].getClientes();

            case 5:
              _this.clientes = _context.sent;
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_7__services_empresa__["a" /* default */].getAll();

            case 8:
              _this.empresas = _context.sent;

              if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user._id);

            case 12:
              _this.user = _context.sent;

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    novo: function novo() {
      this.dialog = true;
      // this.$refs.meta1.$el.getElementsByTagName('input')[0].value = 0;
      // this.$refs.meta2.$el.getElementsByTagName('input')[0].value = 0;
      // this.$refs.meta3.$el.getElementsByTagName('input')[0].value = 0;
      this.model = {
        name: "",
        username: "",
        password: ""
      };
    },
    deleteItem: function deleteItem(even) {
      var _this2 = this;

      if (!this.dialogConfirmation) {
        this.dialogConfirmation = true;
        this.excluindo = even;
      } else {
        __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].deleteUser(even._id).then(function (res) {
          _this2.dialogConfirmation = false;
          _this2.excluindo = null;
          __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuarios().then(function (res) {
            _this2.usuarios = res;
          });
        });
      }
    },
    editItem: function editItem(even) {
      //this.$router.push({ name: 'EditGroupHosts', params: { id: even.groupid }})
      this.dialog = true;
      this.editando = true;
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, even);
      this.$forceUpdate();
      this.model.internal = undefined;
      this.model.flags = undefined;
      // this.$refs.meta1.$el.getElementsByTagName('input')[0].value = even.meta1?even.meta1.toFixed(2):0;
      // this.$refs.meta2.$el.getElementsByTagName('input')[0].value = even.meta2?even.meta2.toFixed(2):0;
      // this.$refs.meta3.$el.getElementsByTagName('input')[0].value = even.meta3?even.meta3.toFixed(2):0;
    },
    editSenha: function editSenha(even) {
      //this.$router.push({ name: 'EditGroupHosts', params: { id: even.groupid }})
      this.dialogSenha = true;
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, even);
      this.$forceUpdate();
      this.model.internal = undefined;
      this.model.flags = undefined;
    },
    save: function save() {
      var _this3 = this;

      this.$validator.validateAll().then(function (errors) {
        if (errors) {
          if (_this3.editando) {
            __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].alterarUsuario(_this3.model._id, _this3.model).then(function (res) {
              if (res.data && res.data.error) {
                _this3.message = res.data.error.data;
                _this3.dialogError = true;
              } else {
                _this3.clear();
                __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuarios().then(function (res) {
                  _this3.usuarios = res;
                });
              }

              _this3.editando = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].saveUsuario(_this3.model).then(function (res) {
              if (res.data && res.data.error) {
                _this3.message = res.data.error.data;
                _this3.dialogError = true;
              } else {
                _this3.clear();
                __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuarios().then(function (res) {
                  _this3.usuarios = res;
                });
              }

              _this3.editando = false;
            });
          }
        }
      });
    },
    saveSenha: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var errors, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$validator.validateAll();

              case 2:
                errors = _context2.sent;

                if (!errors) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].saveUsuarioSenha(this.model);

              case 6:
                res = _context2.sent;

                if (!(res.data && res.data.error)) {
                  _context2.next = 12;
                  break;
                }

                this.message = res.data.error.data;
                this.dialogError = true;
                _context2.next = 16;
                break;

              case 12:
                this.clearSenha();
                _context2.next = 15;
                return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuarios();

              case 15:
                this.usuarios = _context2.sent;

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveSenha() {
        return _ref.apply(this, arguments);
      }

      return saveSenha;
    }(),
    clearSenha: function clearSenha() {
      this.model = {
        name: "",
        username: "",
        password: ""
      };
      this.editando = false;
      this.$validator.reset();
      this.dialogSenha = false;
    },
    clear: function clear() {
      this.model = {
        name: "",
        username: "",
        password: ""
      };
      this.editando = false;
      this.$validator.reset();
      this.dialog = false;
    }

  },
  directives: { money: __WEBPACK_IMPORTED_MODULE_9_v_money__["VMoney"] }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Empresas_vue_vue_type_script_lang_js___ = __webpack_require__(260);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Empresas_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_empresa__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      search: '',
      loading: true,
      dialog: false,
      carregando: false,
      dialogConfirmation: false,
      editando: false,
      excluindo: {},
      empresas: [],
      active: 0,
      maskCNPJ: '##.###.###/####-##',
      options: ['Cliente', 'Admin', 'Funcionario', 'Financeiro', 'Cadastradores'],
      model: {
        nome: ""
      },
      headers: [{
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'nome'
      }, { text: 'Ações', value: 'action', sortable: false }],
      headersPdfs: [{
        text: 'Nome  Anexo',
        align: 'left',
        sortable: true,
        value: 'descricao'
      }, { text: 'Ações', value: 'action', sortable: false }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__services_empresa__["a" /* default */].getAll();

            case 2:
              _this.empresas = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    novo: function novo() {
      this.dialog = true;
      this.model = {
        nome: ""
      };
    },
    deleteItem: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(even) {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.dialogConfirmation) {
                  _context2.next = 5;
                  break;
                }

                this.dialogConfirmation = true;
                this.excluindo = even;
                _context2.next = 13;
                break;

              case 5:
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3__services_empresa__["a" /* default */].remove(even);

              case 7:
                res = _context2.sent;

                this.dialogConfirmation = false;
                this.excluindo = null;
                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_3__services_empresa__["a" /* default */].getAll();

              case 12:
                this.empresas = _context2.sent;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteItem(_x) {
        return _ref.apply(this, arguments);
      }

      return deleteItem;
    }(),
    editItem: function editItem(even) {
      //this.$router.push({ name: 'EditGroupHosts', params: { id: even.groupid }})
      this.dialog = true;
      this.editando = true;
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, even);
      this.$forceUpdate();
      this.model.internal = undefined;
      this.model.flags = undefined;
    },
    save: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.$refs.form.validate()) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__services_empresa__["a" /* default */].save(this.model);

              case 3:
                res = _context3.sent;

                if (!(res.data && res.data.error)) {
                  _context3.next = 9;
                  break;
                }

                this.message = res.data.error.data;
                this.dialogError = true;
                _context3.next = 13;
                break;

              case 9:
                this.clear();
                _context3.next = 12;
                return __WEBPACK_IMPORTED_MODULE_3__services_empresa__["a" /* default */].getAll();

              case 12:
                this.empresas = _context3.sent;

              case 13:

                this.editando = false;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function save() {
        return _ref2.apply(this, arguments);
      }

      return save;
    }(),
    clear: function clear() {
      this.model = {
        name: "",
        username: "",
        password: ""
      };
      this.editando = false;
      this.$validator.reset();
      this.dialog = false;
    },
    onFileChangePdf: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4($event) {
        var files, payload, i, file, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setLoading(true);
                _context4.prev = 1;
                files = $event.target.files || $event.dataTransfer.files;

                if (!files) {
                  _context4.next = 15;
                  break;
                }

                payload = new FormData();

                payload.set('empresa', this.model._id);

                if (!(files.length > 0)) {
                  _context4.next = 15;
                  break;
                }

                for (i = 0; i < files.length; i++) {
                  file = files[i];

                  payload.append('filename', file);
                }
                _context4.next = 10;
                return __WEBPACK_IMPORTED_MODULE_3__services_empresa__["a" /* default */].saveImage(payload);

              case 10:
                res = _context4.sent;
                _context4.next = 13;
                return __WEBPACK_IMPORTED_MODULE_3__services_empresa__["a" /* default */].getId(this.model._id);

              case 13:
                this.model = _context4.sent;

                this.setLoading(false);

              case 15:
                _context4.next = 20;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](1);

                this.setLoading(false);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 17]]);
      }));

      function onFileChangePdf(_x2) {
        return _ref3.apply(this, arguments);
      }

      return onFileChangePdf;
    }(),

    deleteImage: function deleteImage(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this2.setLoading(true);
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__services_empresa__["a" /* default */].removeImage(item, _this2.model._id);

              case 3:
                res = _context5.sent;
                _context5.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__services_empresa__["a" /* default */].getId(_this2.model._id);

              case 6:
                _this2.model = _context5.sent;


                _this2.setLoading(false);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this2);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoletosBB_vue_vue_type_script_lang_js___ = __webpack_require__(262);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoletosBB_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_juno__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js2excel__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js2excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js2excel__);




//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {

      menu: false,
      search: '',
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
      editando: false,
      user: null,
      items: [{ _id: 'A', nome: 'A ser' }, { _id: 'B', nome: 'Baixados/Protestados/Liquidados' }],
      boletos: [],
      model: { status: 'B', date: new Date().toISOString().substr(0, 7) },
      headers: [{
        text: 'Registro',
        align: 'left',
        sortable: true,
        value: 'dataRegistro'
      }, {
        text: 'Vencimento',
        align: 'left',
        sortable: true,
        value: 'dataVencimento'
      }, {
        text: 'Movimento',
        align: 'left',
        sortable: true,
        value: 'dataMovimento'
      }, {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'boleto.nomeSacadoCobranca'
      },
      // {
      //   text: 'Crédito',
      //   align: 'left',
      //   sortable: true,
      //   value: 'dataCredito'
      // },
      {
        text: 'Estado',
        align: 'left',
        sortable: true,
        value: 'estadoTituloCobranca'
      }, {
        text: 'Numero',
        align: 'left',
        sortable: true,
        value: 'numeroBoletoBB'
      }, {
        text: 'Valor Original',
        align: 'left',
        sortable: true,
        value: 'valorOriginal'
      }, {
        text: 'Valor Atual',
        align: 'left',
        sortable: true,
        value: 'valorAtual'
      }, {
        text: 'Valor Pago',
        align: 'left',
        sortable: true,
        value: 'valorPago'
      }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.buscar();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedDateFormatted2: function computedDateFormatted2() {
      return this.formatDate(this.date2);
    }
  },

  watch: {
    date: function date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    date2: function date2(val) {
      this.dateFormatted2 = this.formatDate(this.date2);
      this.model.data = this.date2;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
    },
    buscar: function buscar() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.setLoading(true);
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_juno__["a" /* default */].buscarBoletosBB(_this2.model);

              case 4:
                response = _context2.sent;

                _this2.boletos = response.boletos;
                _this2.setLoading(false);
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                console.log(_context2.t0);
                _this2.boletos = [];
                _this2.setLoading(false);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    exportarExcel: function exportarExcel(boletos) {
      var data = [];
      boletos.forEach(function (boleto) {
        var object = {
          "Registro": boleto.dataRegistro,
          "Vencimento": boleto.dataVencimento,
          "Movimento": boleto.dataMovimento,
          "Nome Devedor": boleto.boleto.nomeSacadoCobranca,
          "Estado": boleto.estadoTituloCobranca,
          "Numero": boleto.numeroBoletoBB,
          "Valor Original": boleto.valorOriginal,
          "Valor Atual": boleto.valorAtual,
          "Valor Pago": boleto.valorPago
        };
        data.push(object);
      });
      try {
        Object(__WEBPACK_IMPORTED_MODULE_8_js2excel__["json2excel"])({
          data: data,
          name: 'boletosBB',
          formateDate: 'dd/mm/yyyy'
        });
      } catch (e) {
        console.error('export error');
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Clientes_vue_vue_type_script_lang_js___ = __webpack_require__(264);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Clientes_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_cliente__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);



//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      active: 0,
      search: '',
      message: '',
      tarefa: '',
      dialog: false,
      menu: false,
      dialogError: false,
      dialogConfirmation: false,
      dialogBlock: false,
      dialogImage: false,
      dialogMovie: false,
      editando: false,
      carregando: false,
      user: null,
      maskPercent: '##.##',
      maskPercent100: '###.##',
      maskCNPJ: '##.###.###/####-##',
      excluindo: {},
      bloqueando: {},
      usuarios: [],
      clientes: [],
      tipoParcelamento: [{ tipopParcela: 1, descricao: "1x" }, { tipopParcela: 2, descricao: "2x" }, { tipopParcela: 3, descricao: "3x" }, { tipopParcela: 4, descricao: "4x" }, { tipopParcela: 5, descricao: "5x" }, { tipopParcela: 6, descricao: "6x" }, { tipopParcela: 7, descricao: "7x" }, { tipopParcela: 8, descricao: "8x" }, { tipopParcela: 9, descricao: "9x" }, { tipopParcela: 10, descricao: "10x" }, { tipopParcela: 11, descricao: "11x" }, { tipopParcela: 12, descricao: "12x" }, { tipopParcela: 13, descricao: "13x" }, { tipopParcela: 14, descricao: "14x" }, { tipopParcela: 15, descricao: "15x" }, { tipopParcela: 16, descricao: "16x" }, { tipopParcela: 17, descricao: "17x" }, { tipopParcela: 18, descricao: "18x" }, { tipopParcela: 19, descricao: "19x" }, { tipopParcela: 20, descricao: "20x" }, { tipopParcela: 21, descricao: "21x" }, { tipopParcela: 22, descricao: "22x" }, { tipopParcela: 23, descricao: "23x" }, { tipopParcela: 24, descricao: "24x" }],
      model: {
        nome: '',
        usuarios: [],
        etapas: []
      },
      headers: [{
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'Nome'
      }, {
        text: 'CNPJ',
        align: 'left',
        sortable: true,
        value: 'Cnpj'
      }, {
        text: 'Email',
        align: 'left',
        sortable: true,
        value: 'Email'
      }, { text: 'Ações', value: 'action', sortable: false }]
    };
  },

  computed: {
    computedDateInicio: function computedDateInicio() {
      return this.model.dtInicio ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.model.dtInicio).format('DD/MM/YYYY') : '';
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.buscar();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    buscar: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                this.setLoading(true);
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__services_usuario__["a" /* default */].getUsuario(this.$store.getters.user._id);

              case 3:
                this.user = _context2.sent;
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4__services_cliente__["a" /* default */].getClientes();

              case 6:
                this.clientes = _context2.sent;

                this.clientes.forEach(function (item) {
                  item.dtInicioFormat = item.dtInicio ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(item.dtInicio).format('DD/MM/YYYY') : '';
                });
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_3__services_usuario__["a" /* default */].getUsuarios();

              case 10:
                this.usuarios = _context2.sent;

                this.setLoading(false);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function buscar() {
        return _ref.apply(this, arguments);
      }

      return buscar;
    }(),
    novo: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.dialog = true;
                this.editando = false;
                this.model = {
                  nome: "",
                  etapas: [],
                  usuarios: []
                };

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function novo() {
        return _ref2.apply(this, arguments);
      }

      return novo;
    }(),

    deleteItem: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(even) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.dialogConfirmation) {
                  _context4.next = 5;
                  break;
                }

                this.dialogConfirmation = true;
                this.excluindo = even;
                _context4.next = 12;
                break;

              case 5:
                _context4.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__services_cliente__["a" /* default */].remove(even);

              case 7:
                this.dialogConfirmation = false;
                this.excluindo = null;
                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_4__services_cliente__["a" /* default */].getClientes();

              case 11:
                this.clientes = _context4.sent;

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteItem(_x) {
        return _ref3.apply(this, arguments);
      }

      return deleteItem;
    }(),
    bloquear: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(even) {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.dialogBlock) {
                  _context5.next = 5;
                  break;
                }

                this.dialogBlock = true;
                this.bloqueando = even;
                _context5.next = 15;
                break;

              case 5:
                this.setLoading(true);
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4__services_cliente__["a" /* default */].bloquear(even);

              case 8:
                res = _context5.sent;

                this.dialogBlock = false;
                this.bloqueando = null;
                _context5.next = 13;
                return __WEBPACK_IMPORTED_MODULE_4__services_cliente__["a" /* default */].getClientes();

              case 13:
                this.clientes = _context5.sent;

                this.setLoading(false);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function bloquear(_x2) {
        return _ref4.apply(this, arguments);
      }

      return bloquear;
    }(),
    editItem: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(even) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_usuario__["a" /* default */].getUsuarios();

              case 2:
                this.usuarios = _context6.sent;

                this.dialog = true;
                this.editando = true;
                this.model = even;

                this.model.internal = undefined;
                this.model.flags = undefined;
                if (!this.model.etapas) {
                  this.model.etapas = [];
                }
                if (!this.model.usuarios) {
                  this.model.usuarios = [];
                }
                if (this.model.dtInicio) {
                  this.model.dtInicio = new Date(this.model.dtInicio).toISOString().substr(0, 10);
                }

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function editItem(_x3) {
        return _ref5.apply(this, arguments);
      }

      return editItem;
    }(),
    save: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var errors, res, _res;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.$validator.validate();

              case 2:
                errors = _context7.sent;

                if (!errors) {
                  _context7.next = 33;
                  break;
                }

                if (!this.editando) {
                  _context7.next = 20;
                  break;
                }

                _context7.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__services_cliente__["a" /* default */].save(this.model);

              case 7:
                res = _context7.sent;

                if (!(res.data && res.data.error)) {
                  _context7.next = 13;
                  break;
                }

                this.message = res.data.error.data;
                this.dialogError = true;
                _context7.next = 17;
                break;

              case 13:
                this.clear();
                _context7.next = 16;
                return __WEBPACK_IMPORTED_MODULE_4__services_cliente__["a" /* default */].getClientes();

              case 16:
                this.clientes = _context7.sent;

              case 17:
                this.editando = false;
                _context7.next = 33;
                break;

              case 20:
                _context7.next = 22;
                return __WEBPACK_IMPORTED_MODULE_4__services_cliente__["a" /* default */].save(this.model);

              case 22:
                _res = _context7.sent;

                if (!(_res.data && _res.data.error)) {
                  _context7.next = 28;
                  break;
                }

                this.message = _res.data.error.data;
                this.dialogError = true;
                _context7.next = 32;
                break;

              case 28:
                this.clear();
                _context7.next = 31;
                return __WEBPACK_IMPORTED_MODULE_4__services_cliente__["a" /* default */].getClientes();

              case 31:
                this.clientes = _context7.sent;

              case 32:
                this.editando = false;

              case 33:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function save() {
        return _ref6.apply(this, arguments);
      }

      return save;
    }(),
    clear: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.model = {
                  email: "",
                  password: ""
                };
                this.editando = false;
                this.$validator.reset();
                this.dialog = false;
                _context8.next = 6;
                return this.buscar();

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function clear() {
        return _ref7.apply(this, arguments);
      }

      return clear;
    }()
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Devedores_vue_vue_type_script_lang_js___ = __webpack_require__(266);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Devedores_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_devedores__ = __webpack_require__(13);




//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      message: '',
      search: '',
      tipo: 'cpf',
      dialogError: false,
      dialogConfirmation: false,
      dialogDevedor: false,
      editando: false,
      user: null,
      excluindo: {},
      devedores: [],
      carregando: false,

      maskCPF: '###.###.###-##',
      maskCNPJ: '##.###.###/####-##',
      totalDevedores: 0,
      desserts: [],
      loading: true,
      options: {},
      menu2: false,
      date2: new Date().toISOString().substr(0, 10),
      model: {},
      headers: [{
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'Nome'
      }, {
        text: 'Endereco',
        align: 'left',
        sortable: true,
        value: 'Endereco'
      }, { text: 'Ações', value: 'action', sortable: false }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__services_usuario__["a" /* default */].getUsuario(_this.$store.getters.user._id);

            case 2:
              _this.user = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    computedDateFormatted2: function computedDateFormatted2() {
      return this.formatDate(this.date2);
    }
  },
  watch: {
    options: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getDataFromApi();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function options() {
        return _ref.apply(this, arguments);
      }

      return options;
    }(),
    date2: function date2(val) {
      this.dateFormatted2 = this.formatDate(this.date2);
      this.model.DataNascimento = this.date2;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
    },

    getDataFromApi: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _options, sortBy, sortDesc, page, itemsPerPage, items;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loading = true;

                //this.setLoading(true);
                _options = this.options, sortBy = _options.sortBy, sortDesc = _options.sortDesc, page = _options.page, itemsPerPage = _options.itemsPerPage;

                this.options.search = this.search;
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7__services_devedores__["a" /* default */].getPagination(this.options);

              case 5:
                items = _context3.sent;


                if (sortBy.length === 1 && sortDesc.length === 1) {
                  items.data = items.data.sort(function (a, b) {
                    var sortA = a[sortBy[0]];
                    var sortB = b[sortBy[0]];

                    if (sortDesc[0]) {
                      if (sortA < sortB) return 1;
                      if (sortA > sortB) return -1;
                      return 0;
                    } else {
                      if (sortA < sortB) return -1;
                      if (sortA > sortB) return 1;
                      return 0;
                    }
                  });
                }

                this.devedores = items.data;
                this.totalDevedores = items.count;
                //this.setLoading(false);
                this.loading = false;

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getDataFromApi() {
        return _ref2.apply(this, arguments);
      }

      return getDataFromApi;
    }(),
    save: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var errors, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$validator.validate();

              case 2:
                errors = _context4.sent;

                if (!errors) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_7__services_devedores__["a" /* default */].save(this.model);

              case 6:
                res = _context4.sent;

                if (!(res.data && res.data.error)) {
                  _context4.next = 12;
                  break;
                }

                this.message = res.data.error.data;
                this.dialogError = true;
                _context4.next = 16;
                break;

              case 12:
                this.model = {};
                this.dialogDevedor = false;
                _context4.next = 16;
                return this.getDataFromApi();

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function save() {
        return _ref3.apply(this, arguments);
      }

      return save;
    }(),

    deleteItem: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(even) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.dialogConfirmation) {
                  _context5.next = 5;
                  break;
                }

                this.dialogConfirmation = true;
                this.excluindo = even;
                _context5.next = 11;
                break;

              case 5:
                _context5.next = 7;
                return __WEBPACK_IMPORTED_MODULE_7__services_devedores__["a" /* default */].remove(even);

              case 7:
                this.dialogConfirmation = false;
                this.excluindo = null;
                _context5.next = 11;
                return this.getDataFromApi();

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteItem(_x) {
        return _ref4.apply(this, arguments);
      }

      return deleteItem;
    }(),
    clear: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.model = {};
                this.editando = false;
                this.dialogDevedor = false;
                _context6.next = 5;
                return this.getDataFromApi();

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function clear() {
        return _ref5.apply(this, arguments);
      }

      return clear;
    }(),
    novo: function novo() {
      this.model = {};
      this.dialogDevedor = true;
    },
    editItem: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(even) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:

                this.dialogDevedor = true;
                this.editando = true;
                this.model = even;

                this.model.internal = undefined;
                this.model.flags = undefined;
                if (this.model.DataNascimento) {
                  this.date2 = new Date(this.model.DataNascimento).toISOString().substr(0, 10);
                } else {
                  this.date2 = null;
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function editItem(_x2) {
        return _ref6.apply(this, arguments);
      }

      return editItem;
    }()
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Dividas_vue_vue_type_script_lang_js___ = __webpack_require__(268);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Dividas_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_dividas__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_cliente__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_enderecodeve__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_telefonedeve__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_buscacep__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_emaildeve__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_v_money__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_js2excel__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_js2excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_js2excel__);





//
//
//
//
















function csvJSON(csv) {
  var lines = csv.split("\n");

  var result = [];
  var countcoma = lines[0].match(/,/g);
  var countpont = lines[0].match(/;/g);
  var char = ',';
  if (countcoma && countpont) {
    char = countcoma.length > countpont.length ? ',' : ';';
  } else {
    char = countcoma ? ',' : ';';
  }
  for (var i = 1; i < lines.length; i++) {
    lines[i] = lines[i].trim();
  }

  var headers = lines[0].split(char);
  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split(char);
    for (var j = 0; j < headers.length; j++) {
      obj[headers[j].trim()] = currentline[j];
    }
    result.push(obj);
  }
  return result; //JSON
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    var _ref;

    return _ref = {
      active: 0,
      search: '',
      filtros: {},
      clientes: [],
      message: '',
      problemas: '',
      tarefa: '',
      dialog: false,
      dialogNovo: false,
      dialogImport: false,
      menu: false,
      dialogError: false,
      dialogConfirmation: false,
      editando: false,
      carregando: false,
      user: null,
      excluindo: {},
      importaCliente: null,
      parseCsv: [],
      usuarios: [],
      dividas: [],
      filtered: []
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "clientes", []), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "tipo", 'cpf'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "maskCEP", '#####-###'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "maskData", '##/##/####'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "maskCPF", '###.###.###-##'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "maskCNPJ", '##.###.###/####-##'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "mask", '(##) #####-####'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "money", {
      decimal: ',',
      thousands: '.',
      suffix: '',
      precision: 2
    }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "model", {
      nome: '',
      usuarios: [],
      etapas: []
    }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "tipoProdutos", [{
      tipoProduto: 1,
      descricao: "BOLETO"
    }, {
      tipoProduto: 2,
      descricao: "CHEQUE"
    }, {
      tipoProduto: 3,
      descricao: "NOTA"
    }, {
      tipoProduto: 4,
      descricao: "NOTA FISCAL"
    }, {
      tipoProduto: 5,
      descricao: "PROMISSORIA"
    }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "tipoJuros", [{
      tipoJuro: 1,
      descricao: "Dia"
    }, {
      tipoJuro: 2,
      descricao: "Mês"
    }, {
      tipoJuro: 3,
      descricao: "Ano"
    }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "headers", [{
      text: 'Empresa',
      align: 'left',
      sortable: true,
      value: 'idcliente.Nome'
    }, {
      text: 'Devedor',
      align: 'left',
      sortable: true,
      value: 'iddevedor.Nome'
    }, {
      text: 'Status Divida',
      align: 'left',
      sortable: true,
      value: 'StatusDivida'
    }, {
      text: 'Valor Divida',
      align: 'left',
      sortable: true,
      value: 'ValorDivida'
    }, { text: 'Ações', value: 'action', sortable: false }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "headersPdfs", [{
      text: 'Nome  Anexo',
      align: 'left',
      sortable: true,
      value: 'descricao'
    }, { text: 'Ações', value: 'action', sortable: false }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "headersCsv", [{
      text: 'Nome',
      align: 'left',
      sortable: true,
      value: 'Nome'
    }, {
      text: 'CPF',
      align: 'left',
      sortable: true,
      value: 'CnpjCpf'
    }, {
      text: 'DataNascimento',
      align: 'left',
      sortable: true,
      value: 'DataNascimento'
    }, {
      text: 'Endereco',
      align: 'left',
      sortable: true,
      value: 'Endereco'
    }, {
      text: 'contrato',
      align: 'left',
      sortable: true,
      value: 'contrato'
    }, {
      text: 'ValorDivida',
      align: 'left',
      sortable: true,
      value: 'ValorDivida'
    }, {
      text: 'ValorEmpresa',
      align: 'left',
      sortable: true,
      value: 'ValorEmpresa'
    }, {
      text: 'status',
      align: 'left',
      sortable: true,
      value: 'status'
    }, {
      text: 'DataDivida',
      align: 'left',
      sortable: true,
      value: 'DataDivida'
    }, {
      text: 'Especificacao',
      align: 'left',
      sortable: true,
      value: 'Especificacao'
    }, {
      text: 'Juros',
      align: 'left',
      sortable: true,
      value: 'Juros'
    }, {
      text: 'Tipo Juros',
      align: 'left',
      sortable: true,
      value: 'TipoJuros'
    }]), _ref;
  },

  computed: {
    computedDateInicio: function computedDateInicio() {
      return this.model.dtInicio ? __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.model.dtInicio).format('DD/MM/YYYY') : '';
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setLoading(true);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_10__services_cliente__["a" /* default */].getClientes();

            case 3:
              _this.clientes = _context.sent;
              _context.next = 6;
              return _this.buscarDividas();

            case 6:
              _this.setLoading(false);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    freteCep: function freteCep(postcode) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__services_buscacep__["a" /* default */].getCep(postcode.replace('-', ''));

              case 2:
                _this2.cep = _context2.sent;


                _this2.model.logradouro = _this2.cep.logradouro;
                _this2.model.bairro = _this2.cep.bairro;
                _this2.model.localidade = _this2.cep.localidade;
                _this2.model.uf = _this2.cep.uf;
                _this2.$forceUpdate();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    buscarDividas: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setLoading(true);

                if (!__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.user) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters.user._id);

              case 4:
                this.user = _context3.sent;

                if (!(this.user != null && this.user.acesso == "Cliente")) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].getDividas({ cliente: this.user.cliente, filtros: this.filtros });

              case 8:
                this.dividas = _context3.sent;
                _context3.next = 14;
                break;

              case 11:
                _context3.next = 13;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].getDividas({ filtros: this.filtros });

              case 13:
                this.dividas = _context3.sent;

              case 14:
                this.setLoading(false);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function buscarDividas() {
        return _ref2.apply(this, arguments);
      }

      return buscarDividas;
    }(),
    novo: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.dialogNovo = true;
                this.editando = false;
                // this.$refs.ValorDivida.$el.getElementsByTagName('input')[0].value = 0;
                // this.$refs.ValorEmpresa.$el.getElementsByTagName('input')[0].value = 0;
                this.model = {
                  nome: ""
                };

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function novo() {
        return _ref3.apply(this, arguments);
      }

      return novo;
    }(),

    deleteItem: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(even) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.dialogConfirmation) {
                  _context5.next = 5;
                  break;
                }

                this.dialogConfirmation = true;
                this.excluindo = even;
                _context5.next = 13;
                break;

              case 5:

                this.setLoading(true);
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].remove(even);

              case 8:
                this.dialogConfirmation = false;
                this.excluindo = null;
                _context5.next = 12;
                return this.buscarDividas();

              case 12:
                this.setLoading(false);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteItem(_x) {
        return _ref4.apply(this, arguments);
      }

      return deleteItem;
    }(),
    editItem: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(even) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.dialog = true;
                this.editando = true;
                this.model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, even);
                this.model.internal = undefined;
                this.model.flags = undefined;
                // this.$refs.ValorDivida.$el.getElementsByTagName('input')[0].value = even.ValorDivida;
                // this.$refs.ValorEmpresa.$el.getElementsByTagName('input')[0].value = even.ValorEmpresa;

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function editItem(_x2) {
        return _ref5.apply(this, arguments);
      }

      return editItem;
    }(),
    save: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var errors, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.setLoading(true);
                _context7.next = 3;
                return this.$validator.validate();

              case 3:
                errors = _context7.sent;

                console.log(errors);

                if (!errors) {
                  _context7.next = 19;
                  break;
                }

                _context7.next = 8;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].save(this.model);

              case 8:
                res = _context7.sent;

                if (!(res.data && res.data.error)) {
                  _context7.next = 14;
                  break;
                }

                this.message = res.data.error.data;
                this.dialogError = true;
                _context7.next = 17;
                break;

              case 14:
                this.clear();
                _context7.next = 17;
                return this.buscarDividas();

              case 17:

                this.setLoading(false);
                this.editando = false;

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function save() {
        return _ref6.apply(this, arguments);
      }

      return save;
    }(),
    clear: function clear() {
      this.model = {};
      this.editando = false;
      this.dialog = false;
      this.dialogNovo = false;
    },
    importCsv: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(e) {
        var vm, render;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                vm = this;

                if (window.FileReader) {
                  render = new FileReader();

                  render.readAsText(e.target.files[0]);
                  render.onload = function (event) {
                    var csv = event.target.result;
                    vm.parseCsv = csvJSON(csv);
                  };
                }

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function importCsv(_x3) {
        return _ref7.apply(this, arguments);
      }

      return importCsv;
    }(),
    getStatusDivida: function getStatusDivida(divida) {
      if (divida && divida.ValorRepasse === 0) {
        return 'Quitado';
      }
      if (divida.StatusDivida == 1) {
        return 'Processo Cobrança';
      } else if (divida.StatusDivida == 2) {
        return 'Aguardando Aprovação';
      } else if (divida.StatusDivida == 3) {
        return 'Acordo Vigente';
      } else if (divida.StatusDivida == 4) {
        return 'Acordo em Atraso';
      } else if (divida.StatusDivida == 5) {
        return 'Divida Bloqueada';
      } else if (divida.StatusDivida == 6) {
        return 'Deslocalizado';
      } else if (divida.StatusDivida == 8) {
        return 'Bloqueado';
      }
    },

    importar: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9(importaCliente, dividasImport) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, divida;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (importaCliente) {
                  _context9.next = 4;
                  break;
                }

                this.dialogError = true;
                this.message = "Cliente deve ser informado!";
                return _context9.abrupt("return");

              case 4:
                if (!(!dividasImport || dividasImport.length <= 0)) {
                  _context9.next = 8;
                  break;
                }

                this.dialogError = true;
                this.message = "Dividas devem ser informadas!";
                return _context9.abrupt("return");

              case 8:

                this.setLoading(true);
                this.problemas = "";
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context9.prev = 13;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator___default()(dividasImport);

              case 15:
                _context9.next = 17;
                return _iterator.next();

              case 17:
                _step = _context9.sent;
                _iteratorNormalCompletion = _step.done;
                _context9.next = 21;
                return _step.value;

              case 21:
                _value = _context9.sent;

                if (_iteratorNormalCompletion) {
                  _context9.next = 28;
                  break;
                }

                divida = _value;

                this.importarDividas(importaCliente, divida);

              case 25:
                _iteratorNormalCompletion = true;
                _context9.next = 15;
                break;

              case 28:
                _context9.next = 34;
                break;

              case 30:
                _context9.prev = 30;
                _context9.t0 = _context9["catch"](13);
                _didIteratorError = true;
                _iteratorError = _context9.t0;

              case 34:
                _context9.prev = 34;
                _context9.prev = 35;

                if (!(!_iteratorNormalCompletion && _iterator.return)) {
                  _context9.next = 39;
                  break;
                }

                _context9.next = 39;
                return _iterator.return();

              case 39:
                _context9.prev = 39;

                if (!_didIteratorError) {
                  _context9.next = 42;
                  break;
                }

                throw _iteratorError;

              case 42:
                return _context9.finish(39);

              case 43:
                return _context9.finish(34);

              case 44:
                this.setLoading(false);
                if (this.problemas.length > 1) {
                  this.dialogError = true;
                  this.message = this.problemas;
                } else {
                  this.dialogError = true;
                  this.message = "Dividas importadas com sucesso!";
                }
                _context9.next = 48;
                return this.buscarDividas();

              case 48:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[13, 30, 34, 44], [35,, 39, 43]]);
      }));

      function importar(_x4, _x5) {
        return _ref8.apply(this, arguments);
      }

      return importar;
    }(),
    importarDividas: function importarDividas(importaCliente, divida) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var devedor, endereco, telefone1, telefone2, telefone3, email, dividaimp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:

                _this3.setLoading(true);

                if (importaCliente) {
                  _context10.next = 6;
                  break;
                }

                _this3.dialogError = true;
                _this3.setLoading(false);
                _this3.message = "Cliente deve ser informado!";
                return _context10.abrupt("return");

              case 6:
                if (divida.Nome) {
                  _context10.next = 11;
                  break;
                }

                _this3.dialogError = true;
                _this3.setLoading(false);
                _this3.message = "Nome deve ser informado!";
                return _context10.abrupt("return");

              case 11:
                if (divida.CnpjCpf) {
                  _context10.next = 16;
                  break;
                }

                _this3.dialogError = true;
                _this3.setLoading(false);
                _this3.message = "CnpjCpf deve ser informado!";
                return _context10.abrupt("return");

              case 16:
                if (divida.DataDivida) {
                  _context10.next = 21;
                  break;
                }

                _this3.dialogError = true;
                _this3.setLoading(false);
                _this3.message = "Data da Divida deve ser informado!";
                return _context10.abrupt("return");

              case 21:
                if (divida.ValorDivida) {
                  _context10.next = 26;
                  break;
                }

                _this3.dialogError = true;
                _this3.setLoading(false);
                _this3.message = "Valor da Divida deve ser informado!";
                return _context10.abrupt("return");

              case 26:
                if (divida.Juros) {
                  _context10.next = 31;
                  break;
                }

                _this3.dialogError = true;
                _this3.setLoading(false);
                _this3.message = "Juros deve ser informado!";
                return _context10.abrupt("return");

              case 31:
                if (divida.ValorEmpresa) {
                  _context10.next = 36;
                  break;
                }

                _this3.dialogError = true;
                _this3.setLoading(false);
                _this3.message = "Valor da Empresa deve ser informado!";
                return _context10.abrupt("return");

              case 36:
                if (!(importaCliente && divida.Nome && divida.CnpjCpf && divida.DataDivida && divida.ValorDivida && divida.Juros && divida.ValorEmpresa)) {
                  _context10.next = 84;
                  break;
                }

                console.log("divida");
                _context10.prev = 38;
                devedor = {
                  Nome: divida.Nome,
                  CnpjCpf: divida.CnpjCpf,
                  Endereco: divida.Endereco,
                  DataNascimento: divida.DataNascimento,
                  TelefonePrincipal: divida.telefone1,
                  Telefone2: divida.telefone2,
                  IsAtivo: true
                };


                console.log(devedor);
                _context10.next = 43;
                return __WEBPACK_IMPORTED_MODULE_12__services_devedores__["a" /* default */].save(devedor);

              case 43:
                devedor = _context10.sent;
                endereco = {
                  cep: divida.cep,
                  logradouro: divida.logradouro,
                  numero: divida.numero,
                  bairro: divida.bairro,
                  localidade: divida.localidade,
                  uf: divida.uf,
                  hot: true,
                  devedor: devedor._id
                };


                console.log(endereco);
                _context10.next = 48;
                return __WEBPACK_IMPORTED_MODULE_11__services_enderecodeve__["a" /* default */].save(endereco);

              case 48:
                if (!divida.telefone1) {
                  _context10.next = 53;
                  break;
                }

                telefone1 = {
                  telefone: divida.telefone1,
                  hot: true,
                  devedor: devedor._id
                };

                console.log("telefone1", telefone1);
                _context10.next = 53;
                return __WEBPACK_IMPORTED_MODULE_13__services_telefonedeve__["a" /* default */].save(telefone1);

              case 53:
                if (!divida.telefone2) {
                  _context10.next = 58;
                  break;
                }

                telefone2 = {
                  telefone: divida.telefone2,
                  hot: false,
                  devedor: devedor._id
                };


                console.log(telefone2);
                _context10.next = 58;
                return __WEBPACK_IMPORTED_MODULE_13__services_telefonedeve__["a" /* default */].save(telefone2);

              case 58:
                if (!divida.telefone3) {
                  _context10.next = 63;
                  break;
                }

                telefone3 = {
                  telefone: divida.telefone3,
                  hot: false,
                  devedor: devedor._id
                };


                console.log(telefone3);
                _context10.next = 63;
                return __WEBPACK_IMPORTED_MODULE_13__services_telefonedeve__["a" /* default */].save(telefone3);

              case 63:
                if (!divida.email) {
                  _context10.next = 68;
                  break;
                }

                email = {
                  email: divida.email,
                  hot: true,
                  devedor: devedor._id
                };


                console.log(email);
                _context10.next = 68;
                return __WEBPACK_IMPORTED_MODULE_15__services_emaildeve__["a" /* default */].save(email);

              case 68:
                dividaimp = {
                  Identificador: divida.contrato,
                  TipoProduto: divida.TipoProduto,
                  TipoJuro: divida.TipoJuros,
                  Especificacao: divida.Especificacao,
                  DataDivida: divida.DataDivida,
                  ValorDivida: divida.ValorDivida,
                  Juros: divida.Juros,
                  ValorEmpresa: divida.ValorEmpresa,
                  StatusDivida: '1',
                  Ativo: true,
                  idcliente: importaCliente,
                  iddevedor: devedor._id
                };


                console.log(dividaimp);
                _context10.next = 72;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].save(dividaimp);

              case 72:
                _context10.next = 81;
                break;

              case 74:
                _context10.prev = 74;
                _context10.t0 = _context10["catch"](38);

                _this3.problemas = _this3.problemas + _context10.t0.message + " Linha sem valores: Nome " + divida.Nome + " CnpjCpf " + divida.CnpjCpf + " DataDivida " + divida.DataDivida + " ValorDivida " + divida.ValorDivida + " Juros " + divida.Juros + " ValorEmpresa: " + divida.ValorEmpresa;
                _this3.dialogError = true;
                _this3.setLoading(false);
                _this3.message = _context10.t0.message;
                return _context10.abrupt("return");

              case 81:

                _this3.dialogNovo = false;
                _context10.next = 85;
                break;

              case 84:
                _this3.problemas = _this3.problemas + "Linha sem valores: Nome " + divida.Nome + " CnpjCpf " + divida.CnpjCpf + " DataDivida " + divida.DataDivida + " ValorDivida " + divida.ValorDivida + " Juros " + divida.Juros + " ValorEmpresa: " + divida.ValorEmpresa;

              case 85:

                _this3.setLoading(false);

              case 86:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this3, [[38, 74]]);
      }))();
    },
    exportarExcel: function exportarExcel() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var data, dividas;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                data = [];
                dividas = [];


                _this4.setLoading(true);

                if (!(_this4.user != null && _this4.user.acesso == "Cliente")) {
                  _context11.next = 9;
                  break;
                }

                _context11.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].getDividas2({ cliente: _this4.user.cliente, filtros: _this4.filtros });

              case 6:
                dividas = _context11.sent;
                _context11.next = 12;
                break;

              case 9:
                _context11.next = 11;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].getDividas2({ filtros: _this4.filtros });

              case 11:
                dividas = _context11.sent;

              case 12:
                _this4.setLoading(false);

                dividas.forEach(function (divida) {
                  var object = {};
                  if (_this4.user.acesso == "Admin") {
                    object = {
                      "Contrato": divida.Identificador,
                      "Empresa": divida.clienteNome,
                      "Devedor": divida.devedorNome,
                      "CPF": divida.devedorCnpjCpf,
                      "Status Divida": _this4.getStatusDivida(divida),
                      "Devedor Bloqueado": divida.devedorIsAtivo ? 'Não' : 'Sim',
                      "Data Nascimento": divida.devedorDataNascimento,
                      "Telefone 1": divida.telefones && divida.telefones[0] ? divida.telefones[0].telefone : '',
                      "Telefone 2": divida.telefones && divida.telefones[1] ? divida.telefones[1].telefone : '',
                      "Telefone 3": divida.telefones && divida.telefones[2] ? divida.telefones[2].telefone : '',
                      "Especificação": divida.Especificacao,
                      "Tipo Produto": divida.TipoProduto,
                      "Juro": divida.Juros,
                      "Tipo Juro": divida.TipoJuro,
                      "Data da Divida": divida.DataDivida,
                      "Valor Divida": divida.ValorDivida,
                      "Valor Empresa": divida.ValorEmpresa
                    };
                  } else if (_this4.user.acesso == "Cliente") {
                    object = {
                      "Contrato": divida.Identificador,
                      "Empresa": divida.clienteNome,
                      "Devedor": divida.devedorNome,
                      "CPF": divida.devedorCnpjCpf,
                      "Status Divida": _this4.getStatusDivida(divida),
                      "Devedor Bloqueado": divida.devedorIsAtivo ? 'Não' : 'Sim',
                      "Data Nascimento": divida.devedorDataNascimento,
                      "Especificação": divida.Especificacao,
                      "Tipo Produto": divida.TipoProduto,
                      "Data da Divida": divida.DataDivida,
                      "Valor Divida": divida.ValorDivida
                    };
                  }

                  data.push(object);
                });
                try {
                  Object(__WEBPACK_IMPORTED_MODULE_18_js2excel__["json2excel"])({
                    data: data,
                    name: 'dividas',
                    formateDate: 'dd/mm/yyyy'
                  });
                } catch (e) {
                  console.error('export error');
                }

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this4);
      }))();
    },
    exportarExcelTodas: function exportarExcelTodas() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var dividas, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:

                _this5.setLoading(true);
                _context12.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].getDividasAll();

              case 3:
                dividas = _context12.sent;
                data = [];

                dividas.forEach(function (divida) {
                  var object = {
                    "Contrato": divida.Identificador,
                    "Empresa": divida.clienteNome,
                    "Devedor": divida.devedorNome,
                    "CPF": divida.devedorCnpjCpf,
                    "Status Divida": _this5.getStatusDivida(divida),
                    "Devedor Bloqueado": divida.devedorIsAtivo ? 'Não' : 'Sim',
                    "Data Nascimento": divida.devedorDataNascimento,
                    // "Endereço": divida.iddevedor?divida.iddevedor.Endereco:'',
                    // "Telefone": divida.iddevedor?divida.iddevedor.TelefonePrincipal:'',
                    "Especificação": divida.Especificacao,
                    "Tipo Produto": divida.TipoProduto,
                    "Juro": divida.Juros,
                    "Tipo Juro": divida.TipoJuro,
                    "Data da Divida": divida.DataDivida,
                    "Valor Divida": divida.ValorDivida,
                    "Valor Empresa": divida.ValorEmpresa
                  };

                  data.push(object);
                });
                try {
                  Object(__WEBPACK_IMPORTED_MODULE_18_js2excel__["json2excel"])({
                    data: data,
                    name: 'TodasDividas',
                    formateDate: 'dd/mm/yyyy'
                  });

                  _this5.setLoading(false);
                } catch (e) {
                  _this5.setLoading(false);
                  console.error('export error');
                }

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this5);
      }))();
    },

    onFileChangePdf: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13($event) {
        var files, payload, i, file, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.setLoading(true);
                _context13.prev = 1;
                files = $event.target.files || $event.dataTransfer.files;

                if (!files) {
                  _context13.next = 16;
                  break;
                }

                payload = new FormData();

                payload.set('divida', this.model._id);
                payload.set('tipo', "pdf");

                if (!(files.length > 0)) {
                  _context13.next = 16;
                  break;
                }

                for (i = 0; i < files.length; i++) {
                  file = files[i];

                  payload.append('filename', file);
                }
                _context13.next = 11;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].saveDividaImage(payload);

              case 11:
                res = _context13.sent;
                _context13.next = 14;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].getDividaId(this.model._id);

              case 14:
                this.model = _context13.sent;

                this.setLoading(false);

              case 16:
                _context13.next = 21;
                break;

              case 18:
                _context13.prev = 18;
                _context13.t0 = _context13["catch"](1);

                this.setLoading(false);

              case 21:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[1, 18]]);
      }));

      function onFileChangePdf(_x6) {
        return _ref9.apply(this, arguments);
      }

      return onFileChangePdf;
    }(),

    deleteImage: function deleteImage(item) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this6.setLoading(true);
                _context14.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].removeDividaImage(item, _this6.model._id);

              case 3:
                res = _context14.sent;
                _context14.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__services_dividas__["a" /* default */].getDividaId(_this6.model._id);

              case 6:
                _this6.model = _context14.sent;


                _this6.setLoading(false);

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this6);
      }))();
    },
    getFiltered: function getFiltered(e) {
      console.log(e);
      this.filtered = e;
    },
    forceFileDownload: function forceFileDownload(response) {
      var url = window.URL.createObjectURL(new Blob([response.data]));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'file.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios: function downloadWithAxios(url) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default()({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(function (response) {

        _this7.forceFileDownload(response);
      }).catch(function () {
        return console.log('error occured');
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setDevedor: "setDevedor"
  })),
  directives: { money: __WEBPACK_IMPORTED_MODULE_17_v_money__["VMoney"] }
});

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Financeiro_vue_vue_type_script_lang_js___ = __webpack_require__(272);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Financeiro_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_acordo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_email__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_juno__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(5);





//
//







function getPosition(string, subString, index) {
  return string.split(subString, index).join(subString).length;
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Endereco',
  data: function data() {
    return {

      valid: true,
      acordo: {},
      dialogPagar: false,
      dialogConfirmation: false,
      dialogParcela: false,
      dialogEmail: false,
      editando: false,
      excluindo: {},
      cep: {},
      model: {},
      acordos: [],
      message: "",
      dialogError: false,
      menu: false,
      menu2: false,
      filtros: { status: [2], date: new Date().toISOString().substr(0, 7) },
      statusContratos: [{ id: 2, nome: 'Aguardando Aprovação' }, { id: 3, nome: 'Acordo Vigente' }, { id: 4, nome: 'Acordo Vigente não pagos' }, { id: 9, nome: 'Acordo Cancelado' }],
      headersAcordo: [{
        text: 'Nome Operador',
        align: 'left',
        sortable: true,
        value: 'acordo.user.name'
      }, {
        text: 'Nome Empresa',
        align: 'left',
        sortable: true,
        value: 'acordo.cliente.Nome',
        width: '20%'
      }, {
        text: 'Nome Devedor',
        align: 'left',
        sortable: true,
        value: 'acordo.devedor.Nome'
      }, {
        text: 'Valor Acordo',
        align: 'left',
        sortable: true,
        value: 'acordo.ValorAcordo'
      }, {
        text: 'Tipo Acordo',
        align: 'left',
        sortable: true,
        value: 'acordo.proposta'
      }, {
        text: 'Tipo Pagamento',
        align: 'left',
        sortable: true,
        value: 'acordo.tipoPagamento'
      }, {
        text: 'Tipo Negociação',
        align: 'left',
        sortable: true,
        value: 'acordo.tipoNegociacao'
      }, {
        text: 'Comentarios',
        align: 'left',
        sortable: true,
        value: 'acordo.detalhes'
      }, {
        text: 'Status Acordo',
        align: 'left',
        sortable: true,
        value: 'acordo.StatusAcordo'
      }, {
        text: 'Data Acordo',
        align: 'left',
        sortable: true,
        value: 'acordo.createdAt'
      }, {
        text: 'Data Divida',
        align: 'left',
        sortable: true,
        value: 'acordo.DataDivida'
      }, {
        text: 'Saldo Inicial',
        align: 'left',
        sortable: true,
        value: 'acordo.ValorDivida'
      }],
      headersParcelas: [{
        text: 'Numero',
        value: 'numero'
      }, {
        text: 'Vencimento',
        value: 'vencimento'
      }, {
        text: 'Valor',
        value: 'valor'
      }, {
        text: 'Valor Cliente',
        value: 'cliente'
      }, {
        text: 'Valor Assoc',
        value: 'valorAssoc'
      }, {
        text: 'Valor Juros',
        value: 'valorJuros'
      }, {
        text: 'Valor Bruto',
        value: 'valorReceita'
      }, {
        text: 'Ações',
        value: 'action'
      }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setLoading(true);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5__services_acordo__["a" /* default */].getFinanc(_this.filtros);

            case 3:
              _this.acordos = _context.sent;

              _this.setLoading(false);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    buscar: function buscar() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.setLoading(true);
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_acordo__["a" /* default */].getFinanc(_this2.filtros);

              case 3:
                _this2.acordos = _context2.sent;

                _this2.setLoading(false);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    abrirAcordo: function abrirAcordo(acordo) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.acordo = acordo;
                _this3.dialogParcela = true;

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getColorAcordo: function getColorAcordo(acordo) {
      if (acordo && acordo.dtPagamento) return 'green';
    },
    enviarEmail: function enviarEmail(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_email__["a" /* default */].sendMessageParcela(item);

              case 2:
                _this4.dialogEmail = false;
                _this4.model = {};

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    pagar: function pagar(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.dialogPagar = true;
                item.dtPagamento = new Date().toISOString().substr(0, 10);
                _this5.model = item;

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    cancelar: function cancelar(item) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.dialogConfirmation = true;
                _this6.model = item;

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    getDiasAtraso: function getDiasAtraso(data) {
      if (data) {
        var mes = data.substring(getPosition(data, '/', 1) + 1, getPosition(data, '/', 2) + 1);
        data = data.replace(mes, '');
        data = mes + data;
        var toDate = new Date(data);
        var result = new Date().getTime() - toDate.getTime();
        result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default()(result / 1000 / 60 / 60 / 24);
        return result;
      }
      return null;
    },
    getMesesAtraso: function getMesesAtraso(data) {
      if (data) {
        var mes = data.substring(getPosition(data, '/', 1) + 1, getPosition(data, '/', 2) + 1);
        data = data.replace(mes, '');
        data = mes + data;
        var toDate = new Date(data);
        var result = new Date().getTime() - toDate.getTime();
        result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default()(result / 1000 / 60 / 60 / 24 / 30);
        return result;
      }
      return null;
    },
    getAnosAtraso: function getAnosAtraso(data) {
      if (data) {
        var mes = data.substring(getPosition(data, '/', 1) + 1, getPosition(data, '/', 2) + 1);
        data = data.replace(mes, '');
        data = mes + data;
        var toDate = new Date(data);
        var result = new Date().getTime() - toDate.getTime();
        result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default()(result / 1000 / 60 / 60 / 24 / 30 / 12);
        return result;
      }
      return null;
    },
    pagarParcela: function pagarParcela(item) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this7.setLoading(true);
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_juno__["a" /* default */].pagarParcela(item);

              case 4:
                response = _context7.sent;

                _this7.setLoading(false);
                _this7.dialogParcela = false;
                _this7.buscar();
                if (response.stPago == 'S') {
                  _this7.message = "Parcela paga com sucesso! Deseja enviar Email?";
                  _this7.dialogEmail = true;
                } else {
                  _this7.message = "Parcela cancelada com sucesso!";
                  _this7.dialogError = true;
                  _this7.model = {};
                }

                _this7.dialogPagar = false;
                _this7.dialogConfirmation = false;
                _context7.next = 20;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](0);

                _this7.message = _context7.t0.message;
                _this7.dialogError = true;
                _this7.model = {};
                _this7.dialogPagar = false;
                _this7.dialogConfirmation = false;

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 13]]);
      }))();
    },
    buscaValorDesconto: function buscaValorDesconto(parcelas) {
      if (parcelas && parcelas.length > 0) {
        var retorno = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parcelas), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            retorno += Number(item.cliente) + Number(item.valorAssoc ? item.valorAssoc : 0) + Number(item.valorJuros ? item.valorJuros : 0);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return retorno;
      } else {
        return 0;
      }
    },
    buscaValorCliente: function buscaValorCliente(parcelas) {
      if (parcelas && parcelas.length > 0) {
        var retorno = 0;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parcelas), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            retorno += Number(item.cliente);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return retorno;
      } else {
        return 0;
      }
    },
    getStatusAcordo: function getStatusAcordo(status) {
      if (status == 1) {
        return 'Processo Cobrança';
      } else if (status == 2) {
        return 'Aguardando Aprovação';
      } else if (status == 3) {
        return 'Acordo Vigente';
      } else if (status == 4) {
        return 'Acordo em Atraso';
      } else if (status == 9) {
        return 'Acordo Cancelado';
      } else if (status == 6) {
        return 'Acordo Liquidado';
      }
    },
    getProposta: function getProposta(proposta) {
      if (proposta == 1) {
        return 'Fixa';
      } else if (proposta == 2) {
        return 'Exceção';
      } else if (proposta == 3) {
        return 'Gerado Devedor';
      }
    },
    getPagamento: function getPagamento(pagamento) {
      if (pagamento == 1) {
        return 'Boleto';
      } else if (pagamento == 2) {
        return 'Deposito';
      } else if (pagamento == 3) {
        return 'Escritório';
      } else if (pagamento == 4) {
        return 'Na Loja';
      } else if (pagamento == 5) {
        return 'Pix';
      }
    },
    getNegociacao: function getNegociacao(pagamento) {
      if (pagamento == 1) {
        return 'Acordo Novo';
      } else if (pagamento == 2) {
        return 'Reativação';
      } else if (pagamento == 3) {
        return 'Renegociação';
      }
    },
    saveAcordo: function saveAcordo(acor) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_acordo__["a" /* default */].save(acor);

              case 2:
                _context8.next = 4;
                return _this8.buscar();

              case 4:
                _this8.dialogParcela = false;
                _this8.message = "Acordo salvo com sucesso!";
                _this8.dialogError = true;

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    confirmItem: function confirmItem(acor) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                acor.StatusAcordo = '3';
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_acordo__["a" /* default */].save(acor);

              case 3:
                _context9.next = 5;
                return _this9.buscar();

              case 5:
                _this9.dialogParcela = false;
                _this9.message = "Acordo aprovado com sucesso!";
                _this9.dialogError = true;

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    recuseItem: function recuseItem(acor) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                acor.StatusAcordo = '9';
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_acordo__["a" /* default */].save(acor);

              case 3:
                _context10.next = 5;
                return _this10.buscar();

              case 5:
                _this10.dialogParcela = false;
                _this10.message = "Acordo recusado com sucesso!";
                _this10.dialogError = true;

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  sendMessageParcela: function sendMessageParcela(model) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context.next = 4;
              return instance.post("/email/sendMessageParcela", model, headers);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context.t0.response.data.message);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },
  sendMessageCliente: function sendMessageCliente(model) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var headers, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") } };
              _context2.next = 4;
              return instance.post("/email/sendMessageCliente", model, headers);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0.response);
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setError', _context2.t0.response.data.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Recebimento_vue_vue_type_script_lang_js___ = __webpack_require__(275);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Recebimento_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncIterator__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_acordo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_juno__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_cliente__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_js2excel__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_js2excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_js2excel__);





//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Endereco',
  data: function data() {
    return {
      valid: true,
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      user: {},
      acordo: {},
      dialogConfirmation: false,
      dialogError: false,
      dialogParcela: false,
      editando: false,
      message: "",
      excluindo: {},
      cep: {},
      devedor: {},
      filtros: {},
      parcelas: [],
      funcionarios: [],
      clientes: [],
      headersParcelas: [{
        text: 'Numero',
        value: 'numero'
      }, {
        text: 'Vencimento',
        value: 'vencimento'
      }, {
        text: 'Valor',
        value: 'valor'
      }, {
        text: 'Data Pagamento',
        value: 'dtPagamento'
      }]
    };
  },

  computed: {
    headersParcela: function headersParcela() {

      var items = [];
      if (__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user) {

        if (this.user.acesso == "Cliente") {
          items = [{
            text: 'Nome Devedor',
            align: 'left',
            sortable: true,
            value: 'acordo.devedor.Nome'
          }, {
            text: 'CPF Devedor',
            align: 'left',
            sortable: true,
            value: 'acordo.devedor.CnpjCpf'
          }, {
            text: 'Vencimento',
            align: 'left',
            sortable: true,
            value: 'vencimento'
          }, {
            text: 'Data Pagamento',
            align: 'left',
            sortable: true,
            value: 'dtPagamento'
          }, {
            text: 'Status',
            align: 'left',
            sortable: true,
            value: 'status'
          }, {
            text: 'Nr Parcela',
            align: 'left',
            sortable: true,
            value: 'numero'
          }, {
            text: 'Valor Bruto',
            align: 'left',
            sortable: true,
            value: 'valor'
          }, {
            text: 'Forma de Pagamento',
            align: 'left',
            sortable: true,
            value: 'tipoPagamento'
          }, {
            text: 'Empresa',
            align: 'left',
            sortable: true,
            value: 'acordo.cliente.Nome'
          }];
        } else if (this.user.acesso == "Funcionario") {
          items = [{
            text: 'Nome Devedor',
            align: 'left',
            sortable: true,
            value: 'acordo.devedor.Nome'
          }, {
            text: 'CPF Devedor',
            align: 'left',
            sortable: true,
            value: 'acordo.devedor.CnpjCpf'
          }, {
            text: 'Vencimento',
            align: 'left',
            sortable: true,
            value: 'vencimento'
          }, {
            text: 'Data Pagamento',
            align: 'left',
            sortable: true,
            value: 'dtPagamento'
          }, {
            text: 'Status',
            align: 'left',
            sortable: true,
            value: 'status'
          }, {
            text: 'Nr Parcela',
            align: 'left',
            sortable: true,
            value: 'numero'
          }, {
            text: 'Valor Parcela',
            align: 'left',
            sortable: true,
            value: 'valor'
          }, {
            text: 'Forma de Pagamento',
            align: 'left',
            sortable: true,
            value: 'tipoPagamento'
          }, {
            text: 'Empresa',
            align: 'left',
            sortable: true,
            value: 'acordo.cliente.Nome'
          }, {
            text: 'Ações',
            value: 'action'
          }];
        } else {
          items = [{
            text: 'Nome Devedor',
            align: 'left',
            sortable: true,
            value: 'acordo.devedor.Nome'
          }, {
            text: 'CPF Devedor',
            align: 'left',
            sortable: true,
            value: 'acordo.devedor.CnpjCpf'
          }, {
            text: 'Vencimento',
            align: 'left',
            sortable: true,
            value: 'vencimento'
          }, {
            text: 'Data Pagamento',
            align: 'left',
            sortable: true,
            value: 'dtPagamento'
          }, {
            text: 'Status',
            align: 'left',
            sortable: true,
            value: 'status'
          }, {
            text: 'Nr Parcela',
            align: 'left',
            sortable: true,
            value: 'numero'
          }, {
            text: 'Valor Parcela',
            align: 'left',
            sortable: true,
            value: 'valor'
          }, {
            text: 'Valor Cliente',
            align: 'left',
            sortable: true,
            value: 'cliente'
          }, {
            text: 'Valor Assoc',
            align: 'left',
            sortable: true,
            value: 'valorAssoc'
          }, {
            text: 'Valor Juros',
            align: 'left',
            sortable: true,
            value: 'valorJuros'
          }, {
            text: 'Valor Bruto',
            align: 'left',
            sortable: true,
            value: 'valor'
          }, {
            text: 'Forma de Pagamento',
            align: 'left',
            sortable: true,
            value: 'tipoPagamento'
          }, {
            text: 'Forma de Negociação',
            align: 'left',
            sortable: true,
            value: 'tipoNegociacao'
          }, {
            text: 'Empresa',
            align: 'left',
            sortable: true,
            value: 'acordo.cliente.Nome'
          }, {
            text: 'Ações',
            value: 'action'
          }];
        }
      }

      return items;
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var items;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              items = [];

              _this.setLoading(true);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_12__services_cliente__["a" /* default */].getClientes();

            case 4:
              _this.clientes = _context.sent;
              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_11__services_usuario__["a" /* default */].getFuncionarios();

            case 7:
              _this.funcionarios = _context.sent;

              console.log(_this.$route.params.id);

              if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user) {
                _context.next = 15;
                break;
              }

              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_11__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user._id);

            case 12:
              _this.user = _context.sent;
              _context.next = 15;
              return _this.buscarParcelas(_this.$route.params.id);

            case 15:
              _this.setLoading(false);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    '$route': function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setLoading(true);

                if (!__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_11__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user._id);

              case 4:
                this.user = _context2.sent;
                _context2.next = 7;
                return this.buscarParcelas(this.$route.params.id);

              case 7:
                this.setLoading(false);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function $route() {
        return _ref.apply(this, arguments);
      }

      return $route;
    }()
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    abrirAcordo: function abrirAcordo(acordo) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, parcela;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 3;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncIterator___default()(acordo.parcelas);

              case 5:
                _context3.next = 7;
                return _iterator.next();

              case 7:
                _step = _context3.sent;
                _iteratorNormalCompletion = _step.done;
                _context3.next = 11;
                return _step.value;

              case 11:
                _value = _context3.sent;

                if (_iteratorNormalCompletion) {
                  _context3.next = 20;
                  break;
                }

                parcela = _value;
                _context3.next = 16;
                return __WEBPACK_IMPORTED_MODULE_9__services_juno__["a" /* default */].get(parcela._id);

              case 16:
                parcela.juno = _context3.sent;

              case 17:
                _iteratorNormalCompletion = true;
                _context3.next = 5;
                break;

              case 20:
                _context3.next = 26;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 26:
                _context3.prev = 26;
                _context3.prev = 27;

                if (!(!_iteratorNormalCompletion && _iterator.return)) {
                  _context3.next = 31;
                  break;
                }

                _context3.next = 31;
                return _iterator.return();

              case 31:
                _context3.prev = 31;

                if (!_didIteratorError) {
                  _context3.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context3.finish(31);

              case 35:
                return _context3.finish(26);

              case 36:
                _this2.acordo = acordo;
                _this2.dialogParcela = true;

              case 38:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[3, 22, 26, 36], [27,, 31, 35]]);
      }))();
    },
    getColorParcela: function getColorParcela(parcela) {
      if (parcela.dtPagamento) {
        return 'green';
      }
      if (parcela.acordo.StatusAcordo == 9) {
        return 'grey';
      }
      if (__WEBPACK_IMPORTED_MODULE_7_moment___default()(parcela.vencimento) < __WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(1, 'days') && parcela.stPago == 'N') {
        return 'red';
      }
    },
    buscarParcelas: function buscarParcelas(status) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.filtros.status = status;
                _this3.setLoading(true);

                if (!(_this3.user != null && _this3.user.acesso == "Funcionario")) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__services_acordo__["a" /* default */].getParcelas({ funcionario: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.user._id, date: _this3.date, filtros: _this3.filtros });

              case 5:
                _this3.parcelas = _context4.sent;
                _context4.next = 18;
                break;

              case 8:
                if (!(_this3.user != null && _this3.user.acesso == "Cliente")) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_8__services_acordo__["a" /* default */].getParcelas({ cliente: _this3.user.cliente, date: _this3.date, filtros: _this3.filtros });

              case 11:
                _this3.parcelas = _context4.sent;
                _context4.next = 18;
                break;

              case 14:
                if (!(_this3.user != null && (_this3.user.acesso == "Admin" || _this3.user.acesso == "Financeiro" || _this3.user.acesso == "AdminClientes"))) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 17;
                return __WEBPACK_IMPORTED_MODULE_8__services_acordo__["a" /* default */].getParcelas({ date: _this3.date, filtros: _this3.filtros });

              case 17:
                _this3.parcelas = _context4.sent;

              case 18:
                _this3.setLoading(false);

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    gerarBoleto: function gerarBoleto(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (item.juno) {
                  _context5.next = 24;
                  break;
                }

                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__services_juno__["a" /* default */].createCharge(item);

              case 3:
                response = _context5.sent;

                if (!response.message) {
                  _context5.next = 9;
                  break;
                }

                _this4.message = response.message;
                _this4.dialogError = true;
                _context5.next = 22;
                break;

              case 9:
                if (!response.details) {
                  _context5.next = 14;
                  break;
                }

                _this4.message = response.details;
                _this4.dialogError = true;
                _context5.next = 22;
                break;

              case 14:
                _this4.message = "Boleto gerado com sucesso!";
                _this4.dialogError = true;

                _context5.t0 = _this4;
                _context5.next = 19;
                return __WEBPACK_IMPORTED_MODULE_10__services_devedores__["a" /* default */].getDevedoreId(_this4.acordo.devedor);

              case 19:
                _context5.t1 = _context5.sent;

                _context5.t0.setDevedor.call(_context5.t0, _context5.t1);

                _this4.abrirAcordo(_this4.acordo);

              case 22:
                _context5.next = 25;
                break;

              case 24:
                window.open(item.juno.link, '_blank');

              case 25:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },

    cobrar: function cobrar(item) {
      this.$router.push('/funcionario/cobranca/' + item.acordo.devedor._id);
    },
    listar: function listar(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this5.acordo = item.acordo;
                _this5.dialogParcela = true;

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    buscaValorTotalParcela: function buscaValorTotalParcela(acordo) {
      if (acordo.parcelas && acordo.parcelas.length > 0) {
        if (this.user != null && this.user.acesso == "Cliente") {
          return acordo.parcelas.map(function (item) {
            return item.cliente;
          }).reduce(function (prev, next) {
            return prev + next;
          });
        } else {
          return acordo.parcelas.map(function (item) {
            return item.valor;
          }).reduce(function (prev, next) {
            return prev + next;
          });
        }
      } else {
        return 0;
      }
    },
    totalGravados: function totalGravados(parcelas) {
      var retorno = 0;
      if (parcelas && parcelas.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parcelas), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var parcela = _step2.value;

            if (parcela.acordo.StatusAcordo != 9) {
              if (this.user != null && this.user.acesso == "Cliente") {
                retorno += parcela.cliente;
              } else {
                retorno += parcela.valor;
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else {
        return 0;
      }
      return retorno;
    },
    totalVigente: function totalVigente(parcelas) {
      var retorno = 0;
      if (parcelas && parcelas.length > 0) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parcelas), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var parcela = _step3.value;

            if (parcela.acordo.StatusAcordo != 9 && __WEBPACK_IMPORTED_MODULE_7_moment___default()(parcela.vencimento) > __WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(1, 'days') && parcela.stPago == 'N') {
              if (this.user != null && this.user.acesso == "Cliente") {
                retorno += parcela.cliente;
              } else {
                retorno += parcela.valor;
              }
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } else {
        return 0;
      }
      return retorno;
    },
    buscaReceita: function buscaReceita(parcelas) {
      var retorno = 0;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parcelas), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var parcela = _step4.value;

          if (this.user != null && this.user.acesso == "Cliente" && parcela.stPago == 'S') {
            retorno = retorno + parcela.cliente;
          } else {
            if (parcela.cliente && parcela.stPago == 'S') {
              retorno = retorno + (parcela.valor - parcela.cliente - (parcela.valorAssoc ? parcela.valorAssoc : 0) - (parcela.valorJuros ? parcela.valorJuros : 0));
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return retorno;
    },
    buscaRecebido: function buscaRecebido(parcelas) {
      var retorno = 0;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parcelas), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var parcela = _step5.value;

          if (parcela.stPago == 'S') {
            if (this.user != null && this.user.acesso == "Cliente" && parcela.cliente) {
              retorno = retorno + parcela.cliente;
            } else {
              retorno = retorno + parcela.valor;
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return retorno;
    },
    buscaAtraso: function buscaAtraso(parcelas) {
      var retorno = 0;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parcelas), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var parcela = _step6.value;

          if (parcela.acordo.StatusAcordo != 9) {
            if (__WEBPACK_IMPORTED_MODULE_7_moment___default()(parcela.vencimento) < __WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(1, 'days') && parcela.stPago == 'N') {
              if (this.user != null && this.user.acesso == "Cliente") {
                retorno = retorno + parcela.cliente;
              } else {
                retorno = retorno + parcela.valor;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return retorno;
    },
    buscaCancelados: function buscaCancelados(parcelas) {
      var retorno = 0;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(parcelas), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var parcela = _step7.value;

          if (parcela.acordo.StatusAcordo == 9 && parcela.stPago != 'S') {
            if (this.user != null && this.user.acesso == "Cliente") {
              retorno = retorno + parcela.cliente;
            } else {
              retorno = retorno + parcela.valor;
            }
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return retorno;
    },
    getStatusAcordo: function getStatusAcordo(item) {
      if (item.acordo.StatusAcordo == 9) {
        return 'Acordo Cancelado';
      }
      if (__WEBPACK_IMPORTED_MODULE_7_moment___default()(item.vencimento) < __WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(1, 'days') && item.stPago == 'N') {
        return 'Acordo em Atraso';
      }
      if (item.acordo.StatusAcordo == 1) {
        return 'Processo Cobrança';
      } else if (item.acordo.StatusAcordo == 2) {
        return 'Aguardando Aprovação';
      } else if (item.acordo.StatusAcordo == 3) {
        return 'Acordo Vigente';
      } else if (item.acordo.StatusAcordo == 6) {
        return 'Acordo Liquidado';
      }
    },
    getProposta: function getProposta(proposta) {
      if (proposta == 1) {
        return 'Fixa';
      } else if (proposta == 2) {
        return 'Exceção';
      } else if (proposta == 3) {
        return 'Gerado Devedor';
      }
    },
    getStPago: function getStPago(item) {
      if (!item.juno) {
        return 'Boleto não Gerado';
      }
      if (item.juno.payments && item.juno.payments.length > 0) {
        return 'Pago';
      }
      if (__WEBPACK_IMPORTED_MODULE_7_moment___default()(item.juno.dueDate) < __WEBPACK_IMPORTED_MODULE_7_moment___default()()) {
        return 'Atraso';
      }
      if (item.stPago == 'N') {
        return 'Não Pago';
      }
    },
    getPagamento: function getPagamento(pagamento) {
      if (pagamento == 1) {
        return 'Boleto';
      } else if (pagamento == 2) {
        return 'Deposito';
      } else if (pagamento == 3) {
        return 'Escritório';
      } else if (pagamento == 4) {
        return 'Na Loja';
      } else if (pagamento == 5) {
        return 'Pix';
      }
    },
    getNegociacao: function getNegociacao(pagamento) {
      if (pagamento == 1) {
        return 'Acordo Novo';
      } else if (pagamento == 2) {
        return 'Reativação';
      } else if (pagamento == 3) {
        return 'Renegociação';
      }
    },
    buscaMeta: function buscaMeta(user, valor) {
      if (user.meta3 && user.meta3 && user.meta3) {

        if (valor > user.meta2) {
          return "3ª " + (valor / user.meta3 * 100).toFixed(2) + "%";
        } else if (valor > user.meta1) {
          return "2ª " + (valor / user.meta2 * 100).toFixed(2) + "%";
        } else {
          return "1ª " + (valor / user.meta1 * 100).toFixed(2) + "%";
        }
      } else {
        return "Não Cadastrado.";
      }
    },
    buscaMetaCor: function buscaMetaCor(user, valor) {
      if (user.meta3 && user.meta3 && user.meta3) {
        if (valor > user.meta2) {
          return "green";
        } else if (valor > user.meta1) {
          return "blue";
        } else {
          return "grey";
        }
      } else {
        return "white";
      }
    },
    exportarExcel: function exportarExcel(parcelas) {
      var _this6 = this;

      var data = [];
      parcelas.forEach(function (parcela) {

        var object = {};
        if (_this6.user.acesso == "Cliente") {
          object = {
            "Empresa": parcela.acordo.cliente.Nome,
            "Funcionario": parcela.acordo.user.name,
            "Devedor": parcela.acordo.devedor.Nome,
            "Vencimento": __WEBPACK_IMPORTED_MODULE_7_moment___default()(parcela.vencimento).format("DD/MM/YYYY"),
            "CPF": parcela.acordo.devedor.CnpjCpf,
            "Telefone": parcela.acordo.devedor.TelefonePrincipal,
            "Status Divida": _this6.getStatusAcordo(parcela),
            //"Valor Parcela": this.formatPrice(parcela.valor),
            "Pagamento": __WEBPACK_IMPORTED_MODULE_7_moment___default()(parcela.dtPagamento).format("DD/MM/YYYY"),
            "Parcela": parcela.numero + '/' + parcela.acordo.parcelas.length,
            "Valor Bruto": _this6.formatPrice(parcela.cliente),
            "Forma Pagamento": _this6.getPagamento(parcela.tipoPagamento || parcela.acordo.tipoPagamento)
          };
        } else {
          object = {
            "Empresa": parcela.acordo.cliente.Nome,
            "Funcionario": parcela.acordo.user.name,
            "Devedor": parcela.acordo.devedor.Nome,
            "Vencimento": __WEBPACK_IMPORTED_MODULE_7_moment___default()(parcela.vencimento).format("DD/MM/YYYY"),
            "CPF": parcela.acordo.devedor.CnpjCpf,
            "Telefone": parcela.acordo.devedor.TelefonePrincipal,
            "Status Divida": _this6.getStatusAcordo(parcela),
            "Pagamento": __WEBPACK_IMPORTED_MODULE_7_moment___default()(parcela.dtPagamento).format("DD/MM/YYYY"),
            "Parcela": parcela.numero + '/' + parcela.acordo.parcelas.length,
            "Valor Parcela": _this6.formatPrice(parcela.valor),
            "Valor Bruto": _this6.formatPrice(parcela.valor - parcela.cliente - (parcela.valorAssoc ? parcela.valorAssoc : 0) - (parcela.valorJuros ? parcela.valorJuros : 0)),
            "Valor Cliente": _this6.formatPrice(parcela.cliente),
            "Valor Assoc": _this6.formatPrice(parcela.valorAssoc),
            "Valor Juros": _this6.formatPrice(parcela.valorJuros),
            "Forma Pagamento": _this6.getPagamento(parcela.tipoPagamento || parcela.acordo.tipoPagamento)
          };
        }

        data.push(object);
      });
      try {
        Object(__WEBPACK_IMPORTED_MODULE_13_js2excel__["json2excel"])({
          data: data,
          name: 'parcelas',
          formateDate: 'dd/mm/yyyy'
        });
      } catch (e) {
        console.error('export error');
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Relatorio_vue_vue_type_script_lang_js___ = __webpack_require__(277);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Relatorio_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_relatorios_Acordos__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_relatorios_Dividas__ = __webpack_require__(280);



//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Dividas: __WEBPACK_IMPORTED_MODULE_5__pages_relatorios_Dividas__["a" /* default */],
    Acordos: __WEBPACK_IMPORTED_MODULE_4__pages_relatorios_Acordos__["a" /* default */]
  },
  name: 'Relatorio',
  data: function data() {
    return {
      model: {},
      active: 0
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              _this.setLoading(true);
              _this.setLoading(false);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
    setError: "setError",
    setLoading: "setLoading"
  }))
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_script_lang_js___ = __webpack_require__(279);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_cliente__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_acordo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js2excel__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js2excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_js2excel__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Email',
  data: function data() {
    return {
      filtros: {},
      clientes: [],
      funcionarios: [],
      user: null,
      date: new Date().toISOString().substr(0, 7),
      menu: false
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setLoading(true);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__services_cliente__["a" /* default */].getClientes();

            case 3:
              _this.clientes = _context.sent;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getFuncionarios();

            case 6:
              _this.funcionarios = _context.sent;

              if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user) {
                _context.next = 11;
                break;
              }

              _context.next = 10;
              return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.user._id);

            case 10:
              _this.user = _context.sent;

            case 11:
              _this.setLoading(false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    exportarExcel: function exportarExcel(filtros) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, parcelas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:

                _this2.setLoading(true);
                data = [];
                parcelas = [];

                if (!(_this2.user != null && _this2.user.acesso == "Cliente")) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_7__services_acordo__["a" /* default */].getParcelas({ cliente: _this2.user.cliente, date: _this2.date, filtros: _this2.filtros });

              case 6:
                parcelas = _context2.sent;
                _context2.next = 13;
                break;

              case 9:
                if (!(_this2.user != null && (_this2.user.acesso == "Admin" || _this2.user.acesso == "Financeiro"))) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_7__services_acordo__["a" /* default */].getParcelas({ date: _this2.date, filtros: filtros });

              case 12:
                parcelas = _context2.sent;

              case 13:
                parcelas.forEach(function (parcela) {

                  var object = {};
                  if (_this2.user.acesso == "Cliente") {
                    object = {
                      "Empresa": parcela.acordo.cliente.Nome,
                      "Funcionario": parcela.acordo.user.name,
                      "Devedor": parcela.acordo.devedor.Nome,
                      "Vencimento": __WEBPACK_IMPORTED_MODULE_8_moment___default()(parcela.vencimento).format("DD/MM/YYYY"),
                      "CPF": parcela.acordo.devedor.CnpjCpf,
                      "Status Divida": _this2.getStatusAcordo(parcela),
                      "Pagamento": __WEBPACK_IMPORTED_MODULE_8_moment___default()(parcela.dtPagamento).format("DD/MM/YYYY"),
                      "Parcela": parcela.numero + '/' + parcela.acordo.parcelas.length,
                      "Valor Bruto": _this2.formatPrice(parcela.cliente),
                      "Forma Pagamento": _this2.getPagamento(parcela.tipoPagamento || parcela.acordo.tipoPagamento)
                    };
                  } else {
                    object = {
                      "Empresa": parcela.acordo.cliente.Nome,
                      "Funcionario": parcela.acordo.user.name,
                      "Devedor": parcela.acordo.devedor.Nome,
                      "Vencimento": __WEBPACK_IMPORTED_MODULE_8_moment___default()(parcela.vencimento).format("DD/MM/YYYY"),
                      "CPF": parcela.acordo.devedor.CnpjCpf,
                      "Status Divida": _this2.getStatusAcordo(parcela),
                      "Pagamento": __WEBPACK_IMPORTED_MODULE_8_moment___default()(parcela.dtPagamento).format("DD/MM/YYYY"),
                      "Parcela": parcela.numero + '/' + parcela.acordo.parcelas.length,
                      "Valor Parcela": _this2.formatPrice(parcela.valor),
                      "Valor Bruto": _this2.formatPrice(parcela.valor - parcela.cliente),
                      "Valor Cliente": _this2.formatPrice(parcela.cliente),
                      "Forma Pagamento": _this2.getPagamento(parcela.tipoPagamento || parcela.acordo.tipoPagamento)
                    };
                  }

                  data.push(object);
                });
                try {
                  Object(__WEBPACK_IMPORTED_MODULE_9_js2excel__["json2excel"])({
                    data: data,
                    name: 'RelatorioAcordo',
                    formateDate: 'dd/mm/yyyy'
                  });

                  _this2.setLoading(false);
                } catch (e) {
                  _this2.setLoading(false);
                  console.error('export error');
                }

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getStatusAcordo: function getStatusAcordo(item) {
      if (item.acordo.StatusAcordo == 9) {
        return 'Acordo Cancelado';
      }
      if (__WEBPACK_IMPORTED_MODULE_8_moment___default()(item.vencimento) < __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(1, 'days') && item.stPago == 'N') {
        return 'Acordo em Atraso';
      }
      if (item.acordo.StatusAcordo == 1) {
        return 'Processo Cobrança';
      } else if (item.acordo.StatusAcordo == 2) {
        return 'Aguardando Aprovação';
      } else if (item.acordo.StatusAcordo == 3) {
        return 'Acordo Vigente';
      } else if (item.acordo.StatusAcordo == 6) {
        return 'Acordo Liquidado';
      }
    },
    getPagamento: function getPagamento(pagamento) {
      if (pagamento == 1) {
        return 'Boleto';
      } else if (pagamento == 2) {
        return 'Deposito';
      } else if (pagamento == 3) {
        return 'Escritório';
      } else if (pagamento == 4) {
        return 'Na Loja';
      } else if (pagamento == 5) {
        return 'Pix';
      }
    },
    getStatusDivida: function getStatusDivida(divida) {
      if (divida && divida.ValorRepasse === 0) {
        return 'Quitado';
      }
      if (divida.StatusDivida == 1) {
        return 'Processo Cobrança';
      } else if (divida.StatusDivida == 2) {
        return 'Aguardando Aprovação';
      } else if (divida.StatusDivida == 3) {
        return 'Acordo Vigente';
      } else if (divida.StatusDivida == 4) {
        return 'Acordo em Atraso';
      } else if (divida.StatusDivida == 5) {
        return 'Divida Bloqueada';
      } else if (divida.StatusDivida == 6) {
        return 'Deslocalizado';
      } else if (divida.StatusDivida == 8) {
        return 'Bloqueado';
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapMutations */])({
    setDevedor: "setDevedor",
    setLoading: "setLoading"
  }))
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dividas_vue_vue_type_template_id_52620f02___ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dividas_vue_vue_type_script_lang_js___ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Dividas_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Dividas_vue_vue_type_template_id_52620f02___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Dividas_vue_vue_type_template_id_52620f02___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Dividas_vue_vue_type_script_lang_js___ = __webpack_require__(282);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Dividas_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_cliente__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_dividas__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js2excel__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js2excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_js2excel__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Email",
  data: function data() {
    return {
      filtros: {},
      clientes: [],
      user: null,
      dateFormatted1: '',
      dateFormatted2: '',
      menu1: false,
      menu2: false,
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10)
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setLoading(true);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__services_cliente__["a" /* default */].getClientes();

            case 3:
              _this.clientes = _context.sent;

              if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user) {
                _context.next = 8;
                break;
              }

              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_6__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user._id);

            case 7:
              _this.user = _context.sent;

            case 8:
              _this.setLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    computedDateFormatted1: function computedDateFormatted1() {
      return this.formatDate(this.date1);
    },
    computedDateFormatted2: function computedDateFormatted2() {
      return this.formatDate(this.date2);
    }
  },
  watch: {
    date1: function date1(val) {
      this.dateFormatted1 = this.formatDate(this.date1);
      this.filtros.dateCreatedInit = this.date1;
    },
    date2: function date2(val) {
      this.dateFormatted2 = this.formatDate(this.date2);
      this.filtros.dateCreatedEnd = this.date2;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split("-"),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split("/"),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, "0") + "-" + day.padStart(2, "0");
    },
    exportarExcel: function exportarExcel(filtros) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dividas, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.setLoading(true);
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_dividas__["a" /* default */].getDividas({ filtros: filtros });

              case 3:
                dividas = _context2.sent;

                console.log(dividas);
                //let dividas = await dividasCtrl.getDividasAll();


                data = [];

                dividas.forEach(function (divida) {
                  var object = {
                    Contrato: divida.Identificador,
                    Empresa: divida.idcliente.Nome,
                    Devedor: divida.iddevedor.Nome,
                    CPF: divida.iddevedor.CnpjCpf,
                    "Status Divida": _this2.getStatusDivida(divida),
                    "Devedor Bloqueado": divida.iddevedor.IsAtivo ? "Não" : "Sim",
                    "Data Nascimento": divida.iddevedor.DataNascimento,
                    Endereço: divida.iddevedor.Endereco,
                    "Telefone 1": divida.iddevedor.TelefonePrincipal && divida.iddevedor.TelefonePrincipal,
                    "Telefone 2": divida.iddevedor.Telefone2 && divida.iddevedor.Telefone2,
                    "Telefone 3": divida.iddevedor.Telefone3 && divida.iddevedor.Telefone3,
                    Especificação: divida.Especificacao,
                    "Tipo Produto": divida.TipoProduto,
                    Juro: divida.Juros,
                    "Tipo Juro": divida.TipoJuro,
                    "Data da Divida": divida.DataDivida,
                    "Valor Divida": divida.ValorDivida,
                    "Valor Empresa": divida.ValorEmpresa
                  };

                  data.push(object);
                });
                try {
                  Object(__WEBPACK_IMPORTED_MODULE_9_js2excel__["json2excel"])({
                    data: data,
                    name: "RelatorioDividas",
                    formateDate: "dd/mm/yyyy"
                  });

                  _this2.setLoading(false);
                } catch (e) {
                  _this2.setLoading(false);
                  console.error("export error");
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getStatusDivida: function getStatusDivida(divida) {
      if (divida && divida.ValorRepasse === 0) {
        return "Quitado";
      }
      if (divida.StatusDivida == 1) {
        return "Processo Cobrança";
      } else if (divida.StatusDivida == 2) {
        return "Aguardando Aprovação";
      } else if (divida.StatusDivida == 3) {
        return "Acordo Vigente";
      } else if (divida.StatusDivida == 4) {
        return "Acordo em Atraso";
      } else if (divida.StatusDivida == 5) {
        return "Divida Bloqueada";
      } else if (divida.StatusDivida == 6) {
        return "Deslocalizado";
      } else if (divida.StatusDivida == 8) {
        return "Bloqueado";
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapMutations */])({
    setDevedor: "setDevedor",
    setLoading: "setLoading"
  }))
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Painel_vue_vue_type_script_lang_js___ = __webpack_require__(284);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Painel_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ocorrencias__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_acordo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_agendas__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js2excel__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js2excel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_js2excel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_QuantidadeParcela__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ValoresParcela__ = __webpack_require__(522);



//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Endereco',
  components: {
    QuantidadeParcela: __WEBPACK_IMPORTED_MODULE_11__components_QuantidadeParcela__["a" /* default */],
    ValoresParcela: __WEBPACK_IMPORTED_MODULE_12__components_ValoresParcela__["a" /* default */]
  },
  data: function data() {
    return {
      valid: true,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      user: {},
      acordo: {},
      dialogConfirmation: false,
      dialogError: false,
      dialogParcela: false,
      editando: false,
      message: "",
      excluindo: {},
      cep: {},
      devedor: {},
      filtros: {},
      ocorrencias: [],
      agendas: [],
      funcionarios: [],
      clientes: [],
      valorTotalRecebido: 0,
      mesAtual: 0,
      mesPassado: 0
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var items, parcelas, hoje, mespassado;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              items = [];

              _this.setLoading(true);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__services_acordo__["a" /* default */].getGraph();

            case 4:
              parcelas = _context.sent;
              hoje = new __WEBPACK_IMPORTED_MODULE_5_moment___default.a().format('YYYY-MM');
              mespassado = new __WEBPACK_IMPORTED_MODULE_5_moment___default.a().subtract(1, "M").format('YYYY-MM');

              parcelas.forEach(function (parcela) {
                if (parcela._id == hoje) {
                  _this.mesAtual += parcela.valorCliente;
                }
                if (parcela._id == mespassado) {
                  _this.mesPassado += parcela.valorCliente;
                }
                _this.valorTotalRecebido += parcela.valorCliente;
              });
              // this.clientes = await cliente.getClientes();
              _context.next = 10;
              return __WEBPACK_IMPORTED_MODULE_9__services_usuario__["a" /* default */].getFuncionarios();

            case 10:
              _this.funcionarios = _context.sent;

              if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user) {
                _context.next = 15;
                break;
              }

              _context.next = 14;
              return __WEBPACK_IMPORTED_MODULE_9__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user._id);

            case 14:
              _this.user = _context.sent;

            case 15:
              _this.setLoading(false);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    buscarOcorrencias: function buscarOcorrencias() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.filtros.idfuncionario && _this2.date)) {
                  _context2.next = 13;
                  break;
                }

                _this2.setLoading(true);

                if (!(_this2.user != null && _this2.user.acesso == "Admin")) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_ocorrencias__["a" /* default */].getOcorrenciasUser({ iduser: _this2.filtros.idfuncionario, date: _this2.date });

              case 5:
                _this2.ocorrencias = _context2.sent;
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8__services_agendas__["a" /* default */].getAgendasUser({ iduser: _this2.filtros.idfuncionario, date: _this2.date });

              case 8:
                _this2.agendas = _context2.sent;
                _context2.next = 12;
                break;

              case 11:
                if (_this2.user != null && _this2.user.acesso == "Cliente") {}

              case 12:
                _this2.setLoading(false);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setDevedor: "setDevedor"
  }))
});

/***/ }),
/* 285 */,
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Fechamento_vue_vue_type_script_lang_js___ = __webpack_require__(287);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Fechamento_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_cliente__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_email__ = __webpack_require__(273);



//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      user: { name: '', acesso: '' },
      dialogConfirmationEmail: false,
      dialogConfirmation: false,
      dialogError: false,
      dialogParcela: false,
      editando: false,
      message: "",
      search: "",
      excluindo: {},
      filtros: {},
      clientes: [],
      valorTotalRecebido: 0,
      mesAtual: 0,
      mesPassado: 0,
      headers: [{
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: '_id.clienteNome'
      }, {
        text: 'Email',
        align: 'left',
        sortable: true,
        value: '_id.clienteEmail'
      }, {
        text: 'Valor Fechamento',
        align: 'left',
        sortable: true,
        value: 'valorCliente'
      }, { text: 'Ações', value: 'action', sortable: false }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.buscar();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({

    buscar: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setLoading(true);
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuario(this.$store.getters.user._id);

              case 3:
                this.user = _context2.sent;
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_cliente__["a" /* default */].getClientesValores({ date: this.date });

              case 6:
                this.clientes = _context2.sent;

                this.setLoading(false);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function buscar() {
        return _ref.apply(this, arguments);
      }

      return buscar;
    }(),
    confirmEmail: function confirmEmail(item) {
      this.model = item;
      this.dialogConfirmationEmail = true;
    },
    enviarEmail: function enviarEmail(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.setLoading(true);
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__services_email__["a" /* default */].sendMessageCliente(item);

              case 3:
                _this2.dialogEmail = false;
                _this2.model = {};
                _this2.setLoading(false);
                _this2.dialogConfirmationEmail = false;
                _this2.setError('Email enviado com sucesso!');

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading",
    setError: "setError"
  }))
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_script_lang_js___ = __webpack_require__(289);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_chat_ChatItem__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_chat_ChatBox__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_message__ = __webpack_require__(535);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    appChatItem: __WEBPACK_IMPORTED_MODULE_4__pages_chat_ChatItem__["a" /* default */],
    appChatBox: __WEBPACK_IMPORTED_MODULE_5__pages_chat_ChatBox__["a" /* default */]
  },
  data: function data() {
    return {
      path: '',
      user: {},
      userOther: {}
    };
  },

  // sockets : {
  //   connect: function(){
  //     console.log('salvarNotificacao connected');
  //   },
  //   chat: function(val){
  //     if (val.user1 == this.$route.params.id && val.user2 == this.$route.params.id2) {
  //       this.$store.dispatch("ADD_CHAT",val);
  //     }
  //   }
  // },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['CHATS', 'HANDLE'])),
  watch: {
    '$route': function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadData();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function $route() {
        return _ref.apply(this, arguments);
      }

      return $route;
    }()
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.loadData();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  updated: function updated() {
    var container = this.$refs.chatContainer;
    container.scrollTop = container.scrollHeight;
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    loadData: function loadData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var uid1, uid2, handle;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.setLoading(true);

                if (!(_this2.$route.params.id && _this2.$route.params.id2)) {
                  _context3.next = 23;
                  break;
                }

                uid1 = _this2.$route.params.id;
                uid2 = _this2.$route.params.id2;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_usuario__["a" /* default */].getUsuario(_this2.$store.getters.user._id);

              case 6:
                _this2.user = _context3.sent;


                _this2.path = uid1 < uid2 ? uid1 + '/' + uid2 : uid2 + '/' + uid1;
                handle = {
                  user1: uid1 < uid2 ? uid1 : uid2,
                  user2: uid1 < uid2 ? uid2 : uid1,
                  handle: _this2.user._id,
                  name: _this2.user.name
                };

                _this2.$store.dispatch("SET_HANDLE", handle);

                if (!(_this2.$store.getters.user._id != uid1)) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 13;
                return __WEBPACK_IMPORTED_MODULE_6__services_usuario__["a" /* default */].getUsuario(uid1);

              case 13:
                _this2.userOther = _context3.sent;
                _context3.next = 19;
                break;

              case 16:
                _context3.next = 18;
                return __WEBPACK_IMPORTED_MODULE_6__services_usuario__["a" /* default */].getUsuario(uid2);

              case 18:
                _this2.userOther = _context3.sent;

              case 19:
                _context3.next = 21;
                return __WEBPACK_IMPORTED_MODULE_7__services_message__["a" /* default */].salvarNotificacao({
                  user1: uid1 < uid2 ? uid1 : uid2,
                  user2: uid1 < uid2 ? uid2 : uid1,
                  handle: _this2.userOther._id,
                  count: 0
                });

              case 21:

                _this2.$store.dispatch("SET_USUARIOS", _this2.user);
                _this2.$store.dispatch("SET_CHAT", {
                  path: _this2.path
                });

              case 23:
                _this2.setLoading(false);

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
    setLoading: "setLoading"
  }))
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatItem_vue_vue_type_script_lang_js___ = __webpack_require__(291);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatItem_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['chat'],
  methods: {
    isMyHandle: function isMyHandle(handle) {
      if (handle == this.$store.getters.HANDLE.handle) {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatBox_vue_vue_type_script_lang_js___ = __webpack_require__(293);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatBox_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: ""
    };
  },

  methods: {
    sendMessage: function sendMessage() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var handle, message;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                handle = _this.$store.getters.HANDLE;

                if (_this.message) {
                  message = {
                    user1: handle.user1,
                    user2: handle.user2,
                    handle: handle.handle,
                    message: _this.message
                    //let response = await this.$socket.client.emit('chat',message)
                  };
                  _this.message = "";
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_minhas_dividas_vue_vue_type_script_lang_js___ = __webpack_require__(295);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_minhas_dividas_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_acordo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_devedores__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_usuario__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);





//
//









function getPosition(string, subString, index) {
  return string.split(subString, index).join(subString).length;
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Negociacao',
  data: function data() {
    return {
      valid: true,
      dialogConfirmation: false,
      menu2: false,
      date2: new Date().toISOString().substr(0, 10),
      dateFormatted2: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu3: false,
      date3: new Date().toISOString().substr(0, 10),
      dateFormatted3: this.formatDate(new Date().toISOString().substr(0, 10)),
      mask: '(##) #####-####',
      modal2: false,
      user: {},
      message: "",
      dialogError: false,
      money: {
        decimal: ',',
        thousands: '.',
        suffix: '',
        precision: 2
      },
      e1: 1,
      dialogParcela: false,
      dialogBoletos: false,
      parcelas: [],
      devedor: {},
      acordo: {},
      acordoBoleto: {},
      tipoParcelamento: [],
      dataVencimentos: [],
      headersParcelas: [{
        text: 'Numero',
        value: 'numero'
      }, {
        text: 'Vencimento',
        value: 'vencimento'
      }, {
        text: 'Valor',
        value: 'valor'
      }],

      headersParcelasBoleto: [{
        text: 'Numero',
        value: 'numero'
      }, {
        text: 'Vencimento',
        value: 'vencimento'
      }, {
        text: 'Valor',
        value: 'valor'
      }, {
        text: 'Boleto',
        value: 'boleto'
      },
      // {
      //   text: 'Modo de Envio',
      //   value: 'email'
      // },
      {
        text: 'Status',
        value: 'stPago'
      }, {
        text: 'Numero Boleto',
        value: 'numeroBoleto'
      }, {
        text: 'Pagamento',
        value: 'dtPagamento'
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setLoading(true);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__services_usuario__["a" /* default */].getUsuario(_this.$store.getters.user._id);

            case 3:
              _this.user = _context.sent;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this.user.devedor);

            case 6:
              _this.devedor = _context.sent;

              _this.$forceUpdate();
              _this.setLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    computedDateFormatted2: function computedDateFormatted2() {
      return this.formatDate(this.date2);
    },
    computedDateFormatted3: function computedDateFormatted3() {
      return this.formatDate(this.date3);
    },
    loading: function loading() {
      return this.$store.getters["loading"];
    }
  },
  /*watch: {
    date2 (val) {
      this.dateFormatted2 = this.formatDate(this.date2)
      this.acordo.dtVencimento = this.date2;
    },
    date3 (val) {
      this.dateFormatted3 = this.formatDate(this.date3)
      this.acordo.dtVencimentoParcela = this.date3;
    },
  },*/
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
    },
    allowedDatesParcela: function allowedDatesParcela(date) {
      var val = __WEBPACK_IMPORTED_MODULE_10_moment___default()().add(45, 'days');
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date) <= val;
    },
    allowedDates: function allowedDates(date) {
      var val = __WEBPACK_IMPORTED_MODULE_10_moment___default()().add(15, 'days');
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date) <= val;
    },
    abrirAcordo: function abrirAcordo(acordos, divida) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                acordos.forEach(function (acordo) {
                  if (acordo.divida == divida._id && acordo.StatusAcordo != 9) {
                    _this2.acordoBoleto = acordo;
                  }
                });
                _this2.dialogBoletos = true;

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    desabilitarPagamento: function desabilitarPagamento(acordo, item) {
      if (acordo.StatusAcordo == '1' || acordo.StatusAcordo == '2' || acordo.StatusAcordo == '9' || item.stPago == 'S') {
        return true;
      } else {
        var retorno = false;
        acordo.parcelas.forEach(function (parcela) {
          if (parcela.numero == item.numero - 1 && parcela.stPago == "N") {
            retorno = true;
          }
        });
        return retorno;
      }
    },
    gerarBoleto: function gerarBoleto(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!item.secure_url) {
                  _context4.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get(item.secure_url).then(function (response) {
                  window.open(item.secure_url, '_blank');
                }).catch(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(error) {
                    var response;
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return juno.imprimirBoletosBB(item);

                          case 2:
                            response = _context3.sent;

                            window.open(response.secure_url, '_blank');

                          case 4:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _context4.next = 19;
                break;

              case 4:
                _context4.next = 6;
                return juno.gerarBoletoBB(item);

              case 6:
                response = _context4.sent;

                if (!response) {
                  _context4.next = 19;
                  break;
                }

                if (!(response && response.data && response.data.erros)) {
                  _context4.next = 11;
                  break;
                }

                _this3.setError(response.data.erros);
                return _context4.abrupt("return");

              case 11:

                _this3.dialogParcela = false;
                _this3.$forceUpdate();
                _context4.t0 = _this3;
                _context4.next = 16;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this3.acordo.devedor);

              case 16:
                _context4.t1 = _context4.sent;

                _context4.t0.setDevedor.call(_context4.t0, _context4.t1);

                _this3.setError('Boleto gerado com sucesso!');

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    getStPago: function getStPago(item) {
      if (item.juno && item.juno.payments && item.juno.payments.length > 0 || item.stPago == 'S') {
        return 'Pago';
      }
      if (item.secure_url) {
        return 'Boleto BB';
      }
      if (!item.juno) {
        return 'Boleto não Gerado';
      }

      if (__WEBPACK_IMPORTED_MODULE_10_moment___default()(item.juno.dueDate) < __WEBPACK_IMPORTED_MODULE_10_moment___default()()) {
        return 'Atraso';
      }
      if (item.stPago == 'N') {
        return 'Não Pago';
      }
    },
    validarTipoPagamento: function validarTipoPagamento() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var valorMinimo, valorAcordo, index, dia, _index, _index2;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this4.acordo.tipoProposta == '2' && !_this4.acordo.ValorEntrada)) {
                  _context5.next = 4;
                  break;
                }

                _this4.setError('O Valor da Entrada deve ser informado!');
                _this4.setLoading(false);
                return _context5.abrupt("return");

              case 4:
                valorMinimo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(Number(_this4.acordo.ValorAcordo) * (_this4.acordo.idcliente.percentualAvista / 100));

                if (!(_this4.acordo.tipoProposta == '2' && Number(_this4.acordo.ValorEntrada) < valorMinimo)) {
                  _context5.next = 9;
                  break;
                }

                _this4.setError('O Valor da Entrada deve ser maior que o Valor ( R$ ' + valorMinimo.toFixed(2) + ').');
                _this4.setLoading(false);
                return _context5.abrupt("return");

              case 9:
                if (!(_this4.acordo.tipoProposta == '2' && Number(_this4.acordo.ValorEntrada) >= Number(_this4.acordo.ValorAcordo))) {
                  _context5.next = 13;
                  break;
                }

                _this4.setError('O Valor da Entrada não pode ser maior que o Valor da Divida, usar o pagamento à vista.');
                _this4.setLoading(false);
                return _context5.abrupt("return");

              case 13:

                _this4.dataVencimentos = [];
                _this4.tipoParcelamento = [];
                valorAcordo = Number(_this4.acordo.ValorAcordo - _this4.acordo.ValorEntrada);


                for (index = 1; index <= _this4.acordo.idcliente.parcelaMaxima; index++) {
                  _this4.tipoParcelamento.push({ tipopParcela: index, descricao: index + "x de R$ " + (valorAcordo / index).toFixed(2) });
                }
                dia = String(new Date().getDate()).padStart(2, '0');

                if (_this4.acordo.tipoProposta == 1) {
                  for (_index = Number(dia); _index < Number(dia) + 2; _index++) {
                    if (_index > 28) {
                      _this4.dataVencimentos.push({ diaVencimento: Number(_index - 28), descricao: "Todo dia " + Number(_index - 28) });
                    } else {
                      _this4.dataVencimentos.push({ diaVencimento: _index, descricao: "Todo dia " + _index });
                    }
                  }
                } else if (_this4.acordo.tipoProposta == 2) {
                  for (_index2 = Number(dia); _index2 < Number(dia) + 15; _index2++) {
                    if (_index2 > 28) {
                      _this4.dataVencimentos.push({ diaVencimento: Number(_index2 - 28), descricao: "Todo dia " + Number(_index2 - 28) });
                    } else {
                      _this4.dataVencimentos.push({ diaVencimento: _index2, descricao: "Todo dia " + _index2 });
                    }
                  }
                }

                _this4.e1 = 2;

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    calcularParcelas: function calcularParcelas() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var vencimento, parcelas, vencimentoParcela, valor, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:

                _this5.setLoading(true);

                if (!(_this5.acordo.tipoProposta == '2' && !_this5.acordo.nrParcela)) {
                  _context6.next = 5;
                  break;
                }

                _this5.setError('O Número de Parcelas deve ser informado!');
                _this5.setLoading(false);
                return _context6.abrupt("return");

              case 5:
                if (_this5.acordo.diaVencimento) {
                  _context6.next = 9;
                  break;
                }

                _this5.setError('A Data do Vencimento deve ser Informada!');
                _this5.setLoading(false);
                return _context6.abrupt("return");

              case 9:
                vencimento = new Date().setDate(_this5.acordo.diaVencimento);

                if (vencimento < new Date()) {
                  vencimento = new Date(vencimento).setMonth(new Date(vencimento).getMonth() + 1);
                }

                parcelas = [];

                if (_this5.acordo.tipoProposta == '1') {
                  parcelas.push({ "numero": 1, "valor": Number(_this5.acordo.ValorAvista), "vencimento": new Date(vencimento).toISOString().substr(0, 10) });
                } else {
                  vencimentoParcela = vencimento;
                  valor = Number(_this5.acordo.ValorAcordo - _this5.acordo.ValorEntrada) / _this5.acordo.nrParcela;


                  parcelas.push({ "numero": parcelas.length + 1, "valor": _this5.acordo.ValorEntrada, "vencimento": new Date(vencimentoParcela).toISOString().substr(0, 10) });
                  for (index = 0; index < _this5.acordo.nrParcela; index++) {
                    /*if (index == 0) {
                      parcelas.push({"numero": (parcelas.length+1), "valor": valor, "vencimento": new Date(vencimentoParcela).toISOString().substr(0, 10) })
                    } else {*/
                    vencimentoParcela = new Date(vencimentoParcela).setMonth(new Date(vencimentoParcela).getMonth() + 1);
                    parcelas.push({ "numero": parcelas.length + 1, "valor": valor, "vencimento": new Date(vencimentoParcela).toISOString().substr(0, 10) });
                    //}
                  }
                }

                _this5.acordo.parcelas = parcelas;
                _this5.setLoading(false);
                _this5.e1 = 3;

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    salvar: function salvar(parcela, acordo) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _valorAcordo, ValorAcordo;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                //if (this.$refs.form.validate()) {
                _this6.acordo = acordo;

                if (parcela) {
                  _context7.next = 26;
                  break;
                }

                if (_this6.acordo.idcliente) {
                  _context7.next = 6;
                  break;
                }

                _this6.setError('Regras da Empresa não foram cadastradas, aguarde!');
                _this6.setLoading(false);
                return _context7.abrupt("return");

              case 6:
                if (_this6.acordo.idcliente.parcelaMaxima) {
                  _context7.next = 10;
                  break;
                }

                _this6.setError('Regras da Empresa não foram cadastradas, aguarde!');
                _this6.setLoading(false);
                return _context7.abrupt("return");

              case 10:
                if (_this6.acordo.idcliente.percentualDescontoAvista) {
                  _context7.next = 14;
                  break;
                }

                _this6.setError('Regras da Empresa não foram cadastradas, aguarde!');
                _this6.setLoading(false);
                return _context7.abrupt("return");

              case 14:
                if (_this6.acordo.idcliente.percentualAvista) {
                  _context7.next = 18;
                  break;
                }

                _this6.setError('Regras da Empresa não foram cadastradas, aguarde!');
                _this6.setLoading(false);
                return _context7.abrupt("return");

              case 18:
                _valorAcordo = Number(_this6.acordo.ValorAcordo);

                //this.acordo.nrParcela = Math.trunc(this.acordo.idcliente.parcelaMaxima/2)

                _this6.acordo.ValorAvista = _valorAcordo - Number(_valorAcordo * (_this6.acordo.idcliente.percentualDescontoAvista / 100)).toFixed(2);
                _this6.acordo.ValorEntrada = Number(_valorAcordo * (_this6.acordo.idcliente.percentualAvista / 100)).toFixed(2);
                /*if (this.acordo.ValorEntrada) {
                   
                }*/

                _this6.acordo.tipoProposta = '1';
                _this6.dialogParcela = true;
                return _context7.abrupt("return");

              case 26:

                _this6.setLoading(true);

                ValorAcordo = 0;


                if (_this6.acordo.tipoProposta == '1') {
                  ValorAcordo = _this6.acordo.ValorAvista;
                } else if (_this6.acordo.tipoProposta == '2') {
                  ValorAcordo = _this6.acordo.ValorAcordo;
                }

                if (!(Number(ValorAcordo) != Number(_this6.acordo.parcelas.map(function (item) {
                  return Number(item.valor);
                }).reduce(function (prev, next) {
                  return prev + next;
                })))) {
                  _context7.next = 33;
                  break;
                }

                _this6.message = "O Valor das parcelas (" + _this6.acordo.parcelas.map(function (item) {
                  return Number(item.valor);
                }).reduce(function (prev, next) {
                  return prev + next;
                }) + ") não é igual ao valor do Acordo (" + _this6.acordo.ValorAcordo + ")";
                _this6.dialogError = true;
                return _context7.abrupt("return");

              case 33:
                _this6.acordo.devedor = _this6.devedor._id;
                _this6.acordo.cliente = _this6.acordo.idcliente._id;
                _this6.acordo.user = _this6.user._id;
                _this6.acordo.StatusAcordo = '2';
                _this6.acordo.proposta = '3';
                _context7.next = 40;
                return __WEBPACK_IMPORTED_MODULE_5__services_acordo__["a" /* default */].save(_this6.acordo);

              case 40:
                _context7.next = 42;
                return __WEBPACK_IMPORTED_MODULE_6__services_devedores__["a" /* default */].getDevedoreId(_this6.user.devedor);

              case 42:
                _this6.devedor = _context7.sent;

                _this6.dialogParcela = false;
                _this6.setLoading(false);
                _this6.e1 = 4;
                _this6.$forceUpdate();

              case 47:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    calculaParcelas: function calculaParcelas(parcelas) {
      if (parcelas && parcelas.length > 0) {
        return Number(parcelas.map(function (item) {
          return Number(item.valor ? item.valor : 0);
        }).reduce(function (prev, next) {
          return prev + next;
        }).toFixed(2));
      } else {
        return 0;
      }
    },
    getTipoProduto: function getTipoProduto(tipo) {
      if (!tipo) return '';
      if (tipo == 1) return 'Boleto';else if (tipo == 2) return 'Cheque';else if (tipo == 3) return 'Nota';else if (tipo == 4) return 'Nota Fiscal';else if (tipo == 5) return 'Promissoria';
    },
    getDiasAtraso: function getDiasAtraso(data) {
      if (data) {
        var mes = data.substring(getPosition(data, '/', 1) + 1, getPosition(data, '/', 2) + 1);
        data = data.replace(mes, '');
        data = mes + data;
        var toDate = new Date(data);
        var result = new Date().getTime() - toDate.getTime();
        result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(result / 1000 / 60 / 60 / 24);
        return result;
      }
      return null;
    },
    getMesesAtraso: function getMesesAtraso(data) {
      if (data) {
        var mes = data.substring(getPosition(data, '/', 1) + 1, getPosition(data, '/', 2) + 1);
        data = data.replace(mes, '');
        data = mes + data;
        var toDate = new Date(data);
        var result = new Date().getTime() - toDate.getTime();
        result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(result / 1000 / 60 / 60 / 24 / 30);
        return result;
      }
      return null;
    },
    getAnosAtraso: function getAnosAtraso(data) {
      if (data) {
        var mes = data.substring(getPosition(data, '/', 1) + 1, getPosition(data, '/', 2) + 1);
        data = data.replace(mes, '');
        data = mes + data;
        var toDate = new Date(data);
        var result = new Date().getTime() - toDate.getTime();
        result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(result / 1000 / 60 / 60 / 24 / 30 / 12);
        return result;
      }
      return null;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapMutations */])({
    setDevedor: "setDevedor",
    setAcordo: "setAcordo",
    setLoading: "setLoading",
    setError: "setError"
  })),
  directives: { money: __WEBPACK_IMPORTED_MODULE_9_v_money__["VMoney"] }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_mask__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_async_computed__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_currency_filter__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_currency_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_currency_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_locale_pt__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_locale_pt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_locale_pt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_timezone__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_currency_input__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_currency_field__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_index__ = __webpack_require__(4);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












//import VueSocketIOExt from 'vue-socket.io-extended';
//import io from 'socket.io-client';



__webpack_require__(49);





__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.tz.setDefault('America/Sao_Paulo');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_v_currency_field__["a" /* default */], {
  locale: 'pt-BR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_moment___default.a, {
  moment: __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_v_mask__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_async_computed__["a" /* default */]);

/*const socket = io(store.getters.server, {
  store: store,
  format: 'json',
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
  reconnectionDelay: 3000,
});
 
Vue.use(VueSocketIOExt, socket, store);*/
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_currency_filter___default.a, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_15__store_index__["a" /* default */],
  vuetify: new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a({
    icons: {
      iconfont: 'md'
    },
    lang: {
      locales: {
        pt: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_locale_pt___default.a
      },
      current: 'pt'
    }
  }),
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_13__App__["a" /* default */] },
  created: function created() {
    this.$store.dispatch('init');
    console.log(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].moment().locale());
  }
});

/***/ }),
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 71,
	"./af.js": 71,
	"./ar": 72,
	"./ar-dz": 73,
	"./ar-dz.js": 73,
	"./ar-kw": 74,
	"./ar-kw.js": 74,
	"./ar-ly": 75,
	"./ar-ly.js": 75,
	"./ar-ma": 76,
	"./ar-ma.js": 76,
	"./ar-sa": 77,
	"./ar-sa.js": 77,
	"./ar-tn": 78,
	"./ar-tn.js": 78,
	"./ar.js": 72,
	"./az": 79,
	"./az.js": 79,
	"./be": 80,
	"./be.js": 80,
	"./bg": 81,
	"./bg.js": 81,
	"./bm": 82,
	"./bm.js": 82,
	"./bn": 83,
	"./bn-bd": 84,
	"./bn-bd.js": 84,
	"./bn.js": 83,
	"./bo": 85,
	"./bo.js": 85,
	"./br": 86,
	"./br.js": 86,
	"./bs": 87,
	"./bs.js": 87,
	"./ca": 88,
	"./ca.js": 88,
	"./cs": 89,
	"./cs.js": 89,
	"./cv": 90,
	"./cv.js": 90,
	"./cy": 91,
	"./cy.js": 91,
	"./da": 92,
	"./da.js": 92,
	"./de": 93,
	"./de-at": 94,
	"./de-at.js": 94,
	"./de-ch": 95,
	"./de-ch.js": 95,
	"./de.js": 93,
	"./dv": 96,
	"./dv.js": 96,
	"./el": 97,
	"./el.js": 97,
	"./en-au": 98,
	"./en-au.js": 98,
	"./en-ca": 99,
	"./en-ca.js": 99,
	"./en-gb": 100,
	"./en-gb.js": 100,
	"./en-ie": 101,
	"./en-ie.js": 101,
	"./en-il": 102,
	"./en-il.js": 102,
	"./en-in": 103,
	"./en-in.js": 103,
	"./en-nz": 104,
	"./en-nz.js": 104,
	"./en-sg": 105,
	"./en-sg.js": 105,
	"./eo": 106,
	"./eo.js": 106,
	"./es": 107,
	"./es-do": 108,
	"./es-do.js": 108,
	"./es-mx": 109,
	"./es-mx.js": 109,
	"./es-us": 110,
	"./es-us.js": 110,
	"./es.js": 107,
	"./et": 111,
	"./et.js": 111,
	"./eu": 112,
	"./eu.js": 112,
	"./fa": 113,
	"./fa.js": 113,
	"./fi": 114,
	"./fi.js": 114,
	"./fil": 115,
	"./fil.js": 115,
	"./fo": 116,
	"./fo.js": 116,
	"./fr": 117,
	"./fr-ca": 118,
	"./fr-ca.js": 118,
	"./fr-ch": 119,
	"./fr-ch.js": 119,
	"./fr.js": 117,
	"./fy": 120,
	"./fy.js": 120,
	"./ga": 121,
	"./ga.js": 121,
	"./gd": 122,
	"./gd.js": 122,
	"./gl": 123,
	"./gl.js": 123,
	"./gom-deva": 124,
	"./gom-deva.js": 124,
	"./gom-latn": 125,
	"./gom-latn.js": 125,
	"./gu": 126,
	"./gu.js": 126,
	"./he": 127,
	"./he.js": 127,
	"./hi": 128,
	"./hi.js": 128,
	"./hr": 129,
	"./hr.js": 129,
	"./hu": 130,
	"./hu.js": 130,
	"./hy-am": 131,
	"./hy-am.js": 131,
	"./id": 132,
	"./id.js": 132,
	"./is": 133,
	"./is.js": 133,
	"./it": 134,
	"./it-ch": 135,
	"./it-ch.js": 135,
	"./it.js": 134,
	"./ja": 136,
	"./ja.js": 136,
	"./jv": 137,
	"./jv.js": 137,
	"./ka": 138,
	"./ka.js": 138,
	"./kk": 139,
	"./kk.js": 139,
	"./km": 140,
	"./km.js": 140,
	"./kn": 141,
	"./kn.js": 141,
	"./ko": 142,
	"./ko.js": 142,
	"./ku": 143,
	"./ku.js": 143,
	"./ky": 144,
	"./ky.js": 144,
	"./lb": 145,
	"./lb.js": 145,
	"./lo": 146,
	"./lo.js": 146,
	"./lt": 147,
	"./lt.js": 147,
	"./lv": 148,
	"./lv.js": 148,
	"./me": 149,
	"./me.js": 149,
	"./mi": 150,
	"./mi.js": 150,
	"./mk": 151,
	"./mk.js": 151,
	"./ml": 152,
	"./ml.js": 152,
	"./mn": 153,
	"./mn.js": 153,
	"./mr": 154,
	"./mr.js": 154,
	"./ms": 155,
	"./ms-my": 156,
	"./ms-my.js": 156,
	"./ms.js": 155,
	"./mt": 157,
	"./mt.js": 157,
	"./my": 158,
	"./my.js": 158,
	"./nb": 159,
	"./nb.js": 159,
	"./ne": 160,
	"./ne.js": 160,
	"./nl": 161,
	"./nl-be": 162,
	"./nl-be.js": 162,
	"./nl.js": 161,
	"./nn": 163,
	"./nn.js": 163,
	"./oc-lnc": 164,
	"./oc-lnc.js": 164,
	"./pa-in": 165,
	"./pa-in.js": 165,
	"./pl": 166,
	"./pl.js": 166,
	"./pt": 49,
	"./pt-br": 167,
	"./pt-br.js": 167,
	"./pt.js": 49,
	"./ro": 168,
	"./ro.js": 168,
	"./ru": 169,
	"./ru.js": 169,
	"./sd": 170,
	"./sd.js": 170,
	"./se": 171,
	"./se.js": 171,
	"./si": 172,
	"./si.js": 172,
	"./sk": 173,
	"./sk.js": 173,
	"./sl": 174,
	"./sl.js": 174,
	"./sq": 175,
	"./sq.js": 175,
	"./sr": 176,
	"./sr-cyrl": 177,
	"./sr-cyrl.js": 177,
	"./sr.js": 176,
	"./ss": 178,
	"./ss.js": 178,
	"./sv": 179,
	"./sv.js": 179,
	"./sw": 180,
	"./sw.js": 180,
	"./ta": 181,
	"./ta.js": 181,
	"./te": 182,
	"./te.js": 182,
	"./tet": 183,
	"./tet.js": 183,
	"./tg": 184,
	"./tg.js": 184,
	"./th": 185,
	"./th.js": 185,
	"./tk": 186,
	"./tk.js": 186,
	"./tl-ph": 187,
	"./tl-ph.js": 187,
	"./tlh": 188,
	"./tlh.js": 188,
	"./tr": 189,
	"./tr.js": 189,
	"./tzl": 190,
	"./tzl.js": 190,
	"./tzm": 191,
	"./tzm-latn": 192,
	"./tzm-latn.js": 192,
	"./tzm.js": 191,
	"./ug-cn": 193,
	"./ug-cn.js": 193,
	"./uk": 194,
	"./uk.js": 194,
	"./ur": 195,
	"./ur.js": 195,
	"./uz": 196,
	"./uz-latn": 197,
	"./uz-latn.js": 197,
	"./uz.js": 196,
	"./vi": 198,
	"./vi.js": 198,
	"./x-pseudo": 199,
	"./x-pseudo.js": 199,
	"./yo": 200,
	"./yo.js": 200,
	"./zh-cn": 201,
	"./zh-cn.js": 201,
	"./zh-hk": 202,
	"./zh-hk.js": 202,
	"./zh-mo": 203,
	"./zh-mo.js": 203,
	"./zh-tw": 204,
	"./zh-tw.js": 204
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 313;

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = {"version":"2021a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020 +0030|.Q 0 -k -u|01212121212121212121212121212121212121212121212131313131313131|-2bRzX.8 9RbX.8 fdE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE Mok 1BXE M0k 1BXE fak 9vbu bjCu MLu 1Bcu MLu 1BAu MLu 1Bcu MLu 1Bcu MLu 1Bcu MLu|41e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EWT EPT EDT|59.u 50 40 40 40|01212314141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2kNuO.u 1drbO.u 6tX0 cp0 1hS0 pF0 J630 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 315 */,
/* 316 */,
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_7f7e65b2___ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_7f7e65b2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_7f7e65b2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_7f7e65b2___ = __webpack_require__(319);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_7f7e65b2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_7f7e65b2___["b"]; });


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Header'),_vm._v(" "),(_vm.user.name)?_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":200,"offset-x":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticStyle:{"z-index":"10 !important"},attrs:{"color":"blue","dark":"","fixed":"","top":"","right":"","fab":""}},on),[_vm._v("\n          "+_vm._s(_vm.getLetter(_vm.user?_vm.user.name.replace(' ', '+'):''))+"\n      ")])]}}],null,false,2485402860),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-card',[_c('v-list',[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.user?_vm.user.name:''))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.user?_vm.user.acesso:''))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();_vm.setDrawer(!_vm.drawer); _vm.menu = !_vm.menu}}},[_c('v-list-item-title',[_vm._v("Menu")])],1),_vm._v(" "),(_vm.user && _vm.user.acesso != 'Devedor')?_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();_vm.setDrawerRight(!_vm.drawerRight); _vm.menu = !_vm.menu}}},[_c('v-list-item-title',[_vm._v("Chat")])],1):_vm._e(),_vm._v(" "),_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.logout()}}},[_c('v-list-item-title',[_vm._v("Sair")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-content',{staticClass:"fill-height",class:[!_vm.isLoggin||_vm.isDesconto ? 'content-main' : ''],attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Observação")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.errorTest();}}},[_vm._v("Ok")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header_vue_vue_type_template_id_08ed56e1___ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header_vue_vue_type_script_lang_js___ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Header_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Header_vue_vue_type_template_id_08ed56e1___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Header_vue_vue_type_template_id_08ed56e1___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_template_id_08ed56e1___ = __webpack_require__(352);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_template_id_08ed56e1___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_template_id_08ed56e1___["b"]; });


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[(_vm.isLoggin)?_c('v-navigation-drawer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isDesconto),expression:"!isDesconto"}],attrs:{"clipped":"","width":"200","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-title',{staticStyle:{"font-size":"20px","margin":"10px"}},[(_vm.isLoggin)?_c('img',{attrs:{"src":_vm.empresa&&_vm.empresa.images?_vm.empresa.images[0].image:'static/img/logo.png',"alt":"Cobrança","height":"60px","width":"150px"}}):_vm._e()])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-title',{staticStyle:{"font-size":"20px"}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"outlined":"","append-icon":"search","required":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1),_vm._v(" "),_vm._l((_vm.filterItems(_vm.items)),function(item){return [(item.heading)?_c('v-row',{key:item.heading,attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"6"}},[(item.heading)?_c('v-subheader',[_vm._v(_vm._s(item.heading))]):_vm._e()],1),_vm._v(" "),_c('v-col',{staticClass:"text-center",attrs:{"cols":"6"}},[_c('a',{staticClass:"body-2 black--text",attrs:{"href":"#!"}},[_vm._v("EDIT")])])],1):(item.children)?_c('v-list-group',{key:item.text,attrs:{"append-icon":item.model ? item.icon : item['icon-alt']},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.text))])],1)],1)]},proxy:true}],null,true),model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-item',{key:i,attrs:{"to":{path:child.link}}},[(child.icon)?_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(child.text))])],1)],1)})],2):_c('v-list-item',{key:item.text,attrs:{"to":{path:item.link}}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.text))])],1)],1)]})],2)],1):_vm._e(),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"app":"","right":""},model:{value:(_vm.drawerRight),callback:function ($$v) {_vm.drawerRight=$$v},expression:"drawerRight"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',{staticStyle:{"font-size":"28px"}},[_c('v-list-item-title',[_vm._v("Chat Room")])],1)],1),_vm._v(" "),_vm._l((_vm.usuarios),function(usuario,i){return _c('v-list-item',{key:i,attrs:{"to":{path:_vm.getPath(usuario)}}},[_c('v-badge',{attrs:{"content":usuario.notificacao?usuario.notificacao.count:0,"value":usuario.notificacao?usuario.notificacao.count:0,"color":"green","overlap":""}},[_c('v-list-item-avatar',{staticStyle:{"margin-right":"2px","margin-left":"2px"}},[_c('img',{attrs:{"src":usuario.name?'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name='+usuario.name.replace(' ', '+')+'':''}})])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(usuario.name))])],1)],1)})],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"700"},model:{value:(_vm.dialogNotif),callback:function ($$v) {_vm.dialogNotif=$$v},expression:"dialogNotif"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Agendamento")])]),_vm._v(" "),(_vm.agendaNotif.agenda)?_c('v-card-text',[_vm._v("\n        Devedor: "+_vm._s(_vm.agendaNotif.agenda.iddevedor.Nome)+" "),_c('br'),_vm._v("\n        CPF: "+_vm._s(_vm.agendaNotif.agenda.iddevedor.CnpjCpf)+" "),_c('br'),_vm._v("\n        Data do agendamento: "+_vm._s(_vm._f("moment")(_vm.agendaNotif.agenda.data,"DD/MM/YYYY HH:mm"))+" "),_c('br')]):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogNotif = false}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.cobrarNotif(_vm.agendaNotif)}}},[_vm._v("Cobrar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',[_vm._v("\n        Carrregando, Aguarde..\n        "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var _this = this;


var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: "https://abcobranca-api.herokuapp.com" });
// const instance = axios.create({ baseURL: "http://localhost:8081" });


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null,
    error: null,
    server: "https://abcobranca-api.herokuapp.com",
    // server: "http://localhost:8081",
    loadingError: false,
    desconto: false,
    chats: null,
    usuarios: [],
    handle: ''
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setDesconto: function setDesconto(state, payload) {
      state.desconto = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },

    SET_CHAT: function SET_CHAT(state, payload) {
      state.chats = payload;
    },
    SET_USUARIOS: function SET_USUARIOS(state, payload) {
      state.usuarios = payload;
    },
    ADD_CHAT: function ADD_CHAT(state, payload) {
      state.chats.push(payload);
    },
    SET_HANDLE: function SET_HANDLE(state, payload) {
      state.handle = payload;
    }

  },
  actions: {
    SET_HANDLE: function SET_HANDLE(context, payload) {
      context.commit('SET_HANDLE', payload);
    },
    SET_CHAT: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, payload) {
        var _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return instance.get('/message/' + payload.path);

              case 2:
                _ref2 = _context.sent;
                data = _ref2.data;

                context.commit("SET_CHAT", data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function SET_CHAT(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(),
    SET_USUARIOS: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, payload) {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!payload) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 3;
                return instance.get("/users/getallid/" + payload._id);

              case 3:
                data = _context2.sent;

                if (payload.acesso == "Cliente") {
                  data.data = data.data.filter(function (el) {
                    return el.acesso != "Cliente";
                  });
                }
                context.commit("SET_USUARIOS", data.data);
                _context2.next = 9;
                break;

              case 8:
                context.commit("SET_USUARIOS", []);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function SET_USUARIOS(_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }(),
    ADD_CHAT: function ADD_CHAT(context, payload) {
      context.commit("ADD_CHAT", payload);
    },
    init: function init(_ref4, payload) {
      var _this2 = this;

      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var token, payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!localStorage.getItem("cobranca-token")) {
                  _context3.next = 5;
                  break;
                }

                token = localStorage.getItem("cobranca-token");
                payload = JSON.parse(window.atob(token.split(".")[1]));
                _context3.next = 5;
                return commit("setUser", payload);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    signUserUp: function signUserUp(_ref5, payload) {
      var _this3 = this;

      var commit = _ref5.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commit("setLoading", true);
                commit("clearError");
                _context5.next = 4;
                return instance.post("/users/register", payload).then(function () {
                  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(user) {
                    var newUser, userNew;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            commit("setLoading", false);
                            newUser = {
                              id: user.uid,
                              name: payload.email,
                              email: payload.email,
                              photoUrl: user.photoURL
                            };
                            userNew = JSON.parse(window.atob(user.data.token.split(".")[1]));

                            localStorage.setItem("cobranca-token", user.data.token);
                            _context4.t0 = commit;
                            _context4.next = 7;
                            return userNew;

                          case 7:
                            _context4.t1 = _context4.sent;
                            (0, _context4.t0)("setUser", _context4.t1);

                          case 9:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this3);
                  }));

                  return function (_x5) {
                    return _ref6.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  commit("setLoading", false);
                  commit("setError", error);
                  console.log(error);
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    signUserIn: function signUserIn(_ref7, payload) {
      var _this4 = this;

      var commit = _ref7.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var user, userNew;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                commit("setLoading", true);
                commit("clearError");
                _context6.next = 5;
                return instance.post("/users/login", payload);

              case 5:
                user = _context6.sent;

                commit("setLoading", false);
                _context6.next = 9;
                return JSON.parse(window.atob(user.data.token.split(".")[1]));

              case 9:
                userNew = _context6.sent;

                localStorage.setItem("cobranca-token", user.data.token);
                commit("setUser", userNew);
                _context6.next = 19;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](0);

                _context6.t0 = "Usuário ou senha invalido!";
                commit("setLoading", false);
                commit("setError", _context6.t0);

              case 19:
                ;

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this4, [[0, 14]]);
      }))();
    },
    signUserInGoogle: function signUserInGoogle(_ref8) {
      var commit = _ref8.commit;

      commit('setLoading', true);
      commit('clearError');
      firebase.getAuth().signInWithPopup(new firebase.getAuth().GoogleAuthProvider()).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserInFacebook: function signUserInFacebook(_ref9) {
      var commit = _ref9.commit;

      commit('setLoading', true);
      commit('clearError');
      firebase.getAuth().signInWithPopup(new firebase.getAuth().FacebookAuthProvider()).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserInGithub: function signUserInGithub(_ref10) {
      var commit = _ref10.commit;

      commit('setLoading', true);
      commit('clearError');
      firebase.getAuth().signInWithPopup(new firebase.getAuth().GithubAuthProvider()).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserInTwitter: function signUserInTwitter(_ref11) {
      var commit = _ref11.commit;

      commit('setLoading', true);
      commit('clearError');
      firebase.getAuth().signInWithPopup(new firebase.getAuth().TwitterAuthProvider()).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(_ref12, payload) {
      var commit = _ref12.commit;

      commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      });
    },
    desconto: function desconto(_ref13, payload) {
      var commit = _ref13.commit;

      commit("setDesconto", payload.val);
    },
    logout: function logout(_ref14) {
      var commit = _ref14.commit;

      localStorage.removeItem("cobranca-token");

      commit("SET_USUARIOS", []);
      commit('drawerRight', false);
      commit("setUser", null);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    server: function server(state) {
      return state.server;
    },
    desconto: function desconto(state) {
      return state.desconto;
    },

    CHATS: function CHATS(state) {
      return state.chats;
    },
    usuarios: function usuarios(state) {
      return state.usuarios;
    },
    HANDLE: function HANDLE(state) {
      return state.handle;
    }
  }
});

/***/ }),
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    drawer: true,
    drawerRight: false,
    error: null
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setDrawer: function setDrawer(state, payload) {
      state.drawer = payload;
    },
    setDrawerRight: function setDrawerRight(state, payload) {
      state.drawerRight = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    },

    setError: function setError(context, payload) {
      context.commit('setError', payload);
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    drawer: function drawer(state) {
      return state.drawer;
    },
    drawerRight: function drawerRight(state) {
      return state.drawerRight;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    devedor: {},
    acordo: {}
  },
  mutations: {
    setDevedor: function setDevedor(state, payload) {
      state.devedor = payload;
    },
    setAcordo: function setAcordo(state, payload) {
      state.acordo = payload;
    }
  },
  getters: {
    devedor: function devedor(state) {
      return state.devedor;
    },
    acordo: function acordo(state) {
      return state.acordo;
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppAlert_vue_vue_type_template_id_43f6ac4c___ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppAlert_vue_vue_type_script_lang_js___ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AppAlert_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__AppAlert_vue_vue_type_template_id_43f6ac4c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AppAlert_vue_vue_type_template_id_43f6ac4c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AppAlert_vue_vue_type_template_id_43f6ac4c___ = __webpack_require__(375);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AppAlert_vue_vue_type_template_id_43f6ac4c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AppAlert_vue_vue_type_template_id_43f6ac4c___["b"]; });


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"error":"","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []



/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */


/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Devedor__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_HelloWorld__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_cobranca_Cobranca__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_agenda_Agenda__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_user_Signin__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_user_Signup__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_user_Usuarios__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_user_Empresas__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_boletosbb_BoletosBB__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_clientes_Clientes__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_devedores_Devedores__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_dividas_Dividas__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_financeiro_Financeiro__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_recebimento_Recebimento__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_relatorios_Relatorio__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_relatorios_Dividas__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_painel_Painel__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_fechamento_Fechamento__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_chat_Chat__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_minhas_dividas_minhas_dividas__ = __webpack_require__(538);

























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  //mode: "history",
  routes: [{
    path: '/home-admin',
    name: 'HelloWorld',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_HelloWorld__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/minhas-dividas',
    name: 'MinhasDividas',
    component: __WEBPACK_IMPORTED_MODULE_23__pages_minhas_dividas_minhas_dividas__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/funcionario/cobranca',
    name: 'Cobranca',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_cobranca_Cobranca__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/funcionario/cobranca/:id',
    name: 'CobrancaId',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_cobranca_Cobranca__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/funcionario/agenda',
    name: 'Agenda',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_agenda_Agenda__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/boletosbb',
    name: 'BoletoBB',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_boletosbb_BoletosBB__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Home__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/devedor',
    name: 'Devedor',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Devedor__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/usuarios",
    name: "Usuarios",
    component: __WEBPACK_IMPORTED_MODULE_10__pages_user_Usuarios__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/empresas",
    name: "Empresas",
    component: __WEBPACK_IMPORTED_MODULE_11__pages_user_Empresas__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/clientes",
    name: "Clientes",
    component: __WEBPACK_IMPORTED_MODULE_13__pages_clientes_Clientes__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/devedores",
    name: "Devedores",
    component: __WEBPACK_IMPORTED_MODULE_14__pages_devedores_Devedores__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/dividas",
    name: "Dividas",
    component: __WEBPACK_IMPORTED_MODULE_15__pages_dividas_Dividas__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/financeiro",
    name: "Financeiro",
    component: __WEBPACK_IMPORTED_MODULE_16__pages_financeiro_Financeiro__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/recebimentos/:id',
    name: 'Recebimento',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_recebimento_Recebimento__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/painel',
    name: 'Painel',
    component: __WEBPACK_IMPORTED_MODULE_20__pages_painel_Painel__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/fechamento',
    name: 'Fechamento',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_fechamento_Fechamento__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/relatorio',
    name: 'Relatorio',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_relatorios_Relatorio__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/rel-dividas',
    name: 'RelDividas',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_relatorios_Dividas__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/chat/:id/:id2',
    name: 'Chat',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_chat_Chat__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  },
  /*{
    path: '/signin',
    name: 'Signin',
    component: Signin
    //beforeEnter: NoAuth
  },*/
  {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_user_Signup__["a" /* default */]
    //beforeEnter: AuthGuard
  }, {
    path: '/logout',
    name: 'Logout',
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }]
}));

/***/ }),
/* 379 */,
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_usuario__ = __webpack_require__(7);



var _this = this;




/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(to.fullPath === "/logout")) {
              _context.next = 4;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("logout");
            next("/");
            return _context.abrupt("return");

          case 4:

            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('desconto', { val: false });
            /*if (to.fullPath.includes("/cliente/cursos") || to.fullPath.includes("/funcionario")) {
              store.dispatch('desconto', {val: true});
            }*/
            _context.next = 7;
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("init");

          case 7:
            if (!(to.fullPath === "/devedor" && !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user)) {
              _context.next = 10;
              break;
            }

            next();
            return _context.abrupt("return");

          case 10:
            if (!(to.fullPath === "/devedor" && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user)) {
              _context.next = 13;
              break;
            }

            next("/funcionario/agenda");
            return _context.abrupt("return");

          case 13:
            if (!(to.fullPath !== "/" && !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user)) {
              _context.next = 16;
              break;
            }

            next("/");
            return _context.abrupt("return");

          case 16:
            if (!(to.fullPath === "/" && !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user)) {
              _context.next = 19;
              break;
            }

            next();
            return _context.abrupt("return");

          case 19:
            if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user) {
              _context.next = 97;
              break;
            }

            _context.next = 22;
            return __WEBPACK_IMPORTED_MODULE_3__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user._id);

          case 22:
            res = _context.sent;

            if (!res) {
              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("logout");
            }

            if (!(res.acesso == "Devedor")) {
              _context.next = 32;
              break;
            }

            if (!to.fullPath.includes("/minhas-dividas")) {
              _context.next = 30;
              break;
            }

            next();
            return _context.abrupt("return");

          case 30:
            next("/minhas-dividas");
            return _context.abrupt("return");

          case 32:
            if (!(res.acesso == "Funcionario")) {
              _context.next = 50;
              break;
            }

            if (!to.fullPath.includes("/recebimentos")) {
              _context.next = 38;
              break;
            }

            next();
            return _context.abrupt("return");

          case 38:
            if (!to.fullPath.includes("/chat")) {
              _context.next = 43;
              break;
            }

            next();
            return _context.abrupt("return");

          case 43:
            if (to.fullPath.includes("/funcionario")) {
              _context.next = 48;
              break;
            }

            next("/funcionario/agenda");
            return _context.abrupt("return");

          case 48:
            next();
            return _context.abrupt("return");

          case 50:
            if (!(res.acesso == "Cliente")) {
              _context.next = 73;
              break;
            }

            if (!to.fullPath.includes("/recebimentos")) {
              _context.next = 56;
              break;
            }

            next();
            return _context.abrupt("return");

          case 56:
            if (!to.fullPath.includes("/chat")) {
              _context.next = 61;
              break;
            }

            next();
            return _context.abrupt("return");

          case 61:
            if (!to.fullPath.includes("/dividas")) {
              _context.next = 66;
              break;
            }

            next();
            return _context.abrupt("return");

          case 66:
            if (!to.fullPath.includes("/painel")) {
              _context.next = 71;
              break;
            }

            next();
            return _context.abrupt("return");

          case 71:
            next("/recebimentos");
            return _context.abrupt("return");

          case 73:
            if (!(res.grand == "Admin")) {
              _context.next = 81;
              break;
            }

            if (!(to.fullPath == "/")) {
              _context.next = 79;
              break;
            }

            next("/painel");
            return _context.abrupt("return");

          case 79:
            next();
            return _context.abrupt("return");

          case 81:
            if (!(res.acesso == "AdminClientes")) {
              _context.next = 89;
              break;
            }

            if (!(to.fullPath == "/")) {
              _context.next = 87;
              break;
            }

            next("/painel");
            return _context.abrupt("return");

          case 87:
            next();
            return _context.abrupt("return");

          case 89:
            if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user) {
              _context.next = 97;
              break;
            }

            if (!(to.fullPath == "/")) {
              _context.next = 95;
              break;
            }

            next("/funcionario/agenda");
            return _context.abrupt("return");

          case 95:
            next();
            return _context.abrupt("return");

          case 97:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Home_vue_vue_type_template_id_8dab219e_scoped_true___ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_vue_vue_type_script_lang_js___ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_vue_vue_type_style_index_0_id_8dab219e_scoped_true_lang_css___ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Home_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Home_vue_vue_type_template_id_8dab219e_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Home_vue_vue_type_template_id_8dab219e_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "8dab219e",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_template_id_8dab219e_scoped_true___ = __webpack_require__(383);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_template_id_8dab219e_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_template_id_8dab219e_scoped_true___["b"]; });


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-2",attrs:{"xs12":"","sm4":"","offset-sm4":"","xl4":"","offset-xl4":""}},[_c('div',{staticClass:"text-xd-center text-md-center login"},[_c('v-card',{staticClass:"elevation-12"},[_c('v-card-text',{staticStyle:{"padding":"50px 50px 50px 50px"}},[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('img',{attrs:{"src":"/static/img/logo.png","alt":"Cobrança","height":"100px","width":"300px"}}),_vm._v(" "),_c('h4',{staticClass:"headline mb-0 text-xd-center text-md-center text-login"},[_vm._v("Log in")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-text-field',{staticClass:"input-login",attrs:{"outlined":"","label":"Usuário","append-icon":"perm_identity","hide-details":"","error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){return _vm.$v.email.$touch()},"blur":function($event){return _vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-text-field',{staticClass:"input-login",attrs:{"outlined":"","label":"Senha","type":"password","append-icon":"lock","hide-details":"","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){return _vm.$v.password.$touch()},"blur":function($event){return _vm.$v.password.$touch()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding":"0px 50px 50px 50px"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"text-transform-none",attrs:{"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Entrar")])],1)],1)],1)])],1)],1)])}
var staticRenderFns = []



/***/ }),
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_id_8dab219e_scoped_true_lang_css___ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_id_8dab219e_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_id_8dab219e_scoped_true_lang_css___);
/* unused harmony reexport namespace */


/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Devedor_html_vue_type_template_id_302aa0d4_scoped_true___ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Devedor_vue_vue_type_script_lang_js___ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Devedor_vue_vue_type_style_index_0_id_302aa0d4_scoped_true_lang_css___ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Devedor_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Devedor_html_vue_type_template_id_302aa0d4_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Devedor_html_vue_type_template_id_302aa0d4_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "302aa0d4",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Devedor_html_vue_type_template_id_302aa0d4_scoped_true___ = __webpack_require__(412);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Devedor_html_vue_type_template_id_302aa0d4_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Devedor_html_vue_type_template_id_302aa0d4_scoped_true___["b"]; });


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-2",attrs:{"xs12":"","sm4":"","offset-sm4":"","xl4":"","offset-xl4":""}},[_c('div',{staticClass:"text-xd-center text-md-center"},[_c('v-card',{staticClass:"elevation-12"},[_c('v-card-text',{staticStyle:{"padding":"50px 50px 50px 50px"}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('img',{attrs:{"src":"/static/img/logo.png","alt":"Cobrança","height":"100px","width":"300px"}}),_vm._v(" "),_c('h4',{staticClass:"headline mb-0 text-xd-center text-md-center text-login"},[_vm._v("Bem vindo")]),_vm._v(" "),_c('h5',{staticClass:"mb-0 text-xd-center text-md-center text-info"},[_vm._v("Informe seu CPF ou CNPJ para ver se tem dívida ativa")]),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}},[_c('v-radio',{attrs:{"label":"CPF","value":"cpf"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"CNPJ","value":"cnpj"}})],1)],1)],1),_vm._v(" "),(_vm.tipo == 'cpf')?_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskCPF),expression:"maskCPF"}],staticClass:"input-login",attrs:{"outlined":"","label":"CPF","hide-details":"","required":""},on:{"blur":function($event){return _vm.getSearch(_vm.cpf)}},model:{value:(_vm.cpf),callback:function ($$v) {_vm.cpf=$$v},expression:"cpf"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.tipo == 'cnpj')?_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskCNPJ),expression:"maskCNPJ"}],staticClass:"input-login",attrs:{"outlined":"","label":"CNPJ","hide-details":"","required":""},on:{"blur":function($event){return _vm.getSearch(_vm.cnpj)}},model:{value:(_vm.cnpj),callback:function ($$v) {_vm.cnpj=$$v},expression:"cnpj"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.devedor.Nome)?_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_vm._v("\n                      Bem vindo "+_vm._s(_vm.devedor.Nome)+"\n                  ")])],1):_vm._e(),_vm._v(" "),(_vm.mensagem && _vm.mensagem.length > 1 && !_vm.devedor.Nome)?_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_vm._v("\n                    "+_vm._s(_vm.mensagem)+"\n                  ")])],1):_vm._e(),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskTelefone),expression:"maskTelefone"}],staticClass:"input-login",attrs:{"outlined":"","label":"Telefone","single-line":"","hide-details":"","required":""},model:{value:(_vm.telefone),callback:function ($$v) {_vm.telefone=$$v},expression:"telefone"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-text-field',{staticClass:"input-login",attrs:{"outlined":"","label":"Email","append-icon":"perm_identity","hide-details":"","error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){return _vm.$v.email.$touch()},"blur":function($event){return _vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-text-field',{staticClass:"input-login",attrs:{"outlined":"","label":"Senha","type":"password","append-icon":"lock","hide-details":"","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){return _vm.$v.password.$touch()},"blur":function($event){return _vm.$v.password.$touch()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding":"0px 50px 50px 50px"}},[_c('h3',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.entrar()}}},[_vm._v("Já sou Cadastrado")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"text-transform-none",attrs:{"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Cadastrar")])],1)],1)],1)])],1)],1)])}
var staticRenderFns = []



/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Devedor_vue_vue_type_style_index_0_id_302aa0d4_scoped_true_lang_css___ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Devedor_vue_vue_type_style_index_0_id_302aa0d4_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Devedor_vue_vue_type_style_index_0_id_302aa0d4_scoped_true_lang_css___);
/* unused harmony reexport namespace */


/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelloWorld_vue_vue_type_template_id_07a65424_scoped_true___ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelloWorld_vue_vue_type_script_lang_js___ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__HelloWorld_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__HelloWorld_vue_vue_type_template_id_07a65424_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__HelloWorld_vue_vue_type_template_id_07a65424_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "07a65424",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HelloWorld_vue_vue_type_template_id_07a65424_scoped_true___ = __webpack_require__(417);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HelloWorld_vue_vue_type_template_id_07a65424_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HelloWorld_vue_vue_type_template_id_07a65424_scoped_true___["b"]; });


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []



/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cobranca_html_vue_type_template_id_7ba8c6a1_scoped_true___ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cobranca_vue_vue_type_script_lang_js___ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cobranca_vue_vue_type_style_index_0_id_7ba8c6a1_lang_css_scoped_true___ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Cobranca_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Cobranca_html_vue_type_template_id_7ba8c6a1_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Cobranca_html_vue_type_template_id_7ba8c6a1_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "7ba8c6a1",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Cobranca_html_vue_type_template_id_7ba8c6a1_scoped_true___ = __webpack_require__(420);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Cobranca_html_vue_type_template_id_7ba8c6a1_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Cobranca_html_vue_type_template_id_7ba8c6a1_scoped_true___["b"]; });


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('v-layout',{attrs:{"column":"","wrap":""}},[_c('v-container',[_c('v-card',[_c('v-container',{attrs:{"grid-list-x1":""}},[_c('v-card-title',{staticStyle:{"padding-bottom":"0px"}},[_vm._v("\n              Cobrança\n              "),_c('v-spacer'),_vm._v(" "),_c('v-radio-group',{attrs:{"mandatory":"","row":""},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.tipoConsulta),callback:function ($$v) {_vm.tipoConsulta=$$v},expression:"tipoConsulta"}},[_c('v-radio',{attrs:{"label":"Nome","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"CPF","value":"2"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"CNPJ","value":"3"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Telefone","value":"4"}})],1),_vm._v(" "),_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.tipoConsulta==2?_vm.maskCPF:_vm.tipoConsulta==3?_vm.maskCNPJ:_vm.tipoConsulta==4?_vm.mask:''),expression:"tipoConsulta==2?maskCPF:tipoConsulta==3?maskCNPJ:tipoConsulta==4?mask:''"}],staticClass:"mr-2 ml-2",attrs:{"outlined":"","label":"Buscar Devedor","append-icon":"search","required":""},on:{"blur":function($event){return _vm.getSearch(_vm.search)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getSearch(_vm.search)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"small":""},on:{"click":function($event){return _vm.setDevedor({})}}},[_vm._v("Limpar Devedor")])],1),_vm._v(" "),_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.devedor.Nome),expression:"devedor.Nome"}],attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"4"}},[_c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Admin'),expression:"user.acesso == 'Admin'"}]},[_vm._v("ID: "+_vm._s(_vm.devedor?_vm.devedor._id:'')+" "),_c('br')]),_vm._v("\n                  Nome: "+_vm._s(_vm.devedor?_vm.devedor.Nome:'')+" "),_c('br'),_vm._v("\n                  CPF: "+_vm._s(_vm.devedor?_vm.devedor.CnpjCpf:'')),_c('br'),_vm._v("\n                  Nascimento: "+_vm._s(_vm.devedor?_vm.devedor.DataNascimento:'')),_c('br'),_c('br'),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"md":"4"}},[_c('v-btn',{attrs:{"small":"","color":_vm.devedor.IsAtivo?'green':'red'},on:{"click":function($event){return _vm.bloquearDevedor(_vm.devedor)}}},[_vm._v("\n                      "+_vm._s(_vm.devedor.IsAtivo?'Cobrar':'Não Cobrar'))])],1),_vm._v(" "),_c('v-col',{attrs:{"md":"4","offset-md":"4"}},[_c('v-btn',{attrs:{"small":"","color":"blue"},on:{"click":_vm.proximo}},[_vm._v("Próximo")])],1)],1)],1)]),_vm._v(" "),_c('v-col',{attrs:{"cols":"8"}},[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.devedor.Nome),expression:"devedor.Nome"}]},[_c('v-data-table',{attrs:{"headers":_vm.headersDividas,"items":_vm.devedor.dividas&&_vm.devedor.dividas.length > 0?_vm.devedor.dividas:[],"hide-default-footer":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{class:_vm.getColorDivida(props.item),on:{"click":function($event){return _vm.setAcordoInterno(props.item)}}},[_c('td',[_vm._v(_vm._s(props.item.Identificador))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.idcliente.Nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("currency")(props.item.ValorEmpresa)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getStatusAcordo(props.item)))]),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"small":"","disabled":props.item.StatusDivida != 1 && props.item.StatusDivida != 5,"color":props.item.IsBloqueado?'red':'green'},on:{"click":function($event){return _vm.bloquearDivida(props.item)}}},[_vm._v("\n                            "+_vm._s(props.item.IsBloqueado?'Não Cobrar':'Cobrar')+"\n                          ")])],1)])]}}])}),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"md":"4","offset-md":"4"}},[_vm._v("\n                      Quantidade: "+_vm._s(_vm.devedor.dividas&&_vm.devedor.dividas.length > 0?_vm.devedor.dividas.length:0)+"\n                    ")]),_vm._v(" "),_c('v-col',{attrs:{"md":"4"}},[_vm._v("\n                      Valor Total:\n                      "+_vm._s(_vm._f("currency")(_vm.devedor.dividas&&_vm.devedor.dividas.length > 0?_vm.devedor.dividas.map(function (item) {return item.ValorEmpresa}).reduce(function (prev, next) {return (prev + next)}):0))+"\n                    ")])],1)],1)],1)],1),_vm._v(" "),_c('v-tabs',{directives:[{name:"show",rawName:"v-show",value:(_vm.devedor.Nome),expression:"devedor.Nome"}],staticStyle:{"margin-top":"30px"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:0,attrs:{"ripple":""}},[_vm._v("\n                Ocorrencias\n              ")]),_vm._v(" "),_c('v-tab',{key:1,attrs:{"ripple":""}},[_vm._v("\n                Contato\n              ")]),_vm._v(" "),_c('v-tab',{key:2,attrs:{"ripple":""}},[_vm._v("\n                Endereço\n              ")]),_vm._v(" "),_c('v-tab',{key:3,attrs:{"disabled":!_vm.devedor.IsAtivo,"ripple":""}},[_vm._v("\n                Negociação\n              ")]),_vm._v(" "),_c('v-tab',{key:4,attrs:{"ripple":""}},[_vm._v("\n                Documentos\n              ")]),_vm._v(" "),_c('v-tab',{key:5,attrs:{"ripple":""}},[_vm._v("\n                Acordo\n              ")]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab-item',{key:1},[_c('v-data-table',{attrs:{"headers":_vm.headersOcorrencias,"items":_vm.devedor?_vm.devedor.ocorrencias:[],"sort-by":['createdAt'],"sort-desc":[true]},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{class:_vm.getColor(props.item.status)},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(props.item.createdAt,"DD/MM/YYYY HH:mm")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.telefone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.subacao))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(props.item.data,"DD/MM/YYYY")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.hora))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.user?props.item.user.name:''))])])]}}])}),_vm._v(" "),_c('div',{staticClass:"my-2"},[_c('v-btn',{attrs:{"small":"","color":"primary"},nativeOn:{"click":function($event){return _vm.novaOcorrencia(_vm.devedor)}}},[_vm._v("Nova Ocorrência")])],1)],1),_vm._v(" "),_c('v-tab-item',{key:2},[_c('Telefone'),_vm._v(" "),_c('Email')],1),_vm._v(" "),_c('v-tab-item',{key:3},[_c('Endereco')],1),_vm._v(" "),_c('v-tab-item',{key:4},[_c('Negociacao')],1),_vm._v(" "),_c('v-tab-item',{key:5},[_c('v-data-table',{attrs:{"headers":_vm.headersPdfs,"items":_vm.acordo?_vm.acordo.images:[]},scopedSlots:_vm._u([{key:"item.descricao",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"target":"_blank","href":item.image}},[_vm._v(_vm._s(item.descricao))])]}}])})],1),_vm._v(" "),_c('v-tab-item',{key:6},[_c('Acordos')],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"70%"},model:{value:(_vm.dialogDevedores),callback:function ($$v) {_vm.dialogDevedores=$$v},expression:"dialogDevedores"}},[_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.devedores,"sort-by":'Nome',"item-key":"Nome"},on:{"click:row":_vm.selectedDevedor}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogDevedores=false}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialogOcorrencia),callback:function ($$v) {_vm.dialogOcorrencia=$$v},expression:"dialogOcorrencia"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Nova Ocorrência")]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-select',{attrs:{"items":_vm.items,"label":"Status"},model:{value:(_vm.model.status),callback:function ($$v) {_vm.$set(_vm.model, "status", $$v)},expression:"model.status"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"label":"Telefone","single-line":"","placeholder":"(##) #####-####","rules":_vm.telefoneRules,"required":""},model:{value:(_vm.model.telefone),callback:function ($$v) {_vm.$set(_vm.model, "telefone", $$v)},expression:"model.telefone"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-text-field',{attrs:{"label":"Sub Ação","single-line":"","rules":_vm.subRules,"required":""},model:{value:(_vm.model.subacao),callback:function ($$v) {_vm.$set(_vm.model, "subacao", $$v)},expression:"model.subacao"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-checkbox',{attrs:{"label":"Novo Agendamento"},model:{value:(_vm.model.agendamento),callback:function ($$v) {_vm.$set(_vm.model, "agendamento", $$v)},expression:"model.agendamento"}})],1)],1),_vm._v(" "),_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.agendamento),expression:"model.agendamento"}],attrs:{"justify":"space-around","align":"center"}},[_c('v-col',{attrs:{"sm":"6"}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Date","persistent-hint":"","prepend-icon":"event"},on:{"blur":function($event){_vm.date2 = _vm.parseDate(_vm.dateFormatted2);}},model:{value:(_vm.dateFormatted2),callback:function ($$v) {_vm.dateFormatted2=$$v},expression:"dateFormatted2"}},on))]}}]),model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","no-title":""},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskHora),expression:"maskHora"}],attrs:{"label":"Hora","single-line":"","placeholder":"08:00","required":""},model:{value:(_vm.model.hora),callback:function ($$v) {_vm.$set(_vm.model, "hora", $$v)},expression:"model.hora"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1","disabled":_vm.loading},nativeOn:{"click":function($event){return _vm.salvar()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogOcorrencia = false}}},[_vm._v("Cancelar")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Endereco_vue_vue_type_template_id_66cb29e4___ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Endereco_vue_vue_type_script_lang_js___ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Endereco_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Endereco_vue_vue_type_template_id_66cb29e4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Endereco_vue_vue_type_template_id_66cb29e4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Endereco_vue_vue_type_template_id_66cb29e4___ = __webpack_require__(428);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Endereco_vue_vue_type_template_id_66cb29e4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Endereco_vue_vue_type_template_id_66cb29e4___["b"]; });


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headersEndereco,"items":_vm.devedor.enderecos?_vm.devedor.enderecos:[]},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{class:_vm.getColorEndereco(props.item)},[_c('td',[_vm._v(_vm._s(props.item.logradouro))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.numero))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.bairro))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.localidade))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.uf))]),_vm._v(" "),_c('td',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_vm._v("\n            edit\n          ")]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Admin'),expression:"user.acesso == 'Admin'"}],attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_vm._v("\n            delete\n          ")])],1)])]}}])}),_vm._v(" "),_c('div',{staticClass:"my-2"},[_c('v-btn',{attrs:{"small":"","color":"primary"},nativeOn:{"click":function($event){return _vm.novoEndereco(_vm.devedor)}}},[_vm._v("Novo Endereço")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialogEndereco),callback:function ($$v) {_vm.dialogEndereco=$$v},expression:"dialogEndereco"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Novo Endereço")]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-row',[_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"label":"Cep","placeholder":"#####-###","required":""},on:{"blur":function($event){return _vm.freteCep(_vm.modelEndereco.cep)}},model:{value:(_vm.modelEndereco.cep),callback:function ($$v) {_vm.$set(_vm.modelEndereco, "cep", $$v)},expression:"modelEndereco.cep"}})],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{attrs:{"label":"Logradouro","required":""},model:{value:(_vm.modelEndereco.logradouro),callback:function ($$v) {_vm.$set(_vm.modelEndereco, "logradouro", $$v)},expression:"modelEndereco.logradouro"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{attrs:{"label":"Numero","type":"number","required":""},model:{value:(_vm.modelEndereco.numero),callback:function ($$v) {_vm.$set(_vm.modelEndereco, "numero", $$v)},expression:"modelEndereco.numero"}})],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{attrs:{"label":"Bairro","required":""},model:{value:(_vm.modelEndereco.bairro),callback:function ($$v) {_vm.$set(_vm.modelEndereco, "bairro", $$v)},expression:"modelEndereco.bairro"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{attrs:{"label":"Localidade","required":""},model:{value:(_vm.modelEndereco.localidade),callback:function ($$v) {_vm.$set(_vm.modelEndereco, "localidade", $$v)},expression:"modelEndereco.localidade"}})],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{attrs:{"label":"UF","required":""},model:{value:(_vm.modelEndereco.uf),callback:function ($$v) {_vm.$set(_vm.modelEndereco, "uf", $$v)},expression:"modelEndereco.uf"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-text-field',{attrs:{"label":"Complemento","type":"text","required":""},model:{value:(_vm.modelEndereco.complemento),callback:function ($$v) {_vm.$set(_vm.modelEndereco, "complemento", $$v)},expression:"modelEndereco.complemento"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-checkbox',{attrs:{"label":"Hot"},model:{value:(_vm.modelEndereco.hot),callback:function ($$v) {_vm.$set(_vm.modelEndereco, "hot", $$v)},expression:"modelEndereco.hot"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.salvarEndereco()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogEndereco = false}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Telefone_vue_vue_type_template_id_1cc90706___ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Telefone_vue_vue_type_script_lang_js___ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Telefone_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Telefone_vue_vue_type_template_id_1cc90706___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Telefone_vue_vue_type_template_id_1cc90706___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Telefone_vue_vue_type_template_id_1cc90706___ = __webpack_require__(431);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Telefone_vue_vue_type_template_id_1cc90706___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Telefone_vue_vue_type_template_id_1cc90706___["b"]; });


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headersTelefone,"items":_vm.devedor.telefones?_vm.devedor.telefones:[]},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{class:_vm.getColor(props.item),style:(props.item.black?'text-decoration: line-through':'')},[_c('td',[_vm._v(_vm._s(props.item.telefone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quem))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tipo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.whatsapp?"Sim":"Não"))]),_vm._v(" "),_c('td',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_vm._v("\n            edit\n          ")]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Admin'),expression:"user.acesso == 'Admin'"}],attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_vm._v("\n            delete\n          ")])],1)])]}}])}),_vm._v(" "),_c('div',{staticClass:"my-2"},[_c('v-btn',{attrs:{"small":"","color":"primary"},nativeOn:{"click":function($event){return _vm.novo(_vm.devedor)}}},[_vm._v("Novo Telefone")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Novo Telefone")]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"label":"Telefone","single-line":"","placeholder":"(##)####-####","required":""},model:{value:(_vm.model.telefone),callback:function ($$v) {_vm.$set(_vm.model, "telefone", $$v)},expression:"model.telefone"}})],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('v-select',{attrs:{"items":_vm.items,"label":"Tipo"},model:{value:(_vm.model.tipo),callback:function ($$v) {_vm.$set(_vm.model, "tipo", $$v)},expression:"model.tipo"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"2"}},[_c('v-checkbox',{attrs:{"label":"Hot","disabled":_vm.model.black},model:{value:(_vm.model.hot),callback:function ($$v) {_vm.$set(_vm.model, "hot", $$v)},expression:"model.hot"}})],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"2"}},[_c('v-checkbox',{attrs:{"label":"Black List"},on:{"change":function($event){_vm.model.hot=false}},model:{value:(_vm.model.black),callback:function ($$v) {_vm.$set(_vm.model, "black", $$v)},expression:"model.black"}})],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"2"}},[_c('v-checkbox',{attrs:{"label":"Whatsapp"},model:{value:(_vm.model.whatsapp),callback:function ($$v) {_vm.$set(_vm.model, "whatsapp", $$v)},expression:"model.whatsapp"}})],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('v-select',{attrs:{"items":_vm.itemsQuem,"label":"Quem"},model:{value:(_vm.model.quem),callback:function ($$v) {_vm.$set(_vm.model, "quem", $$v)},expression:"model.quem"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.salvar()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Email_vue_vue_type_template_id_7850b49d___ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Email_vue_vue_type_script_lang_js___ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Email_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Email_vue_vue_type_template_id_7850b49d___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Email_vue_vue_type_template_id_7850b49d___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Email_vue_vue_type_template_id_7850b49d___ = __webpack_require__(434);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Email_vue_vue_type_template_id_7850b49d___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Email_vue_vue_type_template_id_7850b49d___["b"]; });


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headersEmail,"items":_vm.devedor.emails?_vm.devedor.emails:[]},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{class:_vm.getColor(props.item)},[_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tipo))]),_vm._v(" "),_c('td',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_vm._v("\n            edit\n          ")]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Admin'),expression:"user.acesso == 'Admin'"}],attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_vm._v("\n            delete\n          ")])],1)])]}}])}),_vm._v(" "),_c('div',{staticClass:"my-2"},[_c('v-btn',{attrs:{"small":"","color":"primary"},nativeOn:{"click":function($event){return _vm.novo(_vm.devedor)}}},[_vm._v("Novo Email")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Novo Email")]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{attrs:{"label":"E-mail","rules":_vm.emailRules,"required":""},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('v-select',{attrs:{"items":_vm.items,"label":"Tipo"},model:{value:(_vm.model.tipo),callback:function ($$v) {_vm.$set(_vm.model, "tipo", $$v)},expression:"model.tipo"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-checkbox',{attrs:{"label":"Hot"},model:{value:(_vm.model.hot),callback:function ($$v) {_vm.$set(_vm.model, "hot", $$v)},expression:"model.hot"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},on:{"click":function($event){return _vm.salvar()}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},on:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},on:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Negociacao_html_vue_type_template_id_30e4b6a8_scoped_true___ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Negociacao_vue_vue_type_script_lang_js___ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Negociacao_vue_vue_type_style_index_0_id_30e4b6a8_scoped_true_lang_css___ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Negociacao_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Negociacao_html_vue_type_template_id_30e4b6a8_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Negociacao_html_vue_type_template_id_30e4b6a8_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "30e4b6a8",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Negociacao_html_vue_type_template_id_30e4b6a8_scoped_true___ = __webpack_require__(437);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Negociacao_html_vue_type_template_id_30e4b6a8_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Negociacao_html_vue_type_template_id_30e4b6a8_scoped_true___["b"]; });


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.acordo)?_c('v-card',[_vm._v("\n    Sem dívida ou Acordo cancelado.\n  ")]):_vm._e(),_vm._v(" "),(_vm.acordo)?_c('v-card',[_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Situação do Contrato")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Acordo")])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Empresa")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h4',[_vm._v(_vm._s(_vm.acordo&&_vm.acordo.idcliente?_vm.acordo.idcliente.Nome:''))])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Tipo do Produto")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h4',[_vm._v(_vm._s(_vm.getTipoProduto(_vm.acordo.TipoProduto)))])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Saldo Inicial")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h4',[_vm._v(_vm._s(_vm._f("currency")(_vm.acordo.ValorDivida)))])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Data Inicial")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h4',[_vm._v(_vm._s(_vm.acordo.DataDivida))])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Dias Atraso")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h4',[_vm._v(_vm._s(_vm.getDiasAtraso(_vm.acordo.DataDivida)  + ' dias'))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.getMesesAtraso(_vm.acordo.DataDivida) + ' meses'))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.getAnosAtraso(_vm.acordo.DataDivida) + ' anos'))])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('h4',[_vm._v("Especificação: ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.acordo.Especificacao))])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Valor Atual")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h4',[_vm._v(_vm._s(_vm._f("currency")(_vm.acordo.ValorEmpresa)))])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('v-textarea',{attrs:{"label":"Detalhes do Acordo","rows":"2","required":""},model:{value:(_vm.acordo.detalhes),callback:function ($$v) {_vm.$set(_vm.acordo, "detalhes", $$v)},expression:"acordo.detalhes"}})],1)],1),_vm._v(" "),(_vm.acordo.ValorRepasse)?_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Valor Repasse")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h4',[_vm._v(_vm._s(_vm._f("currency")(_vm.acordo.ValorRepasse)))])])],1):_vm._e(),_vm._v(" "),(_vm.acordo.ValorNegociado)?_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Valor Negociado")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h4',[_vm._v(_vm._s(_vm._f("currency")(_vm.acordo.ValorNegociado)))])])],1):_vm._e(),_vm._v(" "),(_vm.acordo.StatusDivida == 1)?_c('v-row',[_c('v-col',{attrs:{"sm":"8"}},[_c('v-radio-group',{attrs:{"row":""},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.acordo.proposta),callback:function ($$v) {_vm.$set(_vm.acordo, "proposta", $$v)},expression:"acordo.proposta"}},[_c('v-radio',{attrs:{"label":"Proposta Fixa","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Exceção","value":"2"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.acordo.StatusDivida == 1)?_c('v-row',[_c('v-col',{staticClass:"label-negociacao",attrs:{"sm":"2"}},[_c('h3',[_vm._v("Valor Acordo")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"2"}},[_c('v-currency-field',{attrs:{"label":"Valor do Acordo","disabled":_vm.acordo.proposta == '1',"prefix":"R$ "},model:{value:(_vm.acordo.ValorAcordo),callback:function ($$v) {_vm.$set(_vm.acordo, "ValorAcordo", $$v)},expression:"acordo.ValorAcordo"}})],1),_vm._v(" "),_c('v-col',{staticClass:"label-negociacao",attrs:{"sm":"1"}},[_c('h3',[_vm._v("Parcela")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"1"}},[_c('v-text-field',{attrs:{"type":"Number","label":"Parcelas","required":""},model:{value:(_vm.acordo.nrParcela),callback:function ($$v) {_vm.$set(_vm.acordo, "nrParcela", $$v)},expression:"acordo.nrParcela"}})],1),_vm._v(" "),_c('v-col',{staticClass:"label-negociacao",attrs:{"sm":"2"}},[_c('h3',[_vm._v("Vencimento Parcela")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"2"}},[_c('v-menu',{ref:"menu3",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Date","persistent-hint":"","prepend-icon":"event"},on:{"blur":function($event){_vm.date3 = _vm.parseDate(_vm.dateFormatted3);}},model:{value:(_vm.dateFormatted3),callback:function ($$v) {_vm.dateFormatted3=$$v},expression:"dateFormatted3"}},on))]}}],null,false,3839297090),model:{value:(_vm.menu3),callback:function ($$v) {_vm.menu3=$$v},expression:"menu3"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"allowed-dates":_vm.allowedDatesParcela,"min":new Date().toISOString().substr(0, 10),"locale":"pt-br","no-title":""},on:{"input":function($event){_vm.menu3 = false}},model:{value:(_vm.date3),callback:function ($$v) {_vm.date3=$$v},expression:"date3"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.acordo.StatusDivida == 1)?_c('v-row',[_c('v-col',{staticClass:"label-negociacao",attrs:{"sm":"2"}},[_c('h3',[_vm._v("Valor Entrada")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"2"}},[_c('v-currency-field',{attrs:{"label":"Entrada","prefix":"R$ "},model:{value:(_vm.acordo.ValorEntrada),callback:function ($$v) {_vm.$set(_vm.acordo, "ValorEntrada", $$v)},expression:"acordo.ValorEntrada"}})],1),_vm._v(" "),_c('v-col',{staticClass:"label-negociacao",attrs:{"sm":"2"}},[_c('h3',[_vm._v("Vencimento Entrada")])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"2"}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Date","persistent-hint":"","prepend-icon":"event"},on:{"blur":function($event){_vm.date2 = _vm.parseDate(_vm.dateFormatted2);}},model:{value:(_vm.dateFormatted2),callback:function ($$v) {_vm.dateFormatted2=$$v},expression:"dateFormatted2"}},on))]}}],null,false,3764364771),model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"allowed-dates":_vm.allowedDates,"min":new Date().toISOString().substr(0, 10),"locale":"pt-br","no-title":""},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.acordo.StatusDivida == 1)?_c('v-row',[_c('v-col',{attrs:{"sm":"8"}},[_c('v-radio-group',{attrs:{"row":""},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.acordo.tipoPagamento),callback:function ($$v) {_vm.$set(_vm.acordo, "tipoPagamento", $$v)},expression:"acordo.tipoPagamento"}},[_c('v-radio',{attrs:{"label":"Boleto","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Deposito","value":"2"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Escritório","value":"3"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Na Loja","value":"4"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Pix","value":"5"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.acordo.StatusDivida == 1)?_c('v-row',[_c('v-col',{attrs:{"sm":"8"}},[_c('v-radio-group',{attrs:{"row":""},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.acordo.tipoNegociacao),callback:function ($$v) {_vm.$set(_vm.acordo, "tipoNegociacao", $$v)},expression:"acordo.tipoNegociacao"}},[_c('v-radio',{attrs:{"label":"Acordo Novo","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Reativação","value":"2"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Renegociação","value":"3"}})],1)],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.acordo.StatusDivida == 1)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){return _vm.salvar(false)}}},[_vm._v("Fechar Acordo")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.acordo)?_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogParcela),callback:function ($$v) {_vm.dialogParcela=$$v},expression:"dialogParcela"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Parcelas")]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headersParcelas,"items":_vm.acordo.parcelas},scopedSlots:_vm._u([{key:"item.vencimento",fn:function(props){return [_c('v-edit-dialog',{attrs:{"return-value":props.item.vencimento},on:{"update:returnValue":function($event){return _vm.$set(props.item, "vencimento", $event)},"update:return-value":function($event){return _vm.$set(props.item, "vencimento", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"label":"Vencimento","single-line":""},model:{value:(props.item.vencimento),callback:function ($$v) {_vm.$set(props.item, "vencimento", $$v)},expression:"props.item.vencimento"}})]},proxy:true}],null,true)},[_vm._v(" "+_vm._s(props.item.vencimento)+"\n              ")])]}},{key:"item.valor",fn:function(props){return [_c('v-edit-dialog',{attrs:{"return-value":props.item.valor},on:{"update:returnValue":function($event){return _vm.$set(props.item, "valor", $event)},"update:return-value":function($event){return _vm.$set(props.item, "valor", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"Number","label":"Valor"},model:{value:(props.item.valor),callback:function ($$v) {_vm.$set(props.item, "valor", $$v)},expression:"props.item.valor"}})]},proxy:true}],null,true)},[_vm._v(" "+_vm._s(_vm._f("currency")(props.item.valor))+"\n              ")])]}}],null,false,2828517081)}),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"md":"6"}},[_vm._v("\n            Valor Acordo:\n            "),_c('span',[_vm._v(_vm._s(_vm.acordo.ValorAcordo))])]),_vm._v(" "),_c('v-col',{attrs:{"md":"6"}},[_vm._v("\n            Valor Parcelas:\n            "),_c('span',[_vm._v(_vm._s(_vm.calculaParcelas(_vm.acordo.parcelas)))])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"md":"6"}},[_c('h3',[_vm._v("Informe o telefone de Fechamento do Acordo")])])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"md":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"label":"Telefone","single-line":"","placeholder":"(##)####-####","required":""},model:{value:(_vm.acordo.telefone),callback:function ($$v) {_vm.$set(_vm.acordo, "telefone", $$v)},expression:"acordo.telefone"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogParcela = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1","disabled":_vm.loading},nativeOn:{"click":function($event){return _vm.salvar(true)}}},[_vm._v("Sim")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogError),callback:function ($$v) {_vm.dialogError=$$v},expression:"dialogError"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Observação")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){_vm.dialogError = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 438 */,
/* 439 */,
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Negociacao_vue_vue_type_style_index_0_id_30e4b6a8_scoped_true_lang_css___ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Negociacao_vue_vue_type_style_index_0_id_30e4b6a8_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Negociacao_vue_vue_type_style_index_0_id_30e4b6a8_scoped_true_lang_css___);
/* unused harmony reexport namespace */


/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Acordos_vue_vue_type_template_id_371ae8d8___ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Acordos_vue_vue_type_script_lang_js___ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Acordos_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Acordos_vue_vue_type_template_id_371ae8d8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Acordos_vue_vue_type_template_id_371ae8d8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_template_id_371ae8d8___ = __webpack_require__(444);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_template_id_371ae8d8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_template_id_371ae8d8___["b"]; });


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headersAcordo,"items":_vm.devedor.acordos?_vm.devedor.acordos:[],"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{class:_vm.getColorEndereco(props.item),on:{"click":function($event){return _vm.abrirAcordo(props.item)}}},[_c('td',[_vm._v(_vm._s(props.item.user?props.item.user.name:''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.cliente?props.item.cliente.Nome:''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("currency")(props.item.ValorAcordo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getProposta(props.item.proposta)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getPagamento(props.item.tipoPagamento)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("currency")(props.item.ValorDivida)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.detalhes))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getStatusAcordo(props.item.StatusAcordo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(props.item.createdAt,"DD/MM/YYYY HH:mm")))])])]}}])}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialogParcela),callback:function ($$v) {_vm.dialogParcela=$$v},expression:"dialogParcela"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Parcelas")]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headersParcelas,"items":_vm.acordo.parcelas,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.numero",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.numero+'/'+_vm.acordo.parcelas.length))])]}},{key:"item.vencimento",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.vencimento,"DD/MM/YYYY")))])]}},{key:"item.valor",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(item.valor)))])]}},{key:"item.boleto",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"small":"","disabled":_vm.desabilitarPagamento(_vm.acordo, item)},on:{"click":function($event){return _vm.gerarBoleto(item)}}},[_vm._v(_vm._s(item.juno||item.secure_url?'Imprimir':'Gerar'))])]}},{key:"item.stPago",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.getStPago(item)))])]}},{key:"item.dtPagamento",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.dtPagamento,"DD/MM/YYYY")))])]}}])}),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"md":"6","offset-md":"3"}},[_vm._v("\n            Valor Total:\n            "),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.acordo.parcelas&&_vm.acordo.parcelas.length>0?_vm.acordo.parcelas.map(function (item) {return item.valor}).reduce(function (prev, next) {return (prev + next)}):0)))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogParcela = false}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogError),callback:function ($$v) {_vm.dialogError=$$v},expression:"dialogError"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Observação")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){_vm.dialogError = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 445 */,
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Cobranca_vue_vue_type_style_index_0_id_7ba8c6a1_lang_css_scoped_true___ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Cobranca_vue_vue_type_style_index_0_id_7ba8c6a1_lang_css_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Cobranca_vue_vue_type_style_index_0_id_7ba8c6a1_lang_css_scoped_true___);
/* unused harmony reexport namespace */


/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Agenda_html_vue_type_template_id_2bbdff7b___ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Agenda_vue_vue_type_script_lang_js___ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Agenda_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Agenda_html_vue_type_template_id_2bbdff7b___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Agenda_html_vue_type_template_id_2bbdff7b___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Agenda_html_vue_type_template_id_2bbdff7b___ = __webpack_require__(450);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Agenda_html_vue_type_template_id_2bbdff7b___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Agenda_html_vue_type_template_id_2bbdff7b___["b"]; });


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Agenda\n          "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Date","persistent-hint":"","prepend-icon":"event"},on:{"blur":function($event){_vm.date = _vm.parseDate(_vm.dateFormatted);}},model:{value:(_vm.dateFormatted),callback:function ($$v) {_vm.dateFormatted=$$v},expression:"dateFormatted"}},on))]}}]),model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","no-title":""},on:{"input":function($event){_vm.menu1 = false},"change":function($event){return _vm.dateChange(_vm.date)}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"color":"blue","small":""},on:{"click":function($event){return _vm.novo()}}},[_vm._v("\n            Nova Agenda\n          ")])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.agendas,"sort-by":'Nome',"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.data",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.formatDate(new Date(item.data).toISOString().substr(0, 10))))])]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.cobrar(item)}}},[_vm._v("\n              monetization_on\n            ")]),_vm._v(" "),_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(item)}}},[_vm._v("\n              edit\n            ")]),_vm._v(" "),_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v("\n              delete\n            ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"70%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Agenda")])]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.noop($event)}}},[_c('v-row',{attrs:{"justify":"space-around","align":"center"}},[_c('v-col',{attrs:{"sm":"6"}},[_c('v-select',{attrs:{"items":_vm.devedores,"label":"Devedor","item-value":"_id","item-text":"Nome"},model:{value:(_vm.model.iddevedor),callback:function ($$v) {_vm.$set(_vm.model, "iddevedor", $$v)},expression:"model.iddevedor"}})],1)],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"space-around","align":"center"}},[_c('v-col',{attrs:{"sm":"6"}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Date","persistent-hint":"","prepend-icon":"event"},on:{"blur":function($event){_vm.date2 = _vm.parseDate(_vm.dateFormatted2);}},model:{value:(_vm.dateFormatted2),callback:function ($$v) {_vm.dateFormatted2=$$v},expression:"dateFormatted2"}},on))]}}]),model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","no-title":""},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskHora),expression:"maskHora"}],attrs:{"label":"Hora","single-line":"","placeholder":"08:00","required":""},model:{value:(_vm.model.hora),callback:function ($$v) {_vm.$set(_vm.model, "hora", $$v)},expression:"model.hora"}})],1)],1)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Signin_vue_vue_type_template_id_479da82f_scoped_true___ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Signin_vue_vue_type_script_lang_js___ = __webpack_require__(253);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Signin_vue_vue_type_style_index_0_id_479da82f_scoped_true_lang_css___ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Signin_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Signin_vue_vue_type_template_id_479da82f_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Signin_vue_vue_type_template_id_479da82f_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "479da82f",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Signin_vue_vue_type_template_id_479da82f_scoped_true___ = __webpack_require__(453);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Signin_vue_vue_type_template_id_479da82f_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Signin_vue_vue_type_template_id_479da82f_scoped_true___["b"]; });


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs6":"","offset-xs3":"","sm4":"","offset-sm4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-card-text',[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('h2',{staticClass:"headline mb-0 text-md-center"},[_vm._v("Carona")]),_vm._v(" "),_c('h3',{staticClass:"headline mb-0 text-md-center"},[_vm._v("Entrar")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"E-mail","error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){return _vm.$v.email.$touch()},"blur":function($event){return _vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","type":"password","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){return _vm.$v.password.$touch()},"blur":function($event){return _vm.$v.password.$touch()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"text-transform-none",attrs:{"flat":""},on:{"click":_vm.clear}},[_vm._v("Registrar")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"text-transform-none",attrs:{"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Entrar")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signin_vue_vue_type_style_index_0_id_479da82f_scoped_true_lang_css___ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signin_vue_vue_type_style_index_0_id_479da82f_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signin_vue_vue_type_style_index_0_id_479da82f_scoped_true_lang_css___);
/* unused harmony reexport namespace */


/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Signup_vue_vue_type_template_id_52989c16_scoped_true___ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Signup_vue_vue_type_script_lang_js___ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Signup_vue_vue_type_style_index_0_id_52989c16_scoped_true_lang_css___ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Signup_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Signup_vue_vue_type_template_id_52989c16_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Signup_vue_vue_type_template_id_52989c16_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "52989c16",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Signup_vue_vue_type_template_id_52989c16_scoped_true___ = __webpack_require__(458);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Signup_vue_vue_type_template_id_52989c16_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Signup_vue_vue_type_template_id_52989c16_scoped_true___["b"]; });


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs6":"","offset-xs3":"","sm4":"","offset-sm4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-card-text',[_c('v-form',[_c('h2',{staticClass:"headline mb-0 text-md-center"},[_vm._v("Diário de Obras")]),_vm._v(" "),_c('h3',{staticClass:"headline mb-0 text-md-center"},[_vm._v("Registrar-se")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"E-mail","error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){return _vm.$v.email.$touch()},"blur":function($event){return _vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","type":"password","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){return _vm.$v.password.$touch()},"blur":function($event){return _vm.$v.password.$touch()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"text-transform-none",attrs:{"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Registrar")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signup_vue_vue_type_style_index_0_id_52989c16_scoped_true_lang_css___ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signup_vue_vue_type_style_index_0_id_52989c16_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Signup_vue_vue_type_style_index_0_id_52989c16_scoped_true_lang_css___);
/* unused harmony reexport namespace */


/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Usuarios_vue_vue_type_template_id_5e06171c___ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Usuarios_vue_vue_type_script_lang_js___ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Usuarios_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Usuarios_vue_vue_type_template_id_5e06171c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Usuarios_vue_vue_type_template_id_5e06171c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuarios_vue_vue_type_template_id_5e06171c___ = __webpack_require__(463);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuarios_vue_vue_type_template_id_5e06171c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuarios_vue_vue_type_template_id_5e06171c___["b"]; });


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Usuarios\n          "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","append-icon":"search","label":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"small":"","color":"blue"},on:{"click":function($event){return _vm.novo()}}},[_vm._v("\n            Novo Usuário\n          ")])],1),_vm._v(" "),_c('v-data-table',{staticClass:"compact-form",attrs:{"headers":_vm.headers,"items":_vm.usuarios,"search":_vm.search},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editSenha(item)}}},[_vm._v("\n              lock\n            ")]),_vm._v(" "),_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(item)}}},[_vm._v("\n              edit\n            ")]),_vm._v(" "),_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v("\n              delete\n            ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogSenha),callback:function ($$v) {_vm.dialogSenha=$$v},expression:"dialogSenha"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Alterar Senha")])]),_vm._v(" "),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Nome")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"disabled":""},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Email")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"disabled":""},model:{value:(_vm.model.username),callback:function ($$v) {_vm.$set(_vm.model, "username", $$v)},expression:"model.username"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Senha")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"label":"Senha","type":"password","required":""},model:{value:(_vm.model.senha),callback:function ($$v) {_vm.$set(_vm.model, "senha", $$v)},expression:"model.senha"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){return _vm.clearSenha()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.saveSenha()}}},[_vm._v("Salvar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Usuário")])]),_vm._v(" "),_c('v-card-text',[_c('form',{staticClass:"compact-form",on:{"submit":function($event){$event.preventDefault();return _vm.save()}}},[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Nome")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Email")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.username),callback:function ($$v) {_vm.$set(_vm.model, "username", $$v)},expression:"model.username"}})],1)],1),_vm._v(" "),(!_vm.editando)?_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Senha")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"label":"Senha","type":"password","required":""},model:{value:(_vm.model.senha),callback:function ($$v) {_vm.$set(_vm.model, "senha", $$v)},expression:"model.senha"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Acesso")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-select',{attrs:{"items":_vm.options,"label":"Acesso"},model:{value:(_vm.model.acesso),callback:function ($$v) {_vm.$set(_vm.model, "acesso", $$v)},expression:"model.acesso"}})],1)],1),_vm._v(" "),_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.grand == 'Geral':false),expression:"user?user.grand == 'Geral':false"}]},[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Empresa")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-select',{attrs:{"items":_vm.empresas,"label":"Empresa","item-value":"_id","item-text":"nome"},model:{value:(_vm.model.empresa),callback:function ($$v) {_vm.$set(_vm.model, "empresa", $$v)},expression:"model.empresa"}})],1)],1),_vm._v(" "),_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.acesso == 'Cliente'),expression:"model.acesso == 'Cliente'"}]},[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Cliente")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-select',{attrs:{"items":_vm.clientes,"label":"Cliente","item-value":"_id","item-text":"Nome"},model:{value:(_vm.model.cliente),callback:function ($$v) {_vm.$set(_vm.model, "cliente", $$v)},expression:"model.cliente"}})],1)],1),_vm._v(" "),_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.acesso == 'AdminClientes'),expression:"model.acesso == 'AdminClientes'"}]},[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Cliente")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-select',{attrs:{"items":_vm.clientes,"label":"Cliente","item-value":"_id","item-text":"Nome","multiple":""},model:{value:(_vm.model.userClientes),callback:function ($$v) {_vm.$set(_vm.model, "userClientes", $$v)},expression:"model.userClientes"}})],1)],1),_vm._v(" "),_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.acesso == 'Funcionario'),expression:"model.acesso == 'Funcionario'"}]},[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Meta 1")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-currency-field',{attrs:{"label":"Meta 1","prefix":"R$ "},model:{value:(_vm.model.meta1),callback:function ($$v) {_vm.$set(_vm.model, "meta1", $$v)},expression:"model.meta1"}})],1)],1),_vm._v(" "),_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.acesso == 'Funcionario'),expression:"model.acesso == 'Funcionario'"}]},[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Meta 2")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-currency-field',{attrs:{"label":"Meta 2","prefix":"R$ "},model:{value:(_vm.model.meta2),callback:function ($$v) {_vm.$set(_vm.model, "meta2", $$v)},expression:"model.meta2"}})],1)],1),_vm._v(" "),_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.acesso == 'Funcionario'),expression:"model.acesso == 'Funcionario'"}]},[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Meta 3")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-currency-field',{attrs:{"label":"Meta 3","prefix":"R$ "},model:{value:(_vm.model.meta3),callback:function ($$v) {_vm.$set(_vm.model, "meta3", $$v)},expression:"model.meta3"}})],1)],1)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){return _vm.clear()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Empresas_vue_vue_type_template_id_699d42b8___ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Empresas_vue_vue_type_script_lang_js___ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Empresas_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Empresas_vue_vue_type_template_id_699d42b8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Empresas_vue_vue_type_template_id_699d42b8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Empresas_vue_vue_type_template_id_699d42b8___ = __webpack_require__(466);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Empresas_vue_vue_type_template_id_699d42b8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Empresas_vue_vue_type_template_id_699d42b8___["b"]; });


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Empresas\n          "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","append-icon":"search","label":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"small":"","color":"blue"},on:{"click":function($event){return _vm.novo()}}},[_vm._v("\n            Nova Empresa\n          ")])],1),_vm._v(" "),_c('v-data-table',{staticClass:"compact-form",attrs:{"headers":_vm.headers,"items":_vm.empresas,"search":_vm.search},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(item)}}},[_vm._v("\n              edit\n            ")]),_vm._v(" "),_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v("\n              delete\n            ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Empresa")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",staticClass:"compact-form",on:{"submit":function($event){$event.preventDefault();return _vm.save()}}},[_c('v-tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:0,attrs:{"ripple":""}},[_vm._v("\n            Dados\n          ")]),_vm._v(" "),_c('v-tab',{key:1,attrs:{"ripple":""}},[_vm._v("\n            Banco Brasil\n          ")]),_vm._v(" "),_c('v-tab',{key:1,attrs:{"ripple":""}},[_vm._v("\n            Anexos\n          ")]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab-item',{key:2},[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Nome")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.nome),callback:function ($$v) {_vm.$set(_vm.model, "nome", $$v)},expression:"model.nome"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("CNPJ")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskCNPJ),expression:"maskCNPJ"}],attrs:{"label":"CNPJ","required":""},model:{value:(_vm.model.CnpjCpf),callback:function ($$v) {_vm.$set(_vm.model, "CnpjCpf", $$v)},expression:"model.CnpjCpf"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("CEP")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.cep),callback:function ($$v) {_vm.$set(_vm.model, "cep", $$v)},expression:"model.cep"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("logradouro")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.logradouro),callback:function ($$v) {_vm.$set(_vm.model, "logradouro", $$v)},expression:"model.logradouro"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("bairro")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.bairro),callback:function ($$v) {_vm.$set(_vm.model, "bairro", $$v)},expression:"model.bairro"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("cidade")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.cidade),callback:function ($$v) {_vm.$set(_vm.model, "cidade", $$v)},expression:"model.cidade"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("estadoUF")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.estadoUF),callback:function ($$v) {_vm.$set(_vm.model, "estadoUF", $$v)},expression:"model.estadoUF"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Token Iugu")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"label":"Token Iugu","required":""},model:{value:(_vm.model.TokenIugu),callback:function ($$v) {_vm.$set(_vm.model, "TokenIugu", $$v)},expression:"model.TokenIugu"}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:1},[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("numeroConvenio")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.numeroConvenio),callback:function ($$v) {_vm.$set(_vm.model, "numeroConvenio", $$v)},expression:"model.numeroConvenio"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("numeroCarteira")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.numeroCarteira),callback:function ($$v) {_vm.$set(_vm.model, "numeroCarteira", $$v)},expression:"model.numeroCarteira"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("numeroVariacaoCarteira")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.numeroVariacaoCarteira),callback:function ($$v) {_vm.$set(_vm.model, "numeroVariacaoCarteira", $$v)},expression:"model.numeroVariacaoCarteira"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("agencia")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.agencia),callback:function ($$v) {_vm.$set(_vm.model, "agencia", $$v)},expression:"model.agencia"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("agenciaDigito")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.agenciaDigito),callback:function ($$v) {_vm.$set(_vm.model, "agenciaDigito", $$v)},expression:"model.agenciaDigito"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("conta")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.conta),callback:function ($$v) {_vm.$set(_vm.model, "conta", $$v)},expression:"model.conta"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("contaDigito")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.contaDigito),callback:function ($$v) {_vm.$set(_vm.model, "contaDigito", $$v)},expression:"model.contaDigito"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Web")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.web),callback:function ($$v) {_vm.$set(_vm.model, "web", $$v)},expression:"model.web"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("developer_application_key")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.devappkey),callback:function ($$v) {_vm.$set(_vm.model, "devappkey", $$v)},expression:"model.devappkey"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("client_id")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"label":"client_id","required":""},model:{value:(_vm.model.client_id),callback:function ($$v) {_vm.$set(_vm.model, "client_id", $$v)},expression:"model.client_id"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("client_secret")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"label":"client_secret","required":""},model:{value:(_vm.model.client_secret),callback:function ($$v) {_vm.$set(_vm.model, "client_secret", $$v)},expression:"model.client_secret"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Nosso Numero")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.nosso_numero),callback:function ($$v) {_vm.$set(_vm.model, "nosso_numero", $$v)},expression:"model.nosso_numero"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',{staticClass:"justify-end"},[_vm._v("Nosso Numero Digito")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"9"}},[_c('v-text-field',{attrs:{"required":""},model:{value:(_vm.model.nossoNumeroDigito),callback:function ($$v) {_vm.$set(_vm.model, "nossoNumeroDigito", $$v)},expression:"model.nossoNumeroDigito"}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:3},[_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}]},[_c('v-row',{staticClass:"fill-height",attrs:{"align-content":"center","justify":"center"}},[_c('v-col',{staticClass:"subtitle-1 text-center",attrs:{"cols":"12"}},[_c('input',{ref:"image",attrs:{"type":"file","multiple":true},on:{"change":_vm.onFileChangePdf}})])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersPdfs,"items":_vm.model.images},scopedSlots:_vm._u([{key:"item.descricao",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":item.image,"target":"_blank","download":item.descricao}},[_vm._v(_vm._s(item.descricao))])]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteImage(item)}}},[_vm._v("\n                    delete\n                  ")])]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){return _vm.clear()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BoletosBB_html_vue_type_template_id_3f9086ff___ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoletosBB_vue_vue_type_script_lang_js___ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__BoletosBB_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__BoletosBB_html_vue_type_template_id_3f9086ff___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__BoletosBB_html_vue_type_template_id_3f9086ff___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_BoletosBB_html_vue_type_template_id_3f9086ff___ = __webpack_require__(469);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_BoletosBB_html_vue_type_template_id_3f9086ff___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_BoletosBB_html_vue_type_template_id_3f9086ff___["b"]; });


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Boletos BB\n          "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticClass:"ml-2 mr-2",attrs:{"outlined":"","append-icon":"search","label":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-select',{staticClass:"ml-2 mr-2",attrs:{"items":_vm.items,"label":"Status","item-value":"_id","item-text":"nome"},on:{"change":_vm.buscar},model:{value:(_vm.model.status),callback:function ($$v) {_vm.$set(_vm.model, "status", $$v)},expression:"model.status"}}),_vm._v(" "),_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"return-value":_vm.model.date,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.model, "date", $event)},"update:return-value":function($event){return _vm.$set(_vm.model, "date", $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Escolha o mês","prepend-icon":"event","readonly":""},model:{value:(_vm.model.date),callback:function ($$v) {_vm.$set(_vm.model, "date", $$v)},expression:"model.date"}},on))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","scrollable":""},on:{"change":function($event){_vm.$refs.menu.save(_vm.model.date); _vm.buscar();}},model:{value:(_vm.model.date),callback:function ($$v) {_vm.$set(_vm.model, "date", $$v)},expression:"model.date"}})],1),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("more_vert")])],1)]}}])},[_vm._v(" "),_c('v-list',[_c('v-list-item',[_c('v-list-item-title',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.exportarExcel(_vm.boletos)}}},[_vm._v("Exportar Excel")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.boletos,"search":_vm.search}})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Clientes_html_vue_type_template_id_fe6db9e0___ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Clientes_vue_vue_type_script_lang_js___ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Clientes_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Clientes_html_vue_type_template_id_fe6db9e0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Clientes_html_vue_type_template_id_fe6db9e0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Clientes_html_vue_type_template_id_fe6db9e0___ = __webpack_require__(476);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Clientes_html_vue_type_template_id_fe6db9e0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Clientes_html_vue_type_template_id_fe6db9e0___["b"]; });


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Clientes\n          "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","append-icon":"search","label":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"color":"blue","small":""},on:{"click":function($event){return _vm.novo()}}},[_vm._v("\n            Novo Cliente\n          ")])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.clientes,"search":_vm.search},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(item.Bloqueado),expression:"item.Bloqueado"}],staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.bloquear(item)}}},[_vm._v("\n              lock_open\n            ")]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(!item.Bloqueado),expression:"!item.Bloqueado"}],staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.bloquear(item)}}},[_vm._v("\n              lock\n            ")]),_vm._v(" "),_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(item)}}},[_vm._v("\n              edit\n            ")]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.acesso == 'Admin':false),expression:"user?user.acesso == 'Admin':false"}],attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v("\n              delete\n            ")])]}}])},[_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n            Sua busca \""+_vm._s(_vm.search)+"\" não encontrou resultados.\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"70%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Cliente")])]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.noop($event)}}},[_c('v-tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:0,attrs:{"ripple":""}},[_vm._v("\n              Dados\n            ")]),_vm._v(" "),_c('v-tab',{key:1,attrs:{"ripple":""}},[_vm._v("\n              Pagamentos\n            ")]),_vm._v(" "),_c('v-tab',{key:2,attrs:{"ripple":""}},[_vm._v("\n              Dados Bancários\n            ")]),_vm._v(" "),_c('v-tab',{key:3,attrs:{"ripple":""}},[_vm._v("\n              Tipo de Parcelamento\n            ")]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab-item',{key:1},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Nome","required":""},model:{value:(_vm.model.Nome),callback:function ($$v) {_vm.$set(_vm.model, "Nome", $$v)},expression:"model.Nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskCNPJ),expression:"maskCNPJ"}],staticClass:"mr-2 ml-2",attrs:{"label":"CNPJ","required":""},model:{value:(_vm.model.Cnpj),callback:function ($$v) {_vm.$set(_vm.model, "Cnpj", $$v)},expression:"model.Cnpj"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Endereco","required":""},model:{value:(_vm.model.Endereco),callback:function ($$v) {_vm.$set(_vm.model, "Endereco", $$v)},expression:"model.Endereco"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Email","required":""},model:{value:(_vm.model.Email),callback:function ($$v) {_vm.$set(_vm.model, "Email", $$v)},expression:"model.Email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Responsavel","required":""},model:{value:(_vm.model.Responsavel),callback:function ($$v) {_vm.$set(_vm.model, "Responsavel", $$v)},expression:"model.Responsavel"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Telefone","required":""},model:{value:(_vm.model.Telefone),callback:function ($$v) {_vm.$set(_vm.model, "Telefone", $$v)},expression:"model.Telefone"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-checkbox',{staticClass:"mr-2 ml-2",attrs:{"label":"Ativo","required":""},model:{value:(_vm.model.Ativo),callback:function ($$v) {_vm.$set(_vm.model, "Ativo", $$v)},expression:"model.Ativo"}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:2},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskPercent100),expression:"maskPercent100"}],ref:"ValorRepasse1",staticClass:"mr-2 ml-2",attrs:{"label":"Até 1 ano","prefix":"%"},model:{value:(_vm.model.ValorRepasse1),callback:function ($$v) {_vm.$set(_vm.model, "ValorRepasse1", $$v)},expression:"model.ValorRepasse1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskPercent),expression:"maskPercent"}],ref:"ValorRepasse2",staticClass:"mr-2 ml-2",attrs:{"label":"Entre 1 a 2 anos","prefix":"%"},model:{value:(_vm.model.ValorRepasse2),callback:function ($$v) {_vm.$set(_vm.model, "ValorRepasse2", $$v)},expression:"model.ValorRepasse2"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskPercent),expression:"maskPercent"}],ref:"ValorRepasse3",staticClass:"mr-2 ml-2",attrs:{"label":"Entre 2 a 3 anos","prefix":"%"},model:{value:(_vm.model.ValorRepasse3),callback:function ($$v) {_vm.$set(_vm.model, "ValorRepasse3", $$v)},expression:"model.ValorRepasse3"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskPercent),expression:"maskPercent"}],ref:"ValorRepasse4",staticClass:"mr-2 ml-2",attrs:{"label":"Entre 3 a 4 anos","prefix":"%"},model:{value:(_vm.model.ValorRepasse4),callback:function ($$v) {_vm.$set(_vm.model, "ValorRepasse4", $$v)},expression:"model.ValorRepasse4"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskPercent),expression:"maskPercent"}],ref:"ValorRepasse5",staticClass:"mr-2 ml-2",attrs:{"label":"Entre 4 a 5 anos","prefix":"%"},model:{value:(_vm.model.ValorRepasse5),callback:function ($$v) {_vm.$set(_vm.model, "ValorRepasse5", $$v)},expression:"model.ValorRepasse5"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskPercent),expression:"maskPercent"}],ref:"ValorRepasse6",staticClass:"mr-2 ml-2",attrs:{"label":"A partir de 5 anos","prefix":"%"},model:{value:(_vm.model.ValorRepasse6),callback:function ($$v) {_vm.$set(_vm.model, "ValorRepasse6", $$v)},expression:"model.ValorRepasse6"}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:3},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Banco"},model:{value:(_vm.model.banco),callback:function ($$v) {_vm.$set(_vm.model, "banco", $$v)},expression:"model.banco"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"12"}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.model.tipoconta),callback:function ($$v) {_vm.$set(_vm.model, "tipoconta", $$v)},expression:"model.tipoconta"}},[_c('v-radio',{attrs:{"label":"Conta Corrente","value":"C"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Poupança","value":"P"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Agencia"},model:{value:(_vm.model.agencia),callback:function ($$v) {_vm.$set(_vm.model, "agencia", $$v)},expression:"model.agencia"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Conta"},model:{value:(_vm.model.conta),callback:function ($$v) {_vm.$set(_vm.model, "conta", $$v)},expression:"model.conta"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Pix"},model:{value:(_vm.model.pix),callback:function ($$v) {_vm.$set(_vm.model, "pix", $$v)},expression:"model.pix"}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:3},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskPercent),expression:"maskPercent"}],ref:"PercentualCimaCapital",staticClass:"mr-2 ml-2",attrs:{"label":"Percentual de desconto à vista","prefix":"%"},model:{value:(_vm.model.percentualDescontoAvista),callback:function ($$v) {_vm.$set(_vm.model, "percentualDescontoAvista", $$v)},expression:"model.percentualDescontoAvista"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskPercent),expression:"maskPercent"}],ref:"PercentualAvista",staticClass:"mr-2 ml-2",attrs:{"label":"Percentual minimo para a Entrada","prefix":"%"},model:{value:(_vm.model.percentualAvista),callback:function ($$v) {_vm.$set(_vm.model, "percentualAvista", $$v)},expression:"model.percentualAvista"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.tipoParcelamento,"label":"Tipo de Parcelamento","item-value":"tipopParcela","item-text":"descricao"},model:{value:(_vm.model.parcelaMaxima),callback:function ($$v) {_vm.$set(_vm.model, "parcelaMaxima", $$v)},expression:"model.parcelaMaxima"}})],1)],1)],1)],1)],1)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red","flat":""},nativeOn:{"click":function($event){return _vm.clear()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red","flat":""},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue","flat":""},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogBlock),callback:function ($$v) {_vm.dialogBlock=$$v},expression:"dialogBlock"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(_vm.bloqueando&&!_vm.bloqueando.Bloqueado),expression:"bloqueando&&!bloqueando.Bloqueado"}]},[_vm._v("Tem certeza que deseja bloquear os devedores da Empresa "+_vm._s(_vm.bloqueando?_vm.bloqueando.Nome:'')+"?")]),_vm._v(" "),_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(_vm.bloqueando&&_vm.bloqueando.Bloqueado),expression:"bloqueando&&bloqueando.Bloqueado"}]},[_vm._v("Tem certeza que deseja desbloquear os devedores da Empresa "+_vm._s(_vm.bloqueando?_vm.bloqueando.Nome:'')+"?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red","flat":""},nativeOn:{"click":function($event){_vm.dialogBlock = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue","flat":""},nativeOn:{"click":function($event){return _vm.bloquear(_vm.bloqueando)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Devedores_html_vue_type_template_id_5f777caa___ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Devedores_vue_vue_type_script_lang_js___ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Devedores_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Devedores_html_vue_type_template_id_5f777caa___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Devedores_html_vue_type_template_id_5f777caa___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Devedores_html_vue_type_template_id_5f777caa___ = __webpack_require__(479);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Devedores_html_vue_type_template_id_5f777caa___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Devedores_html_vue_type_template_id_5f777caa___["b"]; });


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Devedores\n          "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","append-icon":"search","label":"Buscar","single-line":"","hide-details":""},on:{"keyup":function($event){_vm.options.page = 1; _vm.getDataFromApi()}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"small":"","color":"blue"},on:{"click":function($event){return _vm.novo()}}},[_vm._v("\n            Novo Devedor\n          ")])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.devedores,"options":_vm.options,"loading":_vm.loading,"server-items-length":_vm.totalDevedores},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(item)}}},[_vm._v("\n              edit\n            ")]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.acesso == 'Admin':false),expression:"user?user.acesso == 'Admin':false"}],attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v("\n              delete\n            ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"70%"},model:{value:(_vm.dialogDevedor),callback:function ($$v) {_vm.dialogDevedor=$$v},expression:"dialogDevedor"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Devedor")])]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.noop($event)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Nome","required":""},model:{value:(_vm.model.Nome),callback:function ($$v) {_vm.$set(_vm.model, "Nome", $$v)},expression:"model.Nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-checkbox',{staticClass:"mr-2 ml-2",attrs:{"label":"Ativo","required":""},model:{value:(_vm.model.Ativo),callback:function ($$v) {_vm.$set(_vm.model, "Ativo", $$v)},expression:"model.Ativo"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"12"}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}},[_c('v-radio',{attrs:{"label":"CPF","value":"cpf"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"CNPJ","value":"cnpj"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[(_vm.tipo == 'cpf')?_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskCPF),expression:"maskCPF"}],attrs:{"label":"CPF Devedor","required":""},model:{value:(_vm.model.CnpjCpf),callback:function ($$v) {_vm.$set(_vm.model, "CnpjCpf", $$v)},expression:"model.CnpjCpf"}}):_vm._e(),_vm._v(" "),(_vm.tipo == 'cnpj')?_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskCNPJ),expression:"maskCNPJ"}],attrs:{"label":"CNPJ Devedor","required":""},model:{value:(_vm.model.CnpjCpf),callback:function ($$v) {_vm.$set(_vm.model, "CnpjCpf", $$v)},expression:"model.CnpjCpf"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Endereco","required":""},model:{value:(_vm.model.Endereco),callback:function ($$v) {_vm.$set(_vm.model, "Endereco", $$v)},expression:"model.Endereco"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-menu',{ref:"menu2",staticClass:"mr-2 ml-2",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"mr-2 ml-2",attrs:{"label":"Nascimento","persistent-hint":"","prepend-icon":"event"},on:{"blur":function($event){_vm.date2 = _vm.parseDate(_vm.dateFormatted2);}},model:{value:(_vm.dateFormatted2),callback:function ($$v) {_vm.dateFormatted2=$$v},expression:"dateFormatted2"}},on))]}}]),model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_vm._v(" "),_c('v-date-picker',{staticClass:"mr-2 ml-2",attrs:{"locale":"pt-br","no-title":""},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Telefone Principal","required":""},model:{value:(_vm.model.TelefonePrincipal),callback:function ($$v) {_vm.$set(_vm.model, "TelefonePrincipal", $$v)},expression:"model.TelefonePrincipal"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Telefone 2","required":""},model:{value:(_vm.model.Telefone2),callback:function ($$v) {_vm.$set(_vm.model, "Telefone2", $$v)},expression:"model.Telefone2"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Telefone 3","required":""},model:{value:(_vm.model.Telefone3),callback:function ($$v) {_vm.$set(_vm.model, "Telefone3", $$v)},expression:"model.Telefone3"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"label":"Email Principal","required":""},model:{value:(_vm.model.EmailPrincipal),callback:function ($$v) {_vm.$set(_vm.model, "EmailPrincipal", $$v)},expression:"model.EmailPrincipal"}})],1)],1)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){return _vm.clear()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dividas_html_vue_type_template_id_d0eeae04___ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dividas_vue_vue_type_script_lang_js___ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Dividas_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Dividas_html_vue_type_template_id_d0eeae04___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Dividas_html_vue_type_template_id_d0eeae04___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Dividas_html_vue_type_template_id_d0eeae04___ = __webpack_require__(482);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Dividas_html_vue_type_template_id_d0eeae04___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Dividas_html_vue_type_template_id_d0eeae04___["b"]; });


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Dividas\n          "),_c('v-spacer'),_vm._v(" "),_c('v-autocomplete',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.acesso != 'Cliente':false),expression:"user?user.acesso != 'Cliente':false"}],staticClass:"mr-2 ml-2",attrs:{"items":_vm.clientes,"chips":"","color":"blue-grey lighten-2","label":"Clientes","item-value":"_id","item-text":"Nome","multiple":""},model:{value:(_vm.filtros.idcliente),callback:function ($$v) {_vm.$set(_vm.filtros, "idcliente", $$v)},expression:"filtros.idcliente"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mr-2 ml-2",attrs:{"outlined":"","append-icon":"search","label":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),(_vm.user?_vm.user.acesso != 'Cliente'&&_vm.user.acesso != 'AdminClientes':false)?_c('v-menu',{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("more_vert")])],1)]}}],null,false,944909975)},[_vm._v(" "),_c('v-list',[_c('v-list-item',[_c('v-list-item-title',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.exportarExcel()}}},[_vm._v("Excel em Tela")])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-title',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.acesso != 'Cliente':false),expression:"user?user.acesso != 'Cliente':false"}],staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.exportarExcelTodas()}}},[_vm._v("\n                  Excel Todas as Dividas\n                ")])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-title',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.acesso != 'Cliente':false),expression:"user?user.acesso != 'Cliente':false"}],staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.dialogImport=true;_vm.parseCsv=[];_vm.importaCliente=null;}}},[_vm._v("\n                  Importar planilhas\n                ")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"small":"","color":"blue"},on:{"click":function($event){return _vm.buscarDividas()}}},[_vm._v("\n            Buscar\n          ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.acesso != 'Cliente':false),expression:"user?user.acesso != 'Cliente':false"}],staticClass:"mr-2 ml-2",attrs:{"small":"","color":"blue"},on:{"click":function($event){return _vm.novo()}}},[_vm._v("\n            Nova Divida\n          ")])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.dividas,"search":_vm.search,"footer-props":{
            'items-per-page-options': [50,100,200, -1]
          },"items-per-page":100},on:{"current-items":_vm.getFiltered},scopedSlots:_vm._u([{key:"item.StatusDivida",fn:function(ref){
          var item = ref.item;
return [_vm._v("\n            "+_vm._s(_vm.getStatusDivida(item))+"\n          ")]}},{key:"item.ValorDivida",fn:function(ref){
          var item = ref.item;
return [_vm._v("\n            "+_vm._s(_vm._f("currency")(item.ValorDivida))+"\n          ")]}},{key:"item.action",fn:function(ref){
          var item = ref.item;
return [_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.acesso != 'Cliente':false),expression:"user?user.acesso != 'Cliente':false"}],staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(item)}}},[_vm._v("\n              edit\n            ")]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.acesso == 'Admin':false),expression:"user?user.acesso == 'Admin':false"}],attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v("\n              delete\n            ")])]}}])},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n            Your search for \""+_vm._s(_vm.search)+"\" found no results.\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"70%"},model:{value:(_vm.dialogNovo),callback:function ($$v) {_vm.dialogNovo=$$v},expression:"dialogNovo"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Divida")])]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.noop($event)}}},[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-select',{attrs:{"items":_vm.clientes,"label":"Cliente","item-value":"_id","item-text":"Nome","required":""},model:{value:(_vm.model.idcliente),callback:function ($$v) {_vm.$set(_vm.model, "idcliente", $$v)},expression:"model.idcliente"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Nome Devedor","required":""},model:{value:(_vm.model.Nome),callback:function ($$v) {_vm.$set(_vm.model, "Nome", $$v)},expression:"model.Nome"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"sm":"12"}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}},[_c('v-radio',{attrs:{"label":"CPF","value":"cpf"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"CNPJ","value":"cnpj"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[(_vm.tipo == 'cpf')?_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskCPF),expression:"maskCPF"}],attrs:{"label":"CPF Devedor","required":""},model:{value:(_vm.model.CnpjCpf),callback:function ($$v) {_vm.$set(_vm.model, "CnpjCpf", $$v)},expression:"model.CnpjCpf"}}):_vm._e(),_vm._v(" "),(_vm.tipo == 'cnpj')?_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskCNPJ),expression:"maskCNPJ"}],attrs:{"label":"CNPJ Devedor","required":""},model:{value:(_vm.model.CnpjCpf),callback:function ($$v) {_vm.$set(_vm.model, "CnpjCpf", $$v)},expression:"model.CnpjCpf"}}):_vm._e()],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskData),expression:"maskData"}],attrs:{"label":"Data de Nascimento","required":""},model:{value:(_vm.model.DataNascimento),callback:function ($$v) {_vm.$set(_vm.model, "DataNascimento", $$v)},expression:"model.DataNascimento"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskCEP),expression:"maskCEP"}],attrs:{"label":"Cep","placeholder":"#####-###","required":""},on:{"blur":function($event){return _vm.freteCep(_vm.model.cep)}},model:{value:(_vm.model.cep),callback:function ($$v) {_vm.$set(_vm.model, "cep", $$v)},expression:"model.cep"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Endereço","required":""},model:{value:(_vm.model.logradouro),callback:function ($$v) {_vm.$set(_vm.model, "logradouro", $$v)},expression:"model.logradouro"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Número","type":"Number","required":""},model:{value:(_vm.model.numero),callback:function ($$v) {_vm.$set(_vm.model, "numero", $$v)},expression:"model.numero"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Bairro","required":""},model:{value:(_vm.model.bairro),callback:function ($$v) {_vm.$set(_vm.model, "bairro", $$v)},expression:"model.bairro"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Cidade","required":""},model:{value:(_vm.model.localidade),callback:function ($$v) {_vm.$set(_vm.model, "localidade", $$v)},expression:"model.localidade"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Estado","required":""},model:{value:(_vm.model.uf),callback:function ($$v) {_vm.$set(_vm.model, "uf", $$v)},expression:"model.uf"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"label":"Telefone 1","placeholder":"(##)####-####","required":""},model:{value:(_vm.model.telefone1),callback:function ($$v) {_vm.$set(_vm.model, "telefone1", $$v)},expression:"model.telefone1"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"label":"Telefone 2","placeholder":"(##)####-####","required":""},model:{value:(_vm.model.telefone2),callback:function ($$v) {_vm.$set(_vm.model, "telefone2", $$v)},expression:"model.telefone2"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],attrs:{"label":"Telefone 3","placeholder":"(##)####-####","required":""},model:{value:(_vm.model.telefone3),callback:function ($$v) {_vm.$set(_vm.model, "telefone3", $$v)},expression:"model.telefone3"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-textarea',{attrs:{"label":"Especificacao","required":""},model:{value:(_vm.model.Especificacao),callback:function ($$v) {_vm.$set(_vm.model, "Especificacao", $$v)},expression:"model.Especificacao"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-select',{attrs:{"items":_vm.tipoProdutos,"label":"Tipo Produto","item-value":"tipoProduto","item-text":"descricao"},model:{value:(_vm.model.TipoProduto),callback:function ($$v) {_vm.$set(_vm.model, "TipoProduto", $$v)},expression:"model.TipoProduto"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Contrato","required":""},model:{value:(_vm.model.contrato),callback:function ($$v) {_vm.$set(_vm.model, "contrato", $$v)},expression:"model.contrato"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Juros","required":""},model:{value:(_vm.model.Juros),callback:function ($$v) {_vm.$set(_vm.model, "Juros", $$v)},expression:"model.Juros"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-select',{attrs:{"items":_vm.tipoJuros,"label":"Tipo Juro","item-value":"tipoJuro","item-text":"descricao"},model:{value:(_vm.model.TipoJuros),callback:function ($$v) {_vm.$set(_vm.model, "TipoJuros", $$v)},expression:"model.TipoJuros"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskData),expression:"maskData"}],attrs:{"label":"Data Divida","required":""},model:{value:(_vm.model.DataDivida),callback:function ($$v) {_vm.$set(_vm.model, "DataDivida", $$v)},expression:"model.DataDivida"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-currency-field',{attrs:{"label":"Valor Divida","prefix":"R$ "},model:{value:(_vm.model.ValorDivida),callback:function ($$v) {_vm.$set(_vm.model, "ValorDivida", $$v)},expression:"model.ValorDivida"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-currency-field',{attrs:{"label":"Valor Empresa","prefix":"R$ "},model:{value:(_vm.model.ValorEmpresa),callback:function ($$v) {_vm.$set(_vm.model, "ValorEmpresa", $$v)},expression:"model.ValorEmpresa"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Email","required":""},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-checkbox',{attrs:{"label":"Ativo","required":""},model:{value:(_vm.model.Ativo),callback:function ($$v) {_vm.$set(_vm.model, "Ativo", $$v)},expression:"model.Ativo"}})],1)],1)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){return _vm.clear()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.importarDividas(_vm.model.idcliente, _vm.model);}}},[_vm._v("Salvar")])],1)],1)],1),_vm._v(" "),(_vm.model.idcliente)?_c('v-dialog',{attrs:{"persistent":"","max-width":"70%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Divida")])]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.noop($event)}}},[_c('v-tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:0,attrs:{"ripple":""}},[_vm._v("\n              Dados\n            ")]),_vm._v(" "),_c('v-tab',{key:1,attrs:{"ripple":""}},[_vm._v("\n              Anexos\n            ")]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab-item',{key:1},[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[(_vm.model.idcliente)?_c('v-text-field',{attrs:{"label":"Cliente","disabled":""},model:{value:(_vm.model.idcliente.Nome),callback:function ($$v) {_vm.$set(_vm.model.idcliente, "Nome", $$v)},expression:"model.idcliente.Nome"}}):_vm._e()],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[(_vm.model.iddevedor)?_c('v-text-field',{attrs:{"label":"Devedor","disabled":""},model:{value:(_vm.model.iddevedor.Nome),callback:function ($$v) {_vm.$set(_vm.model.iddevedor, "Nome", $$v)},expression:"model.iddevedor.Nome"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-textarea',{attrs:{"label":"Especificacao","required":""},model:{value:(_vm.model.Especificacao),callback:function ($$v) {_vm.$set(_vm.model, "Especificacao", $$v)},expression:"model.Especificacao"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-select',{attrs:{"items":_vm.tipoProdutos,"label":"Tipo Produto","item-value":"tipoProduto","item-text":"descricao","required":""},model:{value:(_vm.model.TipoProduto),callback:function ($$v) {_vm.$set(_vm.model, "TipoProduto", $$v)},expression:"model.TipoProduto"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.maskData),expression:"maskData"}],attrs:{"label":"Data Divida","required":""},model:{value:(_vm.model.DataDivida),callback:function ($$v) {_vm.$set(_vm.model, "DataDivida", $$v)},expression:"model.DataDivida"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Juros","required":""},model:{value:(_vm.model.Juros),callback:function ($$v) {_vm.$set(_vm.model, "Juros", $$v)},expression:"model.Juros"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-select',{attrs:{"items":_vm.tipoJuros,"label":"Tipo Juro","item-value":"tipoJuro","item-text":"descricao"},model:{value:(_vm.model.TipoJuro),callback:function ($$v) {_vm.$set(_vm.model, "TipoJuro", $$v)},expression:"model.TipoJuro"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"StatusDivida","required":""},model:{value:(_vm.model.StatusDivida),callback:function ($$v) {_vm.$set(_vm.model, "StatusDivida", $$v)},expression:"model.StatusDivida"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-currency-field',{attrs:{"label":"Valor Divida","prefix":"R$ "},model:{value:(_vm.model.ValorDivida),callback:function ($$v) {_vm.$set(_vm.model, "ValorDivida", $$v)},expression:"model.ValorDivida"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-currency-field',{attrs:{"label":"Valor Empresa","prefix":"R$ "},model:{value:(_vm.model.ValorEmpresa),callback:function ($$v) {_vm.$set(_vm.model, "ValorEmpresa", $$v)},expression:"model.ValorEmpresa"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"label":"Contrato"},model:{value:(_vm.model.Identificador),callback:function ($$v) {_vm.$set(_vm.model, "Identificador", $$v)},expression:"model.Identificador"}})],1)],1),_vm._v(" "),_c('v-row',[(_vm.model.ValorRepasse)?_c('v-col',{attrs:{"cols":"6"}},[_vm._v("\n                  Valor Repasse: "+_vm._s(_vm.model.ValorRepasse)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.model.ValorNegociado)?_c('v-col',{attrs:{"cols":"6"}},[_vm._v("\n                  \n                  Valor Negociado: "+_vm._s(_vm.model.ValorNegociado)+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-checkbox',{attrs:{"label":"Ativo","required":""},model:{value:(_vm.model.Ativo),callback:function ($$v) {_vm.$set(_vm.model, "Ativo", $$v)},expression:"model.Ativo"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}})],1)],1),_vm._v(" "),_c('v-tab-item',{key:2},[_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}]},[_c('v-row',{staticClass:"fill-height",attrs:{"align-content":"center","justify":"center"}},[_c('v-col',{staticClass:"subtitle-1 text-center",attrs:{"cols":"12"}},[_c('input',{ref:"image",attrs:{"type":"file","multiple":true},on:{"change":_vm.onFileChangePdf}})])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersPdfs,"items":_vm.model.images},scopedSlots:_vm._u([{key:"item.descricao",fn:function(ref){
          var item = ref.item;
return [_c('a',{attrs:{"href":item.image,"target":"_blank","download":item.descricao}},[_vm._v(_vm._s(item.descricao))])]}},{key:"item.action",fn:function(ref){
          var item = ref.item;
return [_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Admin'),expression:"user.acesso == 'Admin'"}],attrs:{"small":""},on:{"click":function($event){return _vm.deleteImage(item)}}},[_vm._v("\n                      delete\n                    ")])]}}],null,false,4149919854)})],1)],1)],1)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1"},nativeOn:{"click":function($event){return _vm.clear()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.save()}}},[_vm._v("Salvar")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"100%"},model:{value:(_vm.dialogImport),callback:function ($$v) {_vm.dialogImport=$$v},expression:"dialogImport"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Importação Dividas")]),_vm._v(" "),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('input',{attrs:{"type":"file","name":"csv_file"},on:{"change":function($event){return _vm.importCsv($event)}}})]),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-select',{attrs:{"items":_vm.clientes,"label":"Cliente","item-value":"_id","item-text":"Nome"},model:{value:(_vm.importaCliente),callback:function ($$v) {_vm.importaCliente=$$v},expression:"importaCliente"}})],1)],1),_vm._v(" "),_c('v-data-table',{staticStyle:{"overflow":"auto"},attrs:{"headers":_vm.headersCsv,"items":_vm.parseCsv}},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n            Nenhum registro\n          ")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.importar(_vm.importaCliente, _vm.parseCsv)}}},[_vm._v("Importar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogImport = false}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogError),callback:function ($$v) {_vm.dialogError=$$v},expression:"dialogError"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Observação")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){_vm.dialogError = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"green darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Financeiro_html_vue_type_template_id_718c3a10___ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Financeiro_vue_vue_type_script_lang_js___ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Financeiro_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Financeiro_html_vue_type_template_id_718c3a10___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Financeiro_html_vue_type_template_id_718c3a10___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Financeiro_html_vue_type_template_id_718c3a10___ = __webpack_require__(501);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Financeiro_html_vue_type_template_id_718c3a10___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Financeiro_html_vue_type_template_id_718c3a10___["b"]; });


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("\n      Financeiro\n      "),_c('v-spacer'),_vm._v(" "),_c('v-select',{staticClass:"mr-2 ml-2",attrs:{"items":_vm.statusContratos,"menu-props":{ maxHeight: '200' },"label":"Status","item-value":"id","item-text":"nome","multiple":""},on:{"change":_vm.buscar},model:{value:(_vm.filtros.status),callback:function ($$v) {_vm.$set(_vm.filtros, "status", $$v)},expression:"filtros.status"}}),_vm._v(" "),_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"return-value":_vm.filtros.date,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.filtros, "date", $event)},"update:return-value":function($event){return _vm.$set(_vm.filtros, "date", $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Escolha o mês","prepend-icon":"event","readonly":""},model:{value:(_vm.filtros.date),callback:function ($$v) {_vm.$set(_vm.filtros, "date", $$v)},expression:"filtros.date"}},on))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","scrollable":""},on:{"change":function($event){_vm.$refs.menu.save(_vm.filtros.date); _vm.buscar();}},model:{value:(_vm.filtros.date),callback:function ($$v) {_vm.$set(_vm.filtros, "date", $$v)},expression:"filtros.date"}})],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersAcordo,"items":_vm.acordos,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{class:_vm.getColorAcordo(props.item),on:{"click":function($event){return _vm.abrirAcordo(props.item.acordo)}}},[_c('td',[_vm._v(_vm._s(props.item.acordo.user.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.acordo.cliente.Nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.acordo.devedor.Nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("currency")(props.item.acordo.ValorAcordo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getProposta(props.item.acordo.proposta)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getPagamento(props.item.acordo.tipoPagamento)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getNegociacao(props.item.acordo.tipoNegociacao)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.acordo.detalhes))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getStatusAcordo(props.item.acordo.StatusAcordo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(props.item.acordo.createdAt,"DD/MM/YYYY HH:mm")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.acordo.DataDivida))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("currency")(props.item.acordo.ValorDivida)))])])]}}])})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"700"},model:{value:(_vm.dialogParcela),callback:function ($$v) {_vm.dialogParcela=$$v},expression:"dialogParcela"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Parcelas")]),_vm._v(" "),(_vm.acordo && _vm.acordo.user && _vm.acordo.devedor)?_c('v-card-text',[_c('v-row',[_c('v-col',[_c('h4',[_vm._v("Nome do Operador: "+_vm._s(_vm.acordo.user.name))]),_vm._v(" "),_c('h4',[_vm._v("Cliente: "+_vm._s(_vm.acordo.cliente.Nome))]),_vm._v(" "),_c('h4',[_vm._v("Devedor: "+_vm._s(_vm.acordo.devedor.Nome))]),_vm._v(" "),_c('h4',[_vm._v("Valor do Acordo: "+_vm._s(_vm._f("currency")(_vm.acordo.ValorAcordo)))]),_vm._v(" "),_c('h4',[_vm._v("Tipo Pagamento: "+_vm._s(_vm.getPagamento(_vm.acordo.tipoPagamento)))])]),_vm._v(" "),_c('v-col',[_c('h4',[_vm._v("Dias Atraso")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.getDiasAtraso(_vm.acordo.DataDivida)  + ' dias'))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.getMesesAtraso(_vm.acordo.DataDivida) + ' meses'))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.getAnosAtraso(_vm.acordo.DataDivida) + ' anos'))])])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersParcelas,"items":_vm.acordo.parcelas,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.numero",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.numero+'/'+_vm.acordo.parcelas.length))])]}},{key:"item.vencimento",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.vencimento,"DD/MM/YYYY")))])]}},{key:"item.valor",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(item.valor)))])]}},{key:"item.cliente",fn:function(ref){
var item = ref.item;
return [_c('v-edit-dialog',{attrs:{"return-value":item.cliente},on:{"update:returnValue":function($event){return _vm.$set(item, "cliente", $event)},"update:return-value":function($event){return _vm.$set(item, "cliente", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"Number","label":"Cliente"},model:{value:(item.cliente),callback:function ($$v) {_vm.$set(item, "cliente", $$v)},expression:"item.cliente"}})]},proxy:true}],null,true)},[_vm._v(" "+_vm._s(_vm._f("currency")(item.cliente))+"\n              ")])]}},{key:"item.valorAssoc",fn:function(ref){
var item = ref.item;
return [_c('v-edit-dialog',{attrs:{"return-value":item.valorAssoc},on:{"update:returnValue":function($event){return _vm.$set(item, "valorAssoc", $event)},"update:return-value":function($event){return _vm.$set(item, "valorAssoc", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"Number","label":"Assoc"},model:{value:(item.valorAssoc),callback:function ($$v) {_vm.$set(item, "valorAssoc", $$v)},expression:"item.valorAssoc"}})]},proxy:true}],null,true)},[_vm._v(" "+_vm._s(_vm._f("currency")(item.valorAssoc))+"\n              ")])]}},{key:"item.valorJuros",fn:function(ref){
var item = ref.item;
return [_c('v-edit-dialog',{attrs:{"return-value":item.valorJuros},on:{"update:returnValue":function($event){return _vm.$set(item, "valorJuros", $event)},"update:return-value":function($event){return _vm.$set(item, "valorJuros", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"Number","label":"Juros"},model:{value:(item.valorJuros),callback:function ($$v) {_vm.$set(item, "valorJuros", $$v)},expression:"item.valorJuros"}})]},proxy:true}],null,true)},[_vm._v(" "+_vm._s(_vm._f("currency")(item.valorJuros))+"\n              ")])]}},{key:"item.valorReceita",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("currency")((item.valor-item.cliente-(item.valorAssoc?item.valorAssoc:0)-(item.valorJuros?item.valorJuros:0)))))])]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('span',[(item.stPago == 'N')?_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.acordo.StatusAcordo == 3),expression:"acordo.StatusAcordo == 3"}],attrs:{"small":"","color":"blue darken-1"},on:{"click":function($event){return _vm.pagar(item)}}},[_vm._v(" Pagar \n              ")]):_vm._e(),_vm._v(" "),(item.stPago == 'S')?_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.acordo.StatusAcordo == 3),expression:"acordo.StatusAcordo == 3"}],attrs:{"small":"","color":"red darken-1"},on:{"click":function($event){return _vm.cancelar(item)}}},[_vm._v(" Cancela Pagamento\n              ")]):_vm._e()],1)]}}],null,false,219931483)}),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"md":"4"}},[_vm._v("\n            Valor Total:\n            "),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.acordo.parcelas&&_vm.acordo.parcelas.length>0?_vm.acordo.parcelas.map(function (item) {return item.valor}).reduce(function (prev, next) {return (prev + next)}):0)))])]),_vm._v(" "),_c('v-col',{attrs:{"md":"3"}},[_vm._v("\n            Valor Cliente:\n            "),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.buscaValorCliente(_vm.acordo.parcelas))))])]),_vm._v(" "),_c('v-col',{attrs:{"md":"3"}},[_vm._v("\n            Valor Desconto:\n            "),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.buscaValorDesconto(_vm.acordo.parcelas))))])])],1)],1):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.acordo.StatusAcordo == 3),expression:"acordo.StatusAcordo == 3"}],attrs:{"small":"","color":"red darken-1"},on:{"click":function($event){return _vm.recuseItem(_vm.acordo)}}},[_vm._v("Cancelar Acordo")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.acordo.StatusAcordo == 3),expression:"acordo.StatusAcordo == 3"}],attrs:{"small":"","color":"blue darken-1"},on:{"click":function($event){return _vm.saveAcordo(_vm.acordo)}}},[_vm._v("Salvar")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.acordo.StatusAcordo == 2),expression:"acordo.StatusAcordo == 2"}],attrs:{"small":"","color":"blue darken-1"},on:{"click":function($event){return _vm.confirmItem(_vm.acordo)}}},[_vm._v("Aprovar")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.acordo.StatusAcordo == 2),expression:"acordo.StatusAcordo == 2"}],attrs:{"small":"","color":"red darken-1"},on:{"click":function($event){return _vm.recuseItem(_vm.acordo)}}},[_vm._v("Recusar")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"gray darken-1"},nativeOn:{"click":function($event){_vm.dialogParcela = false}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogPagar),callback:function ($$v) {_vm.dialogPagar=$$v},expression:"dialogPagar"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Tem certeza que deseja pagar essa parcela?\n        "),_c('v-row',[_c('v-col',{attrs:{"sm":"8"}},[_c('v-menu',{ref:"menu2",attrs:{"close-on-content-click":false,"return-value":_vm.model.dtPagamento,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.model, "dtPagamento", $event)},"update:return-value":function($event){return _vm.$set(_vm.model, "dtPagamento", $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Data Pagamento","prepend-icon":"event","readonly":""},model:{value:(_vm.model.dtPagamento),callback:function ($$v) {_vm.$set(_vm.model, "dtPagamento", $$v)},expression:"model.dtPagamento"}},on))]}}]),model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},on:{"change":function($event){return _vm.$refs.menu2.save(_vm.model.dtPagamento);}},model:{value:(_vm.model.dtPagamento),callback:function ($$v) {_vm.$set(_vm.model, "dtPagamento", $$v)},expression:"model.dtPagamento"}})],1),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.model.tipoPagamento),callback:function ($$v) {_vm.$set(_vm.model, "tipoPagamento", $$v)},expression:"model.tipoPagamento"}},[_c('v-radio',{attrs:{"label":"Boleto","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Deposito","value":"2"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Escritório","value":"3"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Na Loja","value":"4"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Pix","value":"5"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogPagar = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.pagarParcela(_vm.model)}}},[_vm._v("Sim")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja cancelar o pagamento dessa parcela?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.pagarParcela(_vm.model)}}},[_vm._v("Sim")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogEmail),callback:function ($$v) {_vm.dialogEmail=$$v},expression:"dialogEmail"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Observação")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogEmail = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.enviarEmail(_vm.model)}}},[_vm._v("Sim")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogError),callback:function ($$v) {_vm.dialogError=$$v},expression:"dialogError"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Observação")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){_vm.dialogError = false}}},[_vm._v("Ok")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Recebimento_html_vue_type_template_id_f92e87c6_scoped_true___ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Recebimento_vue_vue_type_script_lang_js___ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Recebimento_vue_vue_type_style_index_0_id_f92e87c6_scoped_true_lang_css___ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Recebimento_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Recebimento_html_vue_type_template_id_f92e87c6_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Recebimento_html_vue_type_template_id_f92e87c6_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "f92e87c6",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Recebimento_html_vue_type_template_id_f92e87c6_scoped_true___ = __webpack_require__(504);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Recebimento_html_vue_type_template_id_f92e87c6_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Recebimento_html_vue_type_template_id_f92e87c6_scoped_true___["b"]; });


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',{staticStyle:{"padding-bottom":"0px"}},[_vm._v("\n      Recebimento\n      "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"small":"","color":"green"},on:{"click":function($event){return _vm.exportarExcel(_vm.parcelas)}}},[_c('v-icon',[_vm._v("assignment")])],1),_vm._v(" "),_c('v-autocomplete',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Admin'||_vm.user.acesso == 'AdminClientes'),expression:"user.acesso == 'Admin'||user.acesso == 'AdminClientes'"}],staticClass:"mr-2 ml-2",attrs:{"items":_vm.clientes,"chips":"","color":"blue-grey lighten-2","label":"Clientes","item-value":"_id","item-text":"Nome","multiple":""},on:{"change":function($event){return _vm.buscarParcelas(_vm.$route.params.id)}},model:{value:(_vm.filtros.idcliente),callback:function ($$v) {_vm.$set(_vm.filtros, "idcliente", $$v)},expression:"filtros.idcliente"}}),_vm._v(" "),_c('v-autocomplete',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Admin'),expression:"user.acesso == 'Admin'"}],staticClass:"mr-2 ml-2 compact-form",attrs:{"items":_vm.funcionarios,"chips":"","color":"blue-grey lighten-2","label":"Funcionarios","item-value":"_id","item-text":"name","multiple":""},on:{"change":function($event){return _vm.buscarParcelas(_vm.$route.params.id)}},model:{value:(_vm.filtros.idfuncionario),callback:function ($$v) {_vm.$set(_vm.filtros, "idfuncionario", $$v)},expression:"filtros.idfuncionario"}}),_vm._v(" "),_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"return-value":_vm.date,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Escolha o mês","prepend-icon":"event","readonly":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},on))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","scrollable":""},on:{"change":function($event){_vm.$refs.menu.save(_vm.date); _vm.buscarParcelas(_vm.$route.params.id)}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6","sm":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","height":"75"}},[_c('v-list-item',{attrs:{"three-line":"","height":"75"}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"40"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("bar_chart")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                "+_vm._s(_vm._f("currency")(_vm.totalGravados(_vm.parcelas)))+"\n              ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Gravados")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6","sm":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","height":"75"}},[_c('v-list-item',{attrs:{"three-line":"","height":"75"}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"40"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("highlight")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n              "+_vm._s(_vm._f("currency")(_vm.totalVigente(_vm.parcelas)))+"\n            ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Vigente")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso != 'Cliente'),expression:"user.acesso != 'Cliente'"}],attrs:{"cols":"6","sm":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","height":"75","color":"green"}},[_c('v-list-item',{attrs:{"three-line":"","height":"75"}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"40"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("money")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                "+_vm._s(_vm._f("currency")(_vm.buscaRecebido(_vm.parcelas)))+"\n              ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Recebido")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso != 'Funcionario'),expression:"user.acesso != 'Funcionario'"}],attrs:{"cols":"6","sm":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","height":"75","color":"blue"}},[_c('v-list-item',{attrs:{"three-line":"","height":"75"}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"40"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("attach_money")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                "+_vm._s(_vm._f("currency")(_vm.buscaReceita(_vm.parcelas)))+"\n              ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Bruto")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6","sm":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","height":"75"}},[_c('v-list-item',{attrs:{"three-line":"","height":"75"}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"40"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("linear_scale")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                "+_vm._s(_vm.parcelas.length)+"\n              ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Qtde")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6","sm":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","height":"75","color":"red"}},[_c('v-list-item',{attrs:{"three-line":"","height":"75"}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"40"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("money_off")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                "+_vm._s(_vm._f("currency")(_vm.buscaAtraso(_vm.parcelas)))+"\n              ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Atrasos")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6","sm":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","height":"75","color":"grey"}},[_c('v-list-item',{attrs:{"three-line":"","height":"75"}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"40"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                "+_vm._s(_vm._f("currency")(_vm.buscaCancelados(_vm.parcelas)))+"\n              ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Cancelados")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Funcionario' && _vm.user.meta1),expression:"user.acesso == 'Funcionario' && user.meta1"}],attrs:{"cols":"6","sm":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","height":"75","color":_vm.buscaMetaCor(_vm.user, _vm.buscaReceita(_vm.parcelas))}},[_c('v-list-item',{attrs:{"three-line":"","height":"75"}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"40"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("north_east")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                "+_vm._s(_vm.buscaMeta(_vm.user, _vm.buscaReceita(_vm.parcelas)))+"\n              ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Meta")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersParcela,"items":_vm.parcelas,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{class:_vm.getColorParcela(props.item)},[_c('td',[_vm._v(_vm._s(props.item.acordo.devedor.Nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.acordo.devedor.CnpjCpf))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(props.item.vencimento,"DD/MM/YYYY")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(props.item.dtPagamento,"DD/MM/YYYY")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getStatusAcordo(props.item)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.numero+'/'+props.item.acordo.parcelas.length))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso != 'Cliente'),expression:"user.acesso != 'Cliente'"}]},[_vm._v(_vm._s(_vm._f("currency")(props.item.valor)))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso != 'Cliente' && _vm.user.acesso != 'Funcionario'),expression:"user.acesso != 'Cliente' && user.acesso != 'Funcionario'"}]},[_vm._v(_vm._s(_vm._f("currency")(props.item.cliente)))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso != 'Cliente' && _vm.user.acesso != 'Funcionario'),expression:"user.acesso != 'Cliente' && user.acesso != 'Funcionario'"}]},[_vm._v(_vm._s(_vm._f("currency")(props.item.valorAssoc)))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso != 'Cliente' && _vm.user.acesso != 'Funcionario'),expression:"user.acesso != 'Cliente' && user.acesso != 'Funcionario'"}]},[_vm._v(_vm._s(_vm._f("currency")(props.item.valorJuros)))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso != 'Funcionario'),expression:"user.acesso != 'Funcionario'"}]},[_vm._v(_vm._s(_vm._f("currency")(_vm.user.acesso == "Cliente"?props.item.cliente:(props.item.valor-props.item.cliente-(props.item.valorAssoc?props.item.valorAssoc:0)-(props.item.valorJuros?props.item.valorJuros:0)))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getPagamento(props.item.tipoPagamento || props.item.acordo.tipoPagamento)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getNegociacao(props.item.acordo.tipoNegociacao)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.acordo.cliente?props.item.acordo.cliente.Nome:''))]),_vm._v(" "),_c('td',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.listar(props.item)}}},[_vm._v("\n              list\n            ")]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso != 'Cliente'),expression:"user.acesso != 'Cliente'"}],staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.cobrar(props.item)}}},[_vm._v("\n              monetization_on\n            ")])],1)])]}}])}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"700"},model:{value:(_vm.dialogParcela),callback:function ($$v) {_vm.dialogParcela=$$v},expression:"dialogParcela"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Parcelas")]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headersParcelas,"items":_vm.acordo.parcelas,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.numero",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.numero+'/'+_vm.acordo.parcelas.length))])]}},{key:"item.vencimento",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.vencimento,"DD/MM/YYYY")))])]}},{key:"item.valor",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.user.acesso == "Cliente"?item.cliente:item.valor)))])]}},{key:"item.dtPagamento",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.dtPagamento,"DD/MM/YYYY")))])]}}])}),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"md":"6","offset-md":"3"}},[_vm._v("\n              Valor Total:\n              "),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.buscaValorTotalParcela(_vm.acordo))))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"small":"","color":"gray darken-1"},nativeOn:{"click":function($event){_vm.dialogParcela = false}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogError),callback:function ($$v) {_vm.dialogError=$$v},expression:"dialogError"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Observação")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){_vm.dialogError = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Recebimento_vue_vue_type_style_index_0_id_f92e87c6_scoped_true_lang_css___ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Recebimento_vue_vue_type_style_index_0_id_f92e87c6_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Recebimento_vue_vue_type_style_index_0_id_f92e87c6_scoped_true_lang_css___);
/* unused harmony reexport namespace */


/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Relatorio_html_vue_type_template_id_67096966_scoped_true___ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Relatorio_vue_vue_type_script_lang_js___ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Relatorio_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Relatorio_html_vue_type_template_id_67096966_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Relatorio_html_vue_type_template_id_67096966_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "67096966",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Relatorio_html_vue_type_template_id_67096966_scoped_true___ = __webpack_require__(509);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Relatorio_html_vue_type_template_id_67096966_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Relatorio_html_vue_type_template_id_67096966_scoped_true___["b"]; });


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-tabs',{staticStyle:{"margin-top":"30px"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',{key:0,attrs:{"ripple":""}},[_vm._v("\n      Dividas\n    ")]),_vm._v(" "),_c('v-tab',{key:1,attrs:{"ripple":""}},[_vm._v("\n      Acordos\n    ")]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab-item',{key:1},[_c('Dividas')],1),_vm._v(" "),_c('v-tab-item',{key:2},[_c('Acordos')],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Acordos_vue_vue_type_template_id_4d843577___ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Acordos_vue_vue_type_script_lang_js___ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Acordos_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Acordos_vue_vue_type_template_id_4d843577___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Acordos_vue_vue_type_template_id_4d843577___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_template_id_4d843577___ = __webpack_require__(512);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_template_id_4d843577___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Acordos_vue_vue_type_template_id_4d843577___["b"]; });


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Dividas\n          "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-autocomplete',{directives:[{name:"show",rawName:"v-show",value:(_vm.user?_vm.user.acesso != 'Cliente':false),expression:"user?user.acesso != 'Cliente':false"}],staticClass:"mr-2 ml-2",attrs:{"items":_vm.clientes,"chips":"","color":"blue-grey lighten-2","label":"Clientes","item-value":"_id","item-text":"Nome","multiple":""},model:{value:(_vm.filtros.idcliente),callback:function ($$v) {_vm.$set(_vm.filtros, "idcliente", $$v)},expression:"filtros.idcliente"}})],1),_vm._v(" "),_c('v-col',[_c('v-autocomplete',{staticClass:"mr-2 ml-2 compact-form",attrs:{"items":_vm.funcionarios,"chips":"","color":"blue-grey lighten-2","label":"Funcionarios","item-value":"_id","item-text":"name","multiple":""},model:{value:(_vm.filtros.idfuncionario),callback:function ($$v) {_vm.$set(_vm.filtros, "idfuncionario", $$v)},expression:"filtros.idfuncionario"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"return-value":_vm.date,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Escolha o mês","prepend-icon":"event","readonly":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},on))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","scrollable":""},on:{"change":function($event){return _vm.$refs.menu.save(_vm.date);}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"small":"","color":"green"},on:{"click":function($event){return _vm.exportarExcel(_vm.filtros)}}},[_c('v-icon',[_vm._v("assignment")]),_vm._v("\n                Gerar Excel\n              ")],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Dividas_vue_vue_type_template_id_52620f02___ = __webpack_require__(514);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Dividas_vue_vue_type_template_id_52620f02___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Dividas_vue_vue_type_template_id_52620f02___["b"]; });


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Relatório de Dividas\n          "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-menu',{ref:"menu1",staticClass:"mr-2 ml-2",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"mr-2 ml-2",attrs:{"label":"Data Criação Inicial","persistent-hint":"","prepend-icon":"event"},on:{"blur":function($event){_vm.date1 = _vm.parseDate(_vm.dateFormatted1)}},model:{value:(_vm.dateFormatted1),callback:function ($$v) {_vm.dateFormatted1=$$v},expression:"dateFormatted1"}},on))]}}]),model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_vm._v(" "),_c('v-date-picker',{staticClass:"mr-2 ml-2",attrs:{"locale":"pt-br","no-title":""},on:{"input":function($event){_vm.menu1 = false}},model:{value:(_vm.date1),callback:function ($$v) {_vm.date1=$$v},expression:"date1"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-menu',{ref:"menu2",staticClass:"mr-2 ml-2",attrs:{"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"mr-2 ml-2",attrs:{"label":"Data Criação Final","persistent-hint":"","prepend-icon":"event"},on:{"blur":function($event){_vm.date2 = _vm.parseDate(_vm.dateFormatted2)}},model:{value:(_vm.dateFormatted2),callback:function ($$v) {_vm.dateFormatted2=$$v},expression:"dateFormatted2"}},on))]}}]),model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_vm._v(" "),_c('v-date-picker',{staticClass:"mr-2 ml-2",attrs:{"locale":"pt-br","no-title":""},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1)],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-autocomplete',{directives:[{name:"show",rawName:"v-show",value:(_vm.user ? _vm.user.acesso != 'Cliente' : false),expression:"user ? user.acesso != 'Cliente' : false"}],staticClass:"mr-2 ml-2",attrs:{"items":_vm.clientes,"chips":"","color":"blue-grey lighten-2","label":"Clientes","item-value":"_id","item-text":"Nome","multiple":""},model:{value:(_vm.filtros.idcliente),callback:function ($$v) {_vm.$set(_vm.filtros, "idcliente", $$v)},expression:"filtros.idcliente"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-btn',{staticClass:"mr-2 ml-2",attrs:{"small":"","color":"green"},on:{"click":function($event){return _vm.exportarExcel(_vm.filtros)}}},[_c('v-icon',[_vm._v("assignment")]),_vm._v("\n                Gerar Excel\n              ")],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Painel_html_vue_type_template_id_c07a79c6___ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Painel_vue_vue_type_script_lang_js___ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Painel_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Painel_html_vue_type_template_id_c07a79c6___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Painel_html_vue_type_template_id_c07a79c6___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Painel_html_vue_type_template_id_c07a79c6___ = __webpack_require__(517);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Painel_html_vue_type_template_id_c07a79c6___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Painel_html_vue_type_template_id_c07a79c6___["b"]; });


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',{staticStyle:{"padding-bottom":"0px"}},[_vm._v("\n      Painel\n      "),_c('v-spacer')],1),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Cliente' || _vm.user.acesso == 'AdminClientes'),expression:"user.acesso == 'Cliente' || user.acesso == 'AdminClientes'"}]},[_c('v-card-title',[_vm._v("\n        Acompanhamento de Desempenho\n      ")]),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","color":"blue"}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"80"}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("monetization_on")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                  "+_vm._s(_vm._f("currency")(_vm.mesPassado?_vm.mesPassado.toFixed(2):0))+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Mês Passado")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","color":"blue","shaped":""}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"80"}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("monetization_on")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                  "+_vm._s(_vm._f("currency")(_vm.mesAtual?_vm.mesAtual.toFixed(2):0))+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Mês Atual")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","color":"green","shaped":""}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"80"}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("monetization_on")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                  "+_vm._s(_vm._f("currency")(_vm.valorTotalRecebido?_vm.valorTotalRecebido.toFixed(2):0))+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Até Hoje")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Admin'),expression:"user.acesso == 'Admin'"}]},[_c('v-card-title',{staticStyle:{"padding-bottom":"0px"}},[_vm._v("\n        Acompanhamento Funcionarios\n      ")]),_vm._v(" "),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"5"}},[_c('v-autocomplete',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.acesso == 'Admin'),expression:"user.acesso == 'Admin'"}],staticClass:"mr-2 ml-2 compact-form",attrs:{"items":_vm.funcionarios,"chips":"","color":"blue-grey lighten-2","label":"Funcionarios","item-value":"_id","item-text":"name","multiple":""},on:{"change":function($event){return _vm.buscarOcorrencias()}},model:{value:(_vm.filtros.idfuncionario),callback:function ($$v) {_vm.$set(_vm.filtros, "idfuncionario", $$v)},expression:"filtros.idfuncionario"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"5"}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"return-value":_vm.date,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Escolha o dia","prepend-icon":"event","readonly":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},on))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"type":"date","no-title":"","scrollable":""},on:{"change":function($event){_vm.$refs.menu.save(_vm.date); _vm.buscarOcorrencias()}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":"","color":"blue"}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"80"}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("settings_phone")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                    "+_vm._s(_vm.ocorrencias?_vm.ocorrencias.length:0)+"\n                  ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Quantidade de Ocorrecias")])],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","color":"green","shaped":""}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"80"}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("calendar_today")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v("\n                    "+_vm._s(_vm.agendas?_vm.agendas.length:0)+"\n                  ")]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v("Quantidade de Agendas")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-row',{staticClass:"mt-2"},[_c('v-col',{attrs:{"cols":"4"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":""}},[_c('QuantidadeParcela')],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-card',{attrs:{"elevation":"10","outlined":"","shaped":""}},[_c('ValoresParcela')],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogError),callback:function ($$v) {_vm.dialogError=$$v},expression:"dialogError"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Observação")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){_vm.dialogError = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_acordo__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__["a" /* Bar */],
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var parcelas;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__services_acordo__["a" /* default */].getGraph();

            case 2:
              parcelas = _context.sent;


              // Overwriting base render method with actual data.
              _this.renderChart({
                labels: parcelas.map(function (item) {
                  return item._id;
                }), //['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                datasets: [{
                  label: 'Quantidade de Parcela',
                  backgroundColor: '#092dbd',
                  data: parcelas.map(function (item) {
                    return item.count;
                  }) //[40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
                }]
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_acordo__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2_vue_chartjs__["a" /* Bar */],
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var parcelas;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__services_acordo__["a" /* default */].getGraph();

            case 2:
              parcelas = _context.sent;


              // Overwriting base render method with actual data.
              _this.renderChart({
                labels: parcelas.map(function (item) {
                  return item._id;
                }), //['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                datasets: [{
                  label: 'Valor de Acordos',
                  backgroundColor: '#092dbd',
                  data: parcelas.map(function (item) {
                    return item.valor;
                  }) //[40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
                }]
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fechamento_html_vue_type_template_id_1be793d2___ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fechamento_vue_vue_type_script_lang_js___ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Fechamento_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Fechamento_html_vue_type_template_id_1be793d2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Fechamento_html_vue_type_template_id_1be793d2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Fechamento_html_vue_type_template_id_1be793d2___ = __webpack_require__(525);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Fechamento_html_vue_type_template_id_1be793d2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_Fechamento_html_vue_type_template_id_1be793d2___["b"]; });


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("\n        Fechamento de Mês\n      ")]),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.user != null?_vm.user.acesso == 'Admin':false),expression:"user != null?user.acesso == 'Admin':false"}]},[_c('v-card-title',[_vm._v("\n        Clientes\n        "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","append-icon":"search","label":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"return-value":_vm.date,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Escolha o mês","prepend-icon":"event","readonly":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},on))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","scrollable":""},on:{"change":function($event){_vm.$refs.menu.save(_vm.date); _vm.buscar()}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.clientes,"search":_vm.search},scopedSlots:_vm._u([{key:"item.valorCliente",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(item.valorCliente?item.valorCliente: 0)))])]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.confirmEmail(item)}}},[_vm._v("\n            email\n          ")])]}}])},[_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n          Sua busca \""+_vm._s(_vm.search)+"\" não encontrou resultados.\n        ")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogError),callback:function ($$v) {_vm.dialogError=$$v},expression:"dialogError"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Observação")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){_vm.dialogError = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmationEmail),callback:function ($$v) {_vm.dialogConfirmationEmail=$$v},expression:"dialogConfirmationEmail"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja enviar o email de fechamento do Cliente?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogConfirmationEmail = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.enviarEmail(_vm.model)}}},[_vm._v("Sim")])],1)],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chat_vue_vue_type_template_id_6598aa0d___ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Chat_vue_vue_type_script_lang_js___ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Chat_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Chat_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Chat_vue_vue_type_template_id_6598aa0d___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Chat_vue_vue_type_template_id_6598aa0d___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_template_id_6598aa0d___ = __webpack_require__(528);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_template_id_6598aa0d___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_template_id_6598aa0d___["b"]; });


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"fill-height",staticStyle:{"padding-bottom":"60px"},attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-3 pl-3",attrs:{"md10":"","offset-md1":""}},[_c('div',{staticClass:"mt-4 mb-4",staticStyle:{"max-width":"80%"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"1"}},[_c('v-list-item-avatar',[_c('img',{attrs:{"src":_vm.userOther.name?'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name='+_vm.userOther.name.replace(' ', '+')+'':''}})])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"11"}},[_c('h2',{staticStyle:{"margin-bottom":"8px","margin-top":"8px"}},[_vm._v(_vm._s(_vm.userOther.name))])])],1)],1)]),_vm._v(" "),_c('v-flex',{ref:"chatContainer",staticClass:"pr-3 pl-3 forum",staticStyle:{"overflow":"auto"},attrs:{"md10":"","offset-md1":""}},_vm._l((_vm.CHATS),function(chat,i){return _c('div',{key:i,staticClass:"mt-4 mb-4 ",staticStyle:{"max-width":"80%"}},[_c('app-chat-item',{attrs:{"chat":chat}})],1)}),0),_vm._v(" "),_c('v-bottom-navigation',{attrs:{"value":true,"absolute":"","color":"blue"}},[_c('v-layout',[_c('app-chat-box')],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChatItem_vue_vue_type_template_id_20d24792___ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatItem_vue_vue_type_script_lang_js___ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ChatItem_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ChatItem_vue_vue_type_template_id_20d24792___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ChatItem_vue_vue_type_template_id_20d24792___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatItem_vue_vue_type_template_id_20d24792___ = __webpack_require__(531);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatItem_vue_vue_type_template_id_20d24792___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatItem_vue_vue_type_template_id_20d24792___["b"]; });


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticStyle:{"padding":"0px !important"},attrs:{"cols":"10"}},[_c('p',{staticClass:"grey--text text--darken-2",staticStyle:{"margin-bottom":"0px !important"}},[(_vm.isMyHandle(_vm.chat.handle._id))?_c('b',{staticClass:"indigo--text"},[_vm._v(_vm._s(_vm.chat.handle.name)+" :")]):_c('b',{staticClass:"pink--text"},[_vm._v(_vm._s(_vm.chat.handle.name)+" :")]),_vm._v("\n      "+_vm._s(_vm.chat.message)+"\n    ")])]),_vm._v(" "),_c('v-col',{staticStyle:{"padding":"0px !important"},attrs:{"cols":"2"}},[_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm._f("moment")(_vm.chat.createdAt,"DD-MM-YYYY HH:mm")))])])],1)}
var staticRenderFns = []



/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChatBox_vue_vue_type_template_id_3d96e946___ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChatBox_vue_vue_type_script_lang_js___ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ChatBox_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ChatBox_vue_vue_type_template_id_3d96e946___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ChatBox_vue_vue_type_template_id_3d96e946___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatBox_vue_vue_type_template_id_3d96e946___ = __webpack_require__(534);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatBox_vue_vue_type_template_id_3d96e946___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ChatBox_vue_vue_type_template_id_3d96e946___["b"]; });


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"pt-1",attrs:{"md10":"","offset-md1":""}},[_c('v-form',{staticStyle:{"width":"100%"},on:{"submit":function($event){$event.preventDefault();return _vm.sendMessage($event)}}},[_c('v-text-field',{ref:"message",attrs:{"label":"Solo","placeholder":"Escreva sua mensagem","solo":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(4);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  salvarNotificacao: function salvarNotificacao(model) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return instance.post("/message/notificacao/save", model).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return response.data;

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Chat_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */


/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__minhas_dividas_html_vue_type_template_id_c59b8808_scoped_true___ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__minhas_dividas_vue_vue_type_script_lang_js___ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__minhas_dividas_vue_vue_type_style_index_0_id_c59b8808_scoped_true_lang_css___ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(3);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__minhas_dividas_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__minhas_dividas_html_vue_type_template_id_c59b8808_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__minhas_dividas_html_vue_type_template_id_c59b8808_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "c59b8808",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_minhas_dividas_html_vue_type_template_id_c59b8808_scoped_true___ = __webpack_require__(540);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_minhas_dividas_html_vue_type_template_id_c59b8808_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_minhas_dividas_html_vue_type_template_id_c59b8808_scoped_true___["b"]; });


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('br'),_vm._v(" "),_c('h1',{staticClass:"title-div"},[_c('span',[_vm._v("Olá, "+_vm._s(_vm.user.name))])]),_vm._v(" "),_c('v-container',{staticClass:"mt-12"},[_c('h3',{staticClass:"title2-div"},[_c('span',[_vm._v("Selecione a dívida que você deseja negociar")])]),_vm._v(" "),_c('v-row',{staticClass:"mb-6",attrs:{"justify":"center","no-gutters":""}},_vm._l((_vm.devedor.dividas),function(divida,i){return (_vm.devedor && _vm.devedor.dividas)?_c('v-col',{key:i,staticStyle:{"text-align":"center"},attrs:{"sm":"8"}},[(!divida.acordo)?_c('v-card',[_c('v-card-text',[_vm._v("\n            Divida Quitada\n          ")])],1):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"my-4 card-divida"},[_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"sm":"3"}},[_c('h2',[_c('span',{staticStyle:{"font-weight":"400"}},[_vm._v(_vm._s(divida.acordo&&divida.acordo.idcliente?divida.acordo.idcliente.Nome:''))])])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h2',[_c('span',{staticStyle:{"font-weight":"400"}},[_vm._v(_vm._s(_vm.getTipoProduto(divida.acordo.TipoProduto)))])]),_vm._v(" "),_c('h3',[_vm._v("Data: "),_c('span',{staticStyle:{"font-weight":"400"}},[_vm._v(_vm._s(divida.acordo.DataDivida))])]),_vm._v(" "),_c('h4',[_vm._v("Atraso: "+_vm._s(_vm.getDiasAtraso(divida.acordo.DataDivida)  + ' dias'))])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[_c('h3',[_vm._v("Valor Atual")]),_vm._v(" "),_c('h2',{staticStyle:{"font-weight":"400"}},[_vm._v(_vm._s(_vm._f("currency")(divida.acordo.ValorJurosTotal)))])]),_vm._v(" "),_c('v-col',{attrs:{"sm":"3"}},[(divida.acordo.StatusDivida == 1)?_c('v-btn',{attrs:{"color":"green darken-1"},nativeOn:{"click":function($event){return _vm.salvar(false, divida.acordo)}}},[_vm._v("Negociar com Desconto")]):_vm._e(),_vm._v(" "),(divida.acordo.StatusDivida == 2)?_c('v-btn',{attrs:{"color":"blue darken-1"}},[_vm._v("Aguardando Aprovação")]):_vm._e(),_vm._v(" "),(divida.acordo.StatusDivida == 3)?_c('v-btn',{attrs:{"color":"blue darken-1"},on:{"click":function($event){return _vm.abrirAcordo(_vm.devedor.acordos, divida)}}},[_vm._v("Boletos")]):_vm._e()],1)],1)],1)],1)],1):_vm._e()}),1),_vm._v(" "),_c('v-row',{staticStyle:{"height":"60px"}},[_c('v-flex',{attrs:{"xs10":"","sm4":""}},[_c('span',{attrs:{"nowrap":""}},[_vm._v("© 2021 AbCobrança")])])],1)],1),_vm._v(" "),(_vm.acordo)?_c('v-dialog',{attrs:{"persistent":"","max-width":"1000"},model:{value:(_vm.dialogParcela),callback:function ($$v) {_vm.dialogParcela=$$v},expression:"dialogParcela"}},[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v("\n          Como você quer pagar?\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v("\n          Data de Vencimento\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3"}},[_vm._v("\n          Revisando as parcelas\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4"}},[_vm._v("\n          Seu acordo está aguardando aprovação\n        ")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-12 text-xd-center text-md-center align-center",attrs:{"align-content":"center","height":"300px"}},[_c('v-card-text',[_c('h2',[_vm._v("Escolha se deseja pagar à vista ou parcelado.")]),_c('br'),_vm._v(" "),_c('v-row',[_c('v-col',{staticClass:"flex-center",attrs:{"cols":"12"}},[_c('v-radio-group',{attrs:{"row":""},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.acordo.tipoProposta),callback:function ($$v) {_vm.$set(_vm.acordo, "tipoProposta", $$v)},expression:"acordo.tipoProposta"}},[_c('v-radio',{attrs:{"label":"A vista","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Parcelado","value":"2"}})],1)],1)],1),_vm._v(" "),(_vm.acordo.tipoProposta == '1')?_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v("Valor à vista")]),_vm._v(" "),_c('h2',{staticStyle:{"font-weight":"400"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.acordo.ValorAvista)))])])],1):_vm._e(),_vm._v(" "),(_vm.acordo.tipoProposta == '2')?_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v("Valor parcelado")]),_vm._v(" "),_c('h2',{staticStyle:{"font-weight":"400"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.acordo.ValorAcordo)))])])],1):_vm._e(),_vm._v(" "),(_vm.acordo.tipoProposta == '2')?_c('v-row',{staticStyle:{"margin-top":"30px"}},[_c('br'),_vm._v(" "),_c('v-col',{staticClass:"flex-center",attrs:{"sm":"12"}},[_c('h3',[_vm._v("Valor Entrada")]),_vm._v(" "),_c('v-currency-field',{attrs:{"label":"Entrada","prefix":"R$ "},model:{value:(_vm.acordo.ValorEntrada),callback:function ($$v) {_vm.$set(_vm.acordo, "ValorEntrada", $$v)},expression:"acordo.ValorEntrada"}})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.validarTipoPagamento()}}},[_vm._v("\n            Continuar\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.dialogParcela = false}}},[_vm._v("\n            Cancelar\n          ")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-12 text-xd-center text-md-center align-center",attrs:{"align-content":"center","height":"200px"}},[_c('v-card-text',[(_vm.acordo.tipoProposta == '2')?_c('v-row',[_c('v-col',{staticClass:"flex-center",attrs:{"sm":"12"}},[_c('v-select',{attrs:{"items":_vm.tipoParcelamento,"label":"Tipo de Parcelamento","item-value":"tipopParcela","item-text":"descricao"},model:{value:(_vm.acordo.nrParcela),callback:function ($$v) {_vm.$set(_vm.acordo, "nrParcela", $$v)},expression:"acordo.nrParcela"}})],1)],1):_vm._e(),_vm._v(" "),_c('h2',[_vm._v("Qual a melhor data de vencimento?")]),_c('br'),_vm._v(" "),_c('v-row',[_c('v-col',{staticClass:"flex-center",attrs:{"sm":"12"}},[_c('v-select',{attrs:{"items":_vm.dataVencimentos,"label":"Data de Vencimento","item-value":"diaVencimento","item-text":"descricao"},model:{value:(_vm.acordo.diaVencimento),callback:function ($$v) {_vm.$set(_vm.acordo, "diaVencimento", $$v)},expression:"acordo.diaVencimento"}})],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.calcularParcelas()}}},[_vm._v("\n            Continuar\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.e1 = 1}}},[_vm._v("\n            Voltar\n          ")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-12 text-xd-center text-md-center align-center",attrs:{"align-content":"center"}},[_c('h2',[_vm._v("Resumo do Acordo")]),_c('br'),_vm._v(" "),_c('h4',[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v("Origem da Dívida: ")]),_vm._v(_vm._s(_vm.acordo&&_vm.acordo.idcliente?_vm.acordo.idcliente.Nome:''))]),_vm._v(" "),_c('h4',[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v("Valor do Acordo: ")]),_vm._v(_vm._s(_vm._f("currency")(_vm.acordo.ValorAcordo)))]),_vm._v(" "),_c('h4',[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v("Forma de Pagamento: ")]),_vm._v(_vm._s(_vm.acordo.tipoProposta==1?'À vista':'Parcelado')+_vm._s(_vm.acordo.tipoProposta==2?' em '+_vm.acordo.nrParcela+'x':''))]),_vm._v(" "),_c('h4',[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v("Método de Pagamento: ")]),_vm._v("Boleto")]),_vm._v(" "),_c('h4',[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v("Vencimento: ")]),_vm._v("Todo dia "+_vm._s(_vm.acordo.diaVencimento))]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headersParcelas,"items":_vm.acordo.parcelas},scopedSlots:_vm._u([{key:"item.vencimento",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.vencimento,"DD/MM/YYYY")))])]}},{key:"item.valor",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(item.valor)))])]}}],null,false,3766799058)})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.salvar(true, _vm.acordo)}}},[_vm._v("\n            Fechar Acordo\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.e1 = 2}}},[_vm._v("\n            Voltar\n          ")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',{staticClass:"mb-12",attrs:{"color":"grey lighten-1","height":"200px"}}),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.dialogParcela = false}}},[_vm._v("\n            Fechar\n          ")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialogBoletos),callback:function ($$v) {_vm.dialogBoletos=$$v},expression:"dialogBoletos"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Parcelas")]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headersParcelasBoleto,"items":_vm.acordoBoleto.parcelas,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.numero",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.numero+'/'+_vm.acordoBoleto.parcelas.length))])]}},{key:"item.vencimento",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.vencimento,"DD/MM/YYYY")))])]}},{key:"item.valor",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("currency")(item.valor)))])]}},{key:"item.boleto",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"small":"","disabled":_vm.desabilitarPagamento(_vm.acordoBoleto, item)},on:{"click":function($event){return _vm.gerarBoleto(item)}}},[_vm._v(_vm._s(item.juno||item.secure_url?'Imprimir':'Gerar'))])]}},{key:"item.stPago",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.getStPago(item)))])]}},{key:"item.dtPagamento",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(item.dtPagamento,"DD/MM/YYYY")))])]}}])}),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"md":"6","offset-md":"3"}},[_vm._v("\n            Valor Total:\n            "),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.acordoBoleto.parcelas&&_vm.acordoBoleto.parcelas.length>0?_vm.acordoBoleto.parcelas.map(function (item) {return item.valor}).reduce(function (prev, next) {return (prev + next)}):0)))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"red darken-1"},nativeOn:{"click":function($event){_vm.dialogBoletos = false}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_minhas_dividas_vue_vue_type_style_index_0_id_c59b8808_scoped_true_lang_css___ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_minhas_dividas_vue_vue_type_style_index_0_id_c59b8808_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_6_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_minhas_dividas_vue_vue_type_style_index_0_id_c59b8808_scoped_true_lang_css___);
/* unused harmony reexport namespace */


/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[296]);


// WEBPACK FOOTER //
// static/js/app.00dd1eccb878889c0e91.js